import React from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,
	CFooter,
	CRow,CCol,
	CContainer,
	CForm,CFormInput,CFormTextarea,CFormCheck,CFormSelect,CInputGroup,CInputGroupText,
	CButton,CFormLabel,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
	CBadge,
	CNav,CNavItem,CNavLink,CTabContent,CTabPane,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import {
	MyButton,
	MyHeaderProfile,
	MyDialogform,
	MyDialoglookup,
	MyDialogview,
	MySessionextender,
	MyCardodontogram,
	MyDialoglookupapi,
	MyDialogformsubjective,
	MyDialogformobjective,
	MyDialognomorgigi,
} from '../../components/index'
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'
import useSatusehat from '../../helpers/useSatusehat'

const pjson 	= require('../../../package.json')
const Periksa = (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props;
	const { tabel_id } 				= useParams(); 
	const { loadTokensatusehat } 	= useSatusehat(props);

	//--DOM--/
	const uNavigate 				= useNavigate();
	const uDispatch 				= useDispatch();
	//--END DOM--/

	const uPasienID 				= parseInt(tabel_id || "0")
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uUsersettingObj 			= useSelector(state => state.gListUserSetting);
	const uSystemsettingObj			= useSelector(state => state.gSystemsetting);
	//const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uEfekview2,setEfekview2] = React.useState(false);
	const uMaxData					= isMobile ? (uUsersettingObj.jml_mobile || 10) : (uUsersettingObj.jml_laporan || 100);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uISAdmininit				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 

	const [uActivetab,setActivetab] = React.useState("iddataperiksa");
	const uDatahookperiksaObj 		= useSelector(state => state.gBillingperiksaObj) || {};
	const uOdontograminputArr		= useSelector(state => state.gOdontograminputArr) || [];
	const [uDatamainObj,setDatamainObj]= React.useState(uDatahookperiksaObj);
	const uItemsArr					= uDatamainObj.items_arr || [];
	const uJanjianArr				= uDatamainObj.janjian_arr || [];
	const uPerawatArr				= uDatamainObj.perawat_arr || [];

	const [uTambahitemObj,setTambahitemObj]	= React.useState({})
	const [uTabelitemObj,setTabelitemObj]	= React.useState({})
	const [uTambahresepObj,setTambahresepObj]	= React.useState({})
	const [uEditresepObj,setEditresepObj]	= React.useState({})
	const [uUpdatefield,setUpdatefield] 	= React.useState(false);
	const [uISReloadodontogram,setReloadodontogram] 	= React.useState(false);

	const uDatacabangArr					= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const [uDatapasienObj,setDatapasienObj]	= React.useState({})
	const [uDatadokterArr,setDatadokterArr]	= React.useState([])
	const [uDataperawatArr,setDataperawatArr]	= React.useState([])
	const [uDatacatdokterArr,setDatacatdokterArr]= React.useState([])
	const [uDatadiagnosaArr,setDatadiagnosaArr]= React.useState([])
	const [uDataterapiArr,setDataterapiArr] = React.useState([])
	const [uDatajanjianArr,setDatajanjianArr]= React.useState([])
	const [uDataitemcicilanArr,setDataitemcicilanArr]= React.useState([])
	const [uHeaderloading,setHeaderloading]	= React.useState(false)
	const [uIsFormupdate,setIsFormupdate]	= React.useState(false)
	const uCabanginitObj 					= useSelector(state => state.gCabangatribut) || {};

	const uTokensatusehatObj			= JSON.parse(localStorage.getItem("tokensatusehat") || "{}");
	const [uCekantrianshow,setCekantrianshow] = React.useState(false);
	const [uCekantrianObj,setCekantrianObj] = React.useState({});
	const uCekDataantrianArr				= uCekantrianObj.antrian_arr || [];

	//---DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]	= React.useState(false)
	const [uDlglookupObj,setDlglookupObj]		= React.useState({});
	//---END DLG_LOOKUP--/

	//---DLG_LOOKUP_API--/
	const [uISDlglookupapishow,setDlglookupapishow]	= React.useState(false)
	const [uDlglookupapiObj,setDlglookupapiObj]	= React.useState({})
	//---END DLG_LOOKUP_API--/

	//---DLG_VIEW--/
	const [uIsDlgviewshow,setDlgviewshow]		= React.useState(false)
	const [uDlgviewheader,setDlgviewheader]		= React.useState("")
	const [uDlgviewjenis,setDlgviewjenis]		= React.useState("")
	//---END DLG_VIEW--/

	//--DLG_FORM--/
	//const [uDlgformheader,setDlgformheader]		= React.useState("")
	const [uIsDlgformshow,setDlgformshow]		= React.useState(false)
	const [uDlgformdataObj,setDlgformdataObj]	= React.useState({})
	//--END DLG_FORM--/

	//--DLG_FORMSUBJECTIVE--/
	const uDatasubjectiveObj 			= useSelector(state => state.gDatasubjective) || {};
	const uISDlgformsubjectivesimpan 	= useSelector(state => state.gISSubjectivesimpan) || false;
	const [uISDlgformsubjectiveshow,setDlgformsubjectiveshow]	= React.useState(false)
	//--END DLG_FORMSUBJECTIVE--/

	//--DLG_FORMOBJECTIVE--/
	const uDataobjectiveObj 			= useSelector(state => state.gDataobjective) || {};
	const uISDlgformobjectivesimpan 	= useSelector(state => state.gISObjectivesimpan) || false;
	const [uISDlgformobjectiveshow,setDlgformobjectiveshow]	= React.useState(false)
	//--END DLG_FORMOBJECTIVE--/

	//--DLG_PiLIHGIGI--/
	const [uISDlgnomorgigishow,setDlgnomorgigishow]	= React.useState(false);
	const [uDlgnomorgigiObj	,setDlgnomorgigiObj]	= React.useState({});
	//--END DLG_PiLIHGIGI--/

	//--DOM--/
	const uJmlcarddataheader		= uISAdmininit ? 5 : 4;
	const uScreenwidth				= window.outerWidth;
	const uScreenheight				= window.innerHeight;
	const uISCellphonemode			= uScreenwidth <= 425;
	const uISTabletmode				= uScreenwidth > 425 && uScreenwidth <= 768;

	const uHeaderheight				= document.getElementById("idheadermain") && (
		document.getElementById("idheadermain").offsetHeight
	);
	const uFooterheight				= document.getElementById("idfootermain") && (
		document.getElementById("idfootermain").offsetHeight
	);

	const uStylesection	= {
		minHeight: uISTabletmode ? (uScreenheight-uHeaderheight-uFooterheight-25) : "auto",
	}
	const contentRef 	= React.useRef(null);

	//--END DOM--*/

	//---HANDEL--/
	const hdlKDownDocument = (_EV) => {
		if(_EV.keyCode === 27) {
			if(uCekantrianshow) {
				_EV.preventDefault();
				_EV.stopPropagation();

				setCekantrianshow(false);
			}
			return;
		}
		if(_EV.keyCode === 120) {
			const vElsimpan = document.getElementById("btnSimpanmain");
			vElsimpan && (vElsimpan.click())
			return;
		}
	}
	const hdlKlikBack = () => {
		uNavigate("/subpasien/pasien/rekammedis/"+uPasienID,{replace:true}); return;
	}
	const hdlKlikReset = async() => {
		const vResetawal = () => {
			setTambahitemObj({}); setTabelitemObj({});
			setTambahresepObj({}); setEditresepObj({});
			apiLoadawal()
			setReloadodontogram(true);
		}

		if(uIsFormupdate) {
			if(await(Konfirm(
				"<b>Billing Periksa Akan DIRESET..</b>"+
				"<br/>Form Billing Kemungkinan Sudah ADA Perubahan Field Data. "+
					"Anda Belum Menyimpannya, dan dapat membatalkan Perubahan Tersebut !"+
				"<br/><br/>Apakah Anda Yakin ?"+
				""))) initResetmain();
		} else {
			vResetawal();
		}
	}
	const hdlToggleDlgLookup = () => { setDlglookupshow(false)}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		if(uDlglookupObj.dlg_jenis==="DOKTER")
			lookupPilihdokter(_IDITEM);
		else if(uDlglookupObj.dlg_jenis==="DOKTERJANJIAN")
			lookupPilihdokterjanjian(_IDITEM);
		else if(uDlglookupObj.dlg_jenis==="CATDOKTER")
			lookupPilihcatdokter(_IDITEM);
		else if(uDlglookupObj.dlg_jenis==="TERAPI")
			lookupPilihterapi(_IDITEM)
		else if(uDlglookupObj.dlg_jenis==="DIAGNOSAMAIN")
			lookupPilihdiagnosamain(_IDITEM);
		else if(uDlglookupObj.dlg_jenis==="DIAGNOSASEKUNDER")
			lookupPilihdiagnosasekunder(_IDITEM);
		else if(uDlglookupObj.dlg_jenis==="DIAGNOSAFORM")
			lookupPilihFormdiagnosa(_IDITEM);
		else if(uDlglookupObj.dlg_jenis==="FORMTERAPI")//--MOBILE
			lookupFormterapi(_IDITEM);

		hdlToggleDlgLookup();
	}
	const hdlKlikPilihLookupapi = (_SELECTEDSTR) => {
		_SELECTEDSTR = _SELECTEDSTR||"{}";
		//if(_SELECTEDSTR==="" || _SELECTEDSTR === "{}") return;
		//console.log("(Periksa - hdlKlikPilihLookupapi) 1 _SELECTEDSTR",_SELECTEDSTR);
		if(_SELECTEDSTR === "{}") return;

		const vLookupObj	= JSON.parse(_SELECTEDSTR);

		let vElfocus;
		if(uDlglookupapiObj.dlg_jenis === "TINDAKAN") {
			const vIdxedit = uDlglookupapiObj.dlg_idxtabel;

			if(vIdxedit < 0) {
				vElfocus	= document.getElementById("inptambahitemtindakanteks");
				setTambahitemObj({
					...uTambahitemObj,
					tindakan_caption: vLookupObj.caption,
					tindakan_id: vLookupObj.id || 0,
				})
			} else {
				vElfocus	= document.getElementById("inptabelitemtindakanteks"+vIdxedit);
				setTabelitemObj({
					...uTabelitemObj,
					tindakan_caption: vLookupObj.caption,
					tindakan_id: vLookupObj.id || 0,
				})
			}
		}
		else if(uDlglookupapiObj.dlg_jenis === "FORMTINDAKAN") {
			vElfocus	= document.getElementById("inpformitemtindakanteks");
			setDlgformdataObj({
				...uDlgformdataObj,
				tindakan_caption: vLookupObj.caption,
				tindakan_id: vLookupObj.id || 0,
			});
		}
		else if(uDlglookupapiObj.dlg_jenis === "FORMOBAT") {
			if((parseInt(vLookupObj.id)||0) === 0) {
				setDlglookupapishow(false);

				let vTimeout = setTimeout(function(){
					clearTimeout(vTimeout);
					initKlikResepformlookupkfa();
				},150);
				return;
			}

			vElfocus	= document.getElementById("inpreseptambahqty");
			setTambahresepObj({
				...vLookupObj,
				nama_item: vLookupObj.caption,
				qty: 1,
				caption: undefined,
			});
		}
		else if(uDlglookupapiObj.dlg_jenis === "FORMKFA") {
			vElfocus	= document.getElementById("inpreseptambahqty");
			setTambahresepObj({
				...vLookupObj,
				nama_item: vLookupObj.caption,
				qty: 1,
				caption: undefined,
			});
		}
		else if(uDlglookupapiObj.dlg_jenis === "DLGFORMOBAT") {
			if((parseInt(vLookupObj.id)||0) === 0) {
				setDlglookupapishow(false);

				let vTimeout = setTimeout(function(){
					clearTimeout(vTimeout);
					initKlikResepmobilelookupkfa();
				},150);
				return;
			}

			vElfocus	= document.getElementById("inpformresepqty");
			setDlgformdataObj({
				...uDlgformdataObj,
				...vLookupObj,
				nama_item: vLookupObj.caption,
				caption: undefined,
			});
		}
		else if(uDlglookupapiObj.dlg_jenis === "DLGFORMKFA") {
			vElfocus	= document.getElementById("inpformresepqty");
			setDlgformdataObj({
				...uDlgformdataObj,
				...vLookupObj,
				nama_item: vLookupObj.caption,
				caption: undefined,
			});
		}

		//console.log("(Periksa - hdlKlikPilihLookupapi) 2 vLookupObj",vLookupObj);
		setDlglookupapishow(false);

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout);
			vElfocus && vElfocus.focus();
		},350);
	}
	const hdlToggleDlgform = () => { setDlgformshow(false); }
	const hdlKlikDlgformsimpan = () => {
		if(uDlgformdataObj.jenis === "PILIHTANGGAL") {
			initKlikformtanggal(); return;
		}
		if(uDlgformdataObj.jenis === "JANJIAN") {
			initKlikformjanjian(); return;
		}
		if(uDlgformdataObj.jenis === "FORMTERAPI") {
			initKlikformitem(); return;
		}
		if(uDlgformdataObj.jenis === "PILIHPERAWAT") {
			initKlikformperawat(); return;
		}
		if(uDlgformdataObj.jenis === "FORMRESEP") {
			initKlikformresep(); return;
		}
		/*if(uDlgformdataObj.jenis === "FORMSUBJECTIVE") {
			initKlikformsubjective(); return;
		}//-*/
	}
	const hdlToggleDlgview = () => { setDlgviewshow(false)}

	const hdlKlikPilihtanggal = () => {
		setDlgformdataObj({
			jenis: "PILIHTANGGAL",
			dlg_header: "Tanggal Periksa",
			dlg_center: true,
			tgl_periksa: uDatamainObj.tgl_periksa,
		});

		setDlgformshow(true);
	}
	const hdlKlikDokterlookup = () => {
		uDlglookupObj.dlg_input = ("");
		uDlglookupObj.dlg_jenis = ("DOKTER");

		const vTmpArr	= uDatadokterArr.map(vItems => {
			return {id:vItems.id,caption:vItems.dokter_caption}});
		uDlglookupObj.data_arr = (vTmpArr);
		uDlglookupObj.dlg_header = ("Pilih: NAMA DOKTER");
		setDlglookupshow(true);
	}
	const hdlKlikSubjective = () => {
		const uRiwayatpasienObj	= JSON.parse(uDatapasienObj.riwayat_penyakit_str || "{}");
		const uRiwayatalergiObj	= JSON.parse(uDatapasienObj.riwayat_alergi_str || "{}");

		const uSubjectiveObj	= uDatamainObj.subjective_obj || {};

		//--DATA_SUBJECTIVE--/
		const vDlgsubjectiveObj = {
			anamnase_caption: uSubjectiveObj.anamnase_caption,
			anamnase_id: uSubjectiveObj.anamnase_id,
			keluhan_tambahan: uSubjectiveObj.keluhan_tambahan,
			penyakit_sekarang: uSubjectiveObj.penyakit_sekarang ? uSubjectiveObj.penyakit_sekarang : uRiwayatpasienObj.penyakit_sekarang,
			penyakit_dahulu: uSubjectiveObj.penyakit_dahulu ? uSubjectiveObj.penyakit_dahulu : uRiwayatpasienObj.penyakit_dahulu,
			penyakit_keluarga: uSubjectiveObj.penyakit_dahulu ? uSubjectiveObj.penyakit_dahulu : uRiwayatpasienObj.penyakit_keluarga,
			alergi_obat_status: uSubjectiveObj.alergi_obat_status ? uSubjectiveObj.alergi_obat_status : uRiwayatalergiObj.alergi_obat_status,
			alergi_obat_teks: uSubjectiveObj.alergi_obat_teks ? uSubjectiveObj.alergi_obat_teks : uRiwayatalergiObj.alergi_obat_teks,
			alergi_obat_sctcode: uSubjectiveObj.alergi_obat_sctcode ? uSubjectiveObj.alergi_obat_sctcode : uRiwayatalergiObj.alergi_obat_sctcode,
			alergi_makanan_status: uSubjectiveObj.alergi_makanan_status ? uSubjectiveObj.alergi_makanan_status : uRiwayatalergiObj.alergi_makanan_status,
			alergi_makanan_teks: uSubjectiveObj.alergi_makanan_teks ? uSubjectiveObj.alergi_makanan_teks : uRiwayatalergiObj.alergi_makanan_teks,
			alergi_makanan_sctcode: uSubjectiveObj.alergi_makanan_sctcode ? uSubjectiveObj.alergi_makanan_sctcode : uRiwayatalergiObj.alergi_makanan_sctcode,
		};
		//--END DATA_SUBJECTIVE--/

		uDispatch({type: "set", gDatasubjective: vDlgsubjectiveObj});
		setDlgformsubjectiveshow(true);
	}
	const hdlKlikObjective = () => {
		let vScreeningObj 	= uDatamainObj.screening_obj || {};
		vScreeningObj	= {
			...vScreeningObj,
			tekanandarahatas: vScreeningObj.tekanandarahatas || 120,
			tekanandarahbawah: vScreeningObj.tekanandarahbawah || 80,
			suhu: vScreeningObj.suhu || 36,
			denyutnadi: vScreeningObj.denyutnadi || 75,
			nyeri_skala: vScreeningObj.nyeri_skala || 0,
		}
		uDispatch({type: "set", gDataobjective: vScreeningObj});
		setDlgformobjectiveshow(true);
	}
	const hdlKlikPerawattambah = () => {
		/*//--LAMA--/
		setDlgviewjenis("PERAWAT");
		setDlgviewheader("Pilih NAMA PERAWAT");
		setDlgviewshow(true);
		//--END LAMA--*/

		uDlgformdataObj.jenis 			= "PILIHPERAWAT";
		uDlgformdataObj.dlg_header 		= "Pilih NAMA PERAWAT";
		uDlgformdataObj.dlg_center		= false;
		uDlgformdataObj.perawatid_arr 	= uPerawatArr.map(vItems=>vItems.id);
		setDlgformshow(true);
	}
	const hdlChangePerawatcheck = (e) => {
		const vValueID	= parseInt(e.target.value)||0;

		const vArridx = UFunc.getObjectIndeks(uPerawatArr,vValueID);
		//console.log("(Periksa - hdlChangePerawatcheck) vArridx => "+vArridx)
		if(vArridx < 0) {
			const vTmpArr = (uDataperawatArr.filter(vItems=>
				(vItems.id||"0").toString() === vValueID.toString()));

			//console.log("(Periksa - hdlChangePerawatcheck) vArridx => "+JSON.stringify(vTmpArr))
			//uDatamainObj.perawat_arr = [...uPerawatArr,vTmpArr[0]];
			setDatamainObj({...uDatamainObj,
				perawat_arr: [...uPerawatArr,vTmpArr[0]],
			})
		} else {
			uPerawatArr.splice(vArridx,1);
			setDatamainObj({...uDatamainObj,
				perawat_arr: uPerawatArr,
			})
			//uDatamainObj.perawat_arr = uPerawatArr;
		}
		//setUpdatefield(!uUpdatefield);
	}
	const hdlKlikPerawatclear = async() => {
		if(uPerawatArr.length <= 0) return;

		if(await(Konfirm("Apakah Yakin Akan Menghapus SELURUH Perawat ?"))) {
			/*uDatamainObj.perawat_arr = [];
			setUpdatefield(!uUpdatefield);//-*/

			setDatamainObj({...uDatamainObj,
				perawat_arr: [],
			})
		}
 	}
	const hdlKlikCatdokterlookup = () => {
		const vTmpArr	= uDatacatdokterArr.map(vItems => {
			return {id:vItems.id,caption:vItems.note_caption}});

		setDlglookupObj({
			dlg_jenis: "CATDOKTER",
			dlg_input: "",
			dlg_header: "Pilih: CATATAN DOKTER",
			data_arr: vTmpArr,
		});
		setDlglookupshow(true);
	}
	const hdlKlikDokterjanjianlookup = () => {
		const vTmpArr	= uDatadokterArr.map(vItems => {
			return {id:vItems.id,caption:vItems.dokter_caption}});
		
		setDlglookupObj({
			dlg_jenis: "DOKTERJANJIAN",
			dlg_input: "",
			dlg_header: "Pilih: NAMA DOKTER",
			data_arr: vTmpArr,
		});
		setDlglookupshow(true);
	}
	const hdlKlikDiagnosalookup = (_JENISDIAGNOSA) => {
		_JENISDIAGNOSA	= (_JENISDIAGNOSA || "").toUpperCase();

		const vTmpArr	= uDatadiagnosaArr.map(vItems => {
			return {id:vItems.id,caption:vItems.nama_diagnosa}});

		setDlglookupObj({
			dlg_jenis: _JENISDIAGNOSA,
			dlg_input: "",
			dlg_header: "Lookup: DIAGNOSA UTAMA",
			data_arr: vTmpArr,
		});

		setDlglookupshow(true);
	}
	const hdlKDownTerapicaption = (_EV) => {
		setTambahitemObj({
			...uTambahitemObj,
			id: undefined,
			terapi_tarif: undefined,
			status_garansi: undefined,
			terapi_main: undefined,
			terapi_qty: 0,
		})
		if(_EV.keyCode !== 13) return;
		const vTerapicaption	= (uTambahitemObj.terapi_caption||"").trim();
		if(vTerapicaption === "") return;

		_EV.preventDefault()
		_EV.stopPropagation();

		const vArrCariMaster 	= uDataterapiArr.filter((vItem)=>
			vItem.terapi_caption.toUpperCase().includes((vTerapicaption).toUpperCase()));
		
		if (vArrCariMaster.length === 1) {
			setTambahitemObj({
				...uTambahitemObj,
				id: parseInt(vArrCariMaster[0].id)||0,
				terapi_caption: (vArrCariMaster[0].terapi_caption || ""),
				terapi_tarif: parseFloat(vArrCariMaster[0].terapi_tarif || 0),
				terapi_main: (vArrCariMaster[0].terapi_main),
				status_garansi: vArrCariMaster[0].status_garansi,
				terapi_qty: 1,
			});

			const vElfocus = document.getElementById("inptambahitemqty");
			vElfocus && vElfocus.focus();
			return;
		}

		hdlKlikTerapilookup();
	}
	const hdlKlikTerapilookup = () => {
		//--CEK_IDDOKTER--/
		const vDokteridx = UFunc.getObjectIndeks(uDatadokterArr,uDatamainObj.id_dokter);
		//if((parseInt(uDatamainObj.id_dokter)||0) < 0) {
		if(vDokteridx < 0) {
			document.getElementById("inpdoktercaption") &&
				document.getElementById("inpdoktercaption").focus();
			document.getElementById("btndokterpilih") &&
				document.getElementById("btndokterpilih").focus();

			//setActivetab("iddataperiksa");
			showToast("Nama Dokter Harus Dipilih Terlebih Dahulu !"); return;
		}
		const vArrkompetensiID = (uDatadokterArr[vDokteridx]||{}).kompetensi_arr || [];
		//--END CEK_IDDOKTER--/

		const vTmpArr	= uDataterapiArr.filter(vItems =>{
			return (parseInt(vItems.id_kompetensi||0) <= 0 ||
				vArrkompetensiID.includes(vItems.id_kompetensi.toString())
			);
		}).map(vItems => {
			return {
				id:vItems.id,
				caption:vItems.terapi_caption,// +" ("+vItems.id_kompetensi+")",
				harga_satuan:vItems.terapi_tarif
			}
		});
		//console.log("(Periksa - hdlKlikTerapilookup) vTmpArr => "+JSON.stringify(vTmpArr));

		setDlglookupObj({
			dlg_jenis: "TERAPI",
			dlg_input: uTambahitemObj.terapi_caption || "",
			dlg_header: "Lookup: TERAPI",
			data_arr: vTmpArr,
		});
		setDlglookupshow(true);
	}
	const hdlKDownTindakanlookup = (_EV,_IDXITEM) => {
		_IDXITEM = _IDXITEM===undefined ? -1 : parseInt(_IDXITEM);

		if(_EV.keyCode !== 13) {
			if(_IDXITEM < 0) 
				setTambahitemObj({...uTambahitemObj,
					tindakan_id: undefined
				})
			else setTabelitemObj({...uTabelitemObj,
					tindakan_id: undefined
				});

			return;
		}
		
		const vTerapicaption	= _IDXITEM < 0 
			? (uTambahitemObj.tindakan_caption||"").trim()
			: (uTabelitemObj.tindakan_caption||"").trim();

		_EV.preventDefault()
		_EV.stopPropagation();

		if(vTerapicaption === "") {
			if(_IDXITEM < 0) 
				setTambahitemObj({...uTambahitemObj,
					tindakan_id: undefined
				})
			else setTabelitemObj({...uTambahitemObj,
					tindakan_id: undefined
				});

			document.getElementById("inptambahitemtindakanteks") &&
				document.getElementById("inptambahitemtindakanteks").focus();
			return;
		}

		setDlglookupapiObj({
			...uDlglookupapiObj,
			dlg_trigger: true,
		});

		hdlKlikTindakanlookup(_IDXITEM);
	}
	const hdlKlikDiagnosasekunderlookup = (_IDXITEM) => {
		_IDXITEM = _IDXITEM===undefined ? -1 : parseInt(_IDXITEM);
		if(_IDXITEM < 0) { setTabelitemObj({}) }

		const vTmpArr	= uDatadiagnosaArr.map(vItems => {
			return {id:vItems.id,caption:vItems.nama_diagnosa}});

		setDlglookupObj({
			dlg_jenis: "DIAGNOSASEKUNDER",
			dlg_input: "",
			dlg_header: "Lookup: DIAGNOSA SEKUNDER ICD-10",
			dlg_idxtabel: _IDXITEM,
			data_arr: vTmpArr,
		});

		setDlglookupshow(true);
	}
	const hdlKlikTindakanlookup = (_IDXITEM) => {
		_IDXITEM = _IDXITEM===undefined ? -1 : parseInt(_IDXITEM);
		if(_IDXITEM < 0) { setTabelitemObj({}) }

		const vKeywordinput = _IDXITEM < 0 
			? uTambahitemObj.tindakan_caption || "" 
			: uTabelitemObj.tindakan_caption || "";

		setDlglookupapiObj({
			...uDlglookupapiObj,
			dlg_header: "Lookup: TINDAKAN ICD-9 CM",
			dlg_keyword: vKeywordinput,
			dlg_jenis: "TINDAKAN",
			dlg_targetapi: pjson.homepage+"api/api_dataicd9/ld_lookup",
			dlg_idxtabel: _IDXITEM,
		});

		setDlglookupapishow(true);
	}
	const hdlKlikDiagnosasekunderhapus = async(_IDXITEM) => {
		_IDXITEM = _IDXITEM===undefined ? -1 : parseInt(_IDXITEM);
		if(_IDXITEM < 0) { setTabelitemObj({}) }
			
		if(await Konfirm(
			"<p>Diagnosa Sekunder <b>"+uItemsArr[_IDXITEM].diagnosa_caption+ "</b> Akan Dihapus..</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) {
			uItemsArr[_IDXITEM].diagnosa_caption = undefined;
			uItemsArr[_IDXITEM].diagnosa_id = undefined;
			setEfekview(!uEfekview);
		}
	}
	const hdlKlikketgigiview = (_IDXITEM) => {
		const vISFormItem 	= (uDlgformdataObj.jenis === "FORMTERAPI");

		let vNomorgigiArr = [];
		let vIdxedit;
		if(vISFormItem) {
			vNomorgigiArr = uDlgformdataObj.nomorgigi_arr || [];
			vIdxedit = parseInt(uDlgformdataObj.idxtabel ?? "-1");
		} else {
			vIdxedit = parseInt(_IDXITEM ?? "-1");
			if(vIdxedit < 0) { 
				vNomorgigiArr =  uTambahitemObj.nomorgigi_arr||[];
				setTabelitemObj({});
			} else {
				vNomorgigiArr =  uTabelitemObj.nomorgigi_arr||[];
				setTambahitemObj({});
			}
		}
		//console.log("(Periksa - hdlKlikpilihgigi) vIdxedit",vIdxedit);

		setDlgnomorgigiObj({
			nomorgigi_arr: vNomorgigiArr,
			idxkey: vIdxedit,
		});
		setDlgnomorgigishow(true);

		//--LAMA_TIDAK_DIPAKAI--/
		return;
		setDlgviewjenis("KETGIGI");
		setDlgviewheader("Pilih NOMOR GIGI");
		setDlgviewshow(true);
		//--END LAMA_TIDAK_DIPAKAI--/
	}
	const hdlKlikpilihgigi = (_IDGIGI) => {
		_IDGIGI = (_IDGIGI||"").trim();
		const vArridx 		= parseInt(uDlgnomorgigiObj.idxkey ?? "-1");
		const vISFormItem 	= (uDlgformdataObj.jenis === "FORMTERAPI");

		let vKetgigilabel	= "";
		let vNomorgigiArr	= uDlgnomorgigiObj.nomorgigi_arr||[];
		const vArrgigiall 	= (Array.from({ length: 75 }, (_, i) => i + 11)).
			filter(vItems=>
				(vItems >= 11 && vItems <= 18) ||
				(vItems >= 21 && vItems <= 28) ||
				(vItems >= 31 && vItems <= 38) ||
				(vItems >= 41 && vItems <= 48) ||
				(vItems >= 51 && vItems <= 55) ||
				(vItems >= 61 && vItems <= 65) ||
				(vItems >= 71 && vItems <= 75) ||
				(vItems >= 81 && vItems <= 85)
			).map(vItems=>(vItems||"").toString());

		const vArrMaxilla 	= (Array.from({ length: 75 }, (_, i) => i + 11)).
			filter(vItems=>
				(vItems >= 11 && vItems <= 18) ||
				(vItems >= 21 && vItems <= 28) ||
				(vItems >= 51 && vItems <= 55) ||
				(vItems >= 61 && vItems <= 65)
			).map(vItems=>(vItems||"").toString());

		const vArrMandibula 	= (Array.from({ length: 75 }, (_, i) => i + 11)).
			filter(vItems=>
				(vItems >= 31 && vItems <= 38) ||
				(vItems >= 41 && vItems <= 48) ||
				(vItems >= 71 && vItems <= 75) ||
				(vItems >= 81 && vItems <= 85)
			).map(vItems=>(vItems||"").toString());

		if(_IDGIGI === "_ALL_") {
			if(vNomorgigiArr.length === vArrgigiall.length) {
				vKetgigilabel	= "";
				vNomorgigiArr	= [];
			} else {
				vKetgigilabel	= "SEMUA GIGI";
				vNomorgigiArr	= vArrgigiall;
			}
		} else if(_IDGIGI === "_CLEAR_") {
			vKetgigilabel	= "";
			vNomorgigiArr	= [];
		} else if(_IDGIGI === "_MAXILLA_") {
			if (vNomorgigiArr.length !== vArrMaxilla.length) {
				vNomorgigiArr = vArrMaxilla;
				vKetgigilabel	= "REGIO MAXILLA (ATAS)";
			} else {
				const sorted1 = [...vNomorgigiArr].sort(UFunc.customSort);
				const sorted2 = [...vArrMaxilla].sort(UFunc.customSort);

				const vISMaxillachecked = sorted1.every((val, index) => val === sorted2[index]);

				if(vISMaxillachecked) {
					vKetgigilabel	= "";
					vNomorgigiArr	= [];
				} else {
					vNomorgigiArr = vArrMaxilla;
					vKetgigilabel= "REGIO MAXILLA (ATAS)";
				}
			}
		} else if(_IDGIGI === "_MANDIBULA_") {
			if (vNomorgigiArr.length !== vArrMandibula.length) {
				vNomorgigiArr 	= vArrMandibula;
				vKetgigilabel	= "REGIO MANDIBULA (BAWAH)";
			} else {
				const sorted1 = [...vNomorgigiArr].sort(UFunc.customSort);
				const sorted2 = [...vArrMandibula].sort(UFunc.customSort);

				const vISMandibulachecked = sorted1.every((val, index) => val === sorted2[index]);

				if(vISMandibulachecked) {
					vKetgigilabel	= "";
					vNomorgigiArr	= [];
				} else {
					vNomorgigiArr = vArrMandibula;
					vKetgigilabel= "REGIO MANDIBULA (BAWAH)";
				}
			}
		} else if(_IDGIGI === "PARAMOLARKW1"
			|| _IDGIGI === "PARAMOLARKW2"
			|| _IDGIGI === "PARAMOLARKW3"
			|| _IDGIGI === "PARAMOLARKW4"
		) {
			const vNamagigi		= (_IDGIGI || "").toString();
			const vIdxnogigi	= vNomorgigiArr.indexOf(vNamagigi);
			if(vIdxnogigi >= 0) vNomorgigiArr.splice(vIdxnogigi,1);
			else {
				if (vNomorgigiArr.length > 1
				) {
					vNomorgigiArr	= [vNamagigi];
				} else {
					vNomorgigiArr	= [...vNomorgigiArr,vNamagigi];
				}

				vKetgigilabel = vNomorgigiArr.map(vItems=>{
					if(vItems==="PARAMOLARKW1"
						|| vItems==="PARAMOLARKW2"
						|| vItems==="PARAMOLARKW3"
						|| vItems==="PARAMOLARKW4"
						) return "PARAMOLAR";
					if(vItems==="MESIODENATAS"
						|| vItems==="MESIODENBAWAH"
						) return "MESIODEN";

					return "No-"+vItems;
				}).join(", ");
			}
		} else if(_IDGIGI === "MESIODENATAS"
			|| _IDGIGI === "MESIODENBAWAH"
		) {
			const vNamagigi		= (_IDGIGI || "").toString();
			const vIdxnogigi	= vNomorgigiArr.indexOf(vNamagigi);
			if(vIdxnogigi >= 0) vNomorgigiArr.splice(vIdxnogigi,1);
			else {
				if (vNomorgigiArr.length > 7
				) {
					vNomorgigiArr	= [vNamagigi];
				} else {
					vNomorgigiArr	= [...vNomorgigiArr,vNamagigi];
				}

				vKetgigilabel = vNomorgigiArr.map(vItems=>{
					if(vItems==="PARAMOLARKW1"
						|| vItems==="PARAMOLARKW2"
						|| vItems==="PARAMOLARKW3"
						|| vItems==="PARAMOLARKW4"
						) return "PARAMOLAR";
					if(vItems==="MESIODENATAS"
						|| vItems==="MESIODENBAWAH"
						) return "MESIODEN";

					return "No-"+vItems;
				}).join(", ");
			}
		} else {
			const vNomorgigi	= (_IDGIGI || "").toString();
			const vIdxnogigi	= vNomorgigiArr.indexOf(vNomorgigi);
			if(vIdxnogigi >= 0) vNomorgigiArr.splice(vIdxnogigi,1);
			else vNomorgigiArr	= [...vNomorgigiArr,vNomorgigi];

			vKetgigilabel = vNomorgigiArr.map(vItems=>{
				if(vItems==="PARAMOLARKW1"
					|| vItems==="PARAMOLARKW2"
					|| vItems==="PARAMOLARKW3"
					|| vItems==="PARAMOLARKW4"
					) return "PARAMOLAR";
				if(vItems==="MESIODENATAS"
					|| vItems==="MESIODENBAWAH"
					) return "MESIODEN";

				return "No-"+vItems;
			}).join(", ");
		}

		if(vISFormItem) {
			setDlgformdataObj({...uDlgformdataObj,
				nomorgigi_arr:vNomorgigiArr,
				ketgigi: vKetgigilabel,
			});
		} else {
			if(vArridx < 0) {
				setTambahitemObj({...uTambahitemObj,
					nomorgigi_arr:vNomorgigiArr,
					ketgigi: vKetgigilabel
				});
			} else {
				setTabelitemObj({...uTabelitemObj,
					nomorgigi_arr:vNomorgigiArr,
					keterangan: vKetgigilabel
				});
			}
		}

		setDlgnomorgigiObj({...uDlgnomorgigiObj,
			nomorgigi_arr: vNomorgigiArr,
			is_updated: !(uDlgnomorgigiObj.is_updated||false),
		});
	}
	const hdlKlikPilihketgigi = (_EV,_TEKSVALUE) => {//--TIDAK_DIPAKAI--/
		_TEKSVALUE		= (_TEKSVALUE||"").trim();
		const vElcheck	= document.getElementById("iddiagramchecked");
		const vISFormItem = (uDlgformdataObj.jenis === "FORMTERAPI");

		//console.log("(hdlKlikPilihketgigi) uDlgformdataObj.jenis => "+uDlgformdataObj.jenis);
		//console.log("(hdlKlikPilihketgigi) vISFormItem => "+vISFormItem);

		if(vISFormItem) {
			uDlgformdataObj.ketgigi = ((uDlgformdataObj.ketgigi||"").trim() === "" ? ""
				: uDlgformdataObj.ketgigi+", ")+ _TEKSVALUE;
		} else {
			if(JSON.stringify(uTabelitemObj||{})==="{}") {
				uTambahitemObj.ketgigi = (uTambahitemObj.ketgigi||"") +
					((uTambahitemObj.ketgigi||"").trim()!=="" ? ", " : "")+
					_TEKSVALUE; 
			} else {
				uTabelitemObj.keterangan = (uTabelitemObj.keterangan||"") +
					((uTabelitemObj.keterangan||"").trim()!=="" ? ", " : "")+
					_TEKSVALUE; 
			}
		}
		setEfekview(!uEfekview);

		if(vElcheck) {
			vElcheck.style.top 	= (_EV.clientY - _EV.target.offsetTop - 18)+"px";
			vElcheck.style.left = (_EV.clientX - _EV.target.offsetLeft + 7)+"px";
			vElcheck.style.display = "block";
			//alert(_EV.pageX);
		}

		let vTimeout = setTimeout((e) => {
			clearTimeout(vTimeout);
			vElcheck && (vElcheck.style.display = "none");
		},700);//--*/
	}
	const hdlKlikTambahitem = () => {
		const vTerapiID = parseInt(uTambahitemObj.id)||0;
		let vElfocus = document.getElementById("inptambahitemcaption");
		if(vTerapiID <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Nama Terapi Harus Dipilih Terlebih Dahulu !");return;
		}

		vElfocus = document.getElementById("inptambahitemqty");
		if(parseInt(uTambahitemObj.terapi_qty||0) < 1) {
			vElfocus && vElfocus.focus();
			return;
		}
		//--CEK_TINDAKAN_ID--/
		vElfocus = document.getElementById("inptambahitemtindakanlookup");
		if((uTambahitemObj.tindakan_caption||"").trim()!=="")
			if(parseInt(uTambahitemObj.tindakan_id||0) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Tindakan ICD-9 Harus Dipilih Terlebih Dahulu !");return;
			}
		//--END CEK_TINDAKAN_ID--/

		const vTerapimain = uTambahitemObj.terapi_main || "";
		const vTmpObj = {
			id_terapi_sub : vTerapiID,
			caption_terapi : uTambahitemObj.terapi_caption || "",
			tarif_terapi: uTambahitemObj.terapi_tarif || "0",
			qty_terapi: parseInt(uTambahitemObj.terapi_qty ?? "1"),
			diagnosa_id: uDatamainObj.diagnosa_main_id,
			diagnosa_caption: uDatamainObj.diagnosa_main_caption,
			tindakan_id : uTambahitemObj.tindakan_id||0,
			tindakan_caption : (uTambahitemObj.tindakan_caption||"").trim(),
			tindakan_teks : ((uTambahitemObj.tindakan_teks||"").trim()),
			keterangan : (uTambahitemObj.ketgigi||"").trim(),
			status_ada_garansi : (uTambahitemObj.status_garansi||"TIDAK"),
			nomorgigi_arr: uTambahitemObj.nomorgigi_arr||[],
			tgl_batas_garansi : "",
		}

		//uDatamainObj.items_arr = [vTmpObj,...uItemsArr];
		setDatamainObj({...uDatamainObj,
			items_arr: [vTmpObj,...uItemsArr],
		})

		const vTmpresetObj = {
			terapi_caption : vTerapimain
		}
		setTambahitemObj(vTmpresetObj);

		document.getElementById("inptambahitemtindakanteks") &&
			document.getElementById("inptambahitemtindakanteks").focus();
		setUpdatefield(!uUpdatefield);
	}
	const hdlKlikTabelsimpan = (_IDXITEM) => {
		_IDXITEM = _IDXITEM===undefined ? -1 : parseInt(_IDXITEM);
		if(_IDXITEM < 0) return;
		initResettambahform();

		//--VALIDASI--/
		let vElfocus = document.getElementById("inptabelitemqty");
		if(parseInt(uTabelitemObj.qty_terapi||0) < 1) {
			document.getElementById("inptabelitemqty") &&
				document.getElementById("inptabelitemqty").focus();
			return;
		}
		//--CEK_DIAGNOSAID--/
		vElfocus = document.getElementById("inptabelitemdiagnosasekunder");
		if((uTabelitemObj.diagnosa_caption||"").trim()!=="")
			if(parseInt(uTabelitemObj.diagnosa_id||0) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Diagnosa Sekunder ICD-10 Harus Dipilih Terlebih Dahulu !");return;
			}
		//--END CEK_DIAGNOSAID--/

		//--CEK_TINDAKAN_ID--/
		vElfocus = document.getElementById("inptabelitemtindakanlookup");
		if((uTabelitemObj.tindakan_caption||"").trim()!=="")
			if(parseInt(uTabelitemObj.tindakan_id||0) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Tindakan ICD-9 Harus Dipilih Terlebih Dahulu !");return;
			}
		//--END CEK_TINDAKAN_ID--/
		//--END VALIDASI--/

		//---PROSES_EDIT--/
		/*uItemsArr[_IDXITEM].diagnosa_id 	= uTabelitemObj.diagnosa_id;
		uItemsArr[_IDXITEM].diagnosa_caption = (uTabelitemObj.diagnosa_caption||"").trim();
		uItemsArr[_IDXITEM].tindakan_id 	= uTabelitemObj.tindakan_id;
		uItemsArr[_IDXITEM].tindakan_caption = (uTabelitemObj.tindakan_caption||"").trim();
		uItemsArr[_IDXITEM].tindakan_teks 	= ((uTabelitemObj.tindakan_teks||"").trim());
		uItemsArr[_IDXITEM].keterangan 		= (uTabelitemObj.keterangan||"").trim();
		uItemsArr[_IDXITEM].qty_terapi 		= uTabelitemObj.qty_terapi||1;
		uDatamainObj.items_arr = uItemsArr;//-*/

		uItemsArr[_IDXITEM]	= {...(uItemsArr[_IDXITEM]||{}),
			diagnosa_id: uTabelitemObj.diagnosa_id,
			diagnosa_caption: (uTabelitemObj.diagnosa_caption||"").trim(),
			tindakan_id: uTabelitemObj.tindakan_id,
			tindakan_caption: (uTabelitemObj.tindakan_caption||"").trim(),
			tindakan_teks: ((uTabelitemObj.tindakan_teks||"").trim()),
			keterangan: (uTabelitemObj.keterangan||"").trim(),
			qty_terapi: parseInt(uTabelitemObj.qty_terapi)||1,
			diskon_terapi: parseFloat(uTabelitemObj.diskon_terapi)||0,
			nomorgigi_arr: uTabelitemObj.nomorgigi_arr||[],
		}

		setDatamainObj({...uDatamainObj,
			items_arr: uItemsArr,
		})
		//---END PROSES_EDIT--/

		setTabelitemObj({});
		setUpdatefield(!uUpdatefield);
	}
	const hdlKlikTabeledit = (_IDXITEM) => {
		_IDXITEM = parseInt(_IDXITEM); if(_IDXITEM < 0) return;

		const vTmpObj = {
			tabelidx: _IDXITEM,
			diagnosa_id: uItemsArr[_IDXITEM].diagnosa_id||0, 
			diagnosa_caption: uItemsArr[_IDXITEM].diagnosa_caption||"", 
			tindakan_id: uItemsArr[_IDXITEM].tindakan_id||0, 
			tindakan_caption: uItemsArr[_IDXITEM].tindakan_caption||"", 
			tindakan_teks: (uItemsArr[_IDXITEM].tindakan_teks||""), 
			keterangan: uItemsArr[_IDXITEM].keterangan||"", 
			qty_terapi: parseInt(uItemsArr[_IDXITEM].qty_terapi)||1, 
			tarif_terapi: parseFloat(uItemsArr[_IDXITEM].tarif_terapi)||0, 
			diskon_terapi: parseFloat(uItemsArr[_IDXITEM].diskon_terapi)||0, 
			nomorgigi_arr: uItemsArr[_IDXITEM].nomorgigi_arr||[], 
		}
		setTabelitemObj(vTmpObj);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inptambahitemqty"+_IDXITEM);
			vElfocus && vElfocus.focus();
		},350)
	}
	const hdlKlikTabelhapus = async(_IDXITEM) => {
		_IDXITEM = parseInt(_IDXITEM); if(_IDXITEM < 0) return;

		const vFuncnext = () => {
			uItemsArr.splice(_IDXITEM,1);
			/*uDatamainObj.items_arr = uItemsArr;
			setUpdatefield(!uUpdatefield);//-*/
			setDatamainObj({...uDatamainObj,
				items_arr: uItemsArr,
			})
		}

		if(await(Konfirm("Apakah Yakin Akan Dihapus ?"))) vFuncnext()
	}
	const hdlKlikTambahitemmobile = () => {
		setDlgformdataObj({
			dlg_header: "Tambah Item Terapi",
			jenis: "FORMTERAPI",
			dlg_size: "lg",
			diagnosa_id: parseInt(uDatamainObj.diagnosa_main_id)||0,	
			diagnosa_caption: uDatamainObj.diagnosa_main_caption,
		})
		setDlgformshow(true);
	}
	const hdlKlikTabelEditmobile = (_IDXITEM) => {
		const vArridx = parseInt(_IDXITEM);

		setDlgformdataObj({
			dlg_header: "Edit Terapi",
			jenis: "FORMTERAPI",
			dlg_size: "lg",
			idxtabel: vArridx,
			terapi_sub_id: parseInt(uItemsArr[vArridx].id_terapi_sub) || 0,
			terapi_caption: uItemsArr[vArridx].caption_terapi,
			terapi_tarif: parseFloat(uItemsArr[vArridx].tarif_terapi)||0,
			terapi_main: parseInt(uItemsArr[vArridx].id_terapi_sub)||0,
			diagnosa_id: parseInt(uItemsArr[vArridx].diagnosa_id)||0,
			diagnosa_caption: uItemsArr[vArridx].diagnosa_caption,
			tindakan_id: parseInt(uItemsArr[vArridx].tindakan_id)||0,
			tindakan_caption: uItemsArr[vArridx].tindakan_caption,
			tindakan_teks: uItemsArr[vArridx].tindakan_teks,
			ketgigi: uItemsArr[vArridx].keterangan,
			nomorgigi_arr: uItemsArr[vArridx].nomorgigi_arr,
			status_garansi: uItemsArr[vArridx].status_ada_garansi,
			terapi_qty: parseInt(uItemsArr[vArridx].qty_terapi) || 1,
			terapi_diskon: parseFloat(uItemsArr[vArridx].diskon_terapi) || 0,
		});
		setDlgformshow(true);
	}
	const hdlKDownFormitemcaption = (_EV) => {
		uDlgformdataObj.terapi_sub_id 	= 0;
		uDlgformdataObj.terapi_tarif  	= 0;
		uDlgformdataObj.terapi_main		= "";
		uDlgformdataObj.status_garansi 	= 0;
		uDlgformdataObj.terapi_qty 		= 0;
		if(_EV.keyCode !== 13) { setEfekview(!uEfekview); return; }
 		const vTerapicaption	= (uDlgformdataObj.terapi_caption||"").trim();
		if(vTerapicaption === "") { setEfekview(!uEfekview); return; }

		_EV.preventDefault()
		_EV.stopPropagation();

		const vArrCariMaster 	= uDataterapiArr.filter((vItem)=>
			vItem.terapi_caption.toUpperCase().includes((vTerapicaption).toUpperCase()));
		
		if (vArrCariMaster.length === 1) {
			uDlgformdataObj.terapi_sub_id	= (vArrCariMaster[0].id);
			uDlgformdataObj.terapi_caption	= (vArrCariMaster[0].terapi_caption);
			uDlgformdataObj.terapi_tarif	= parseInt(vArrCariMaster[0].terapi_tarif || 0);
			uDlgformdataObj.terapi_main		= (vArrCariMaster[0].terapi_main);
			uDlgformdataObj.status_garansi 	= vArrCariMaster[0].status_garansi;
			uDlgformdataObj.terapi_qty		= 1;

			setEfekview(!uEfekview);
			document.getElementById("inpformitemqty") &&
				document.getElementById("inpformitemqty").focus();
			return;
		}

		hdlKlikFormitemlookup();
	}
	const hdlKlikFormitemlookup = () => {
		//--CEK_IDDOKTER--/
		const vDokteridx = UFunc.getObjectIndeks(uDatadokterArr,uDatamainObj.id_dokter);
		if(vDokteridx < 0) {
			showToast("Nama Dokter Harus Dipilih Terlebih Dahulu !"); return;
		}
		const vArrkompetensiID = uDatadokterArr[vDokteridx].kompetensi_arr || [];
		//--END CEK_IDDOKTER--/

		uDlglookupObj.dlg_input = (uDlgformdataObj.terapi_caption||"");
		uDlglookupObj.dlg_jenis = ("FORMTERAPI");

		const vTmpArr	= uDataterapiArr.filter(vItems =>{
			return (parseInt(vItems.id_kompetensi||0) <= 0 ||
				vArrkompetensiID.includes(vItems.id_kompetensi.toString())
			);
		}).map(vItems => {
			return {
				id:vItems.id,
				caption:vItems.terapi_caption,// +" ("+vItems.id_kompetensi+")",
				harga_satuan:vItems.terapi_tarif
			}
		});

		/*const vTmpArr	= uDataterapiArr.map(vItems => {
			return {
				id:vItems.id,
				caption:vItems.terapi_caption,
				harga_satuan:vItems.terapi_tarif
			}
		});//-*/
		uDlglookupObj.data_arr = (vTmpArr);
		uDlglookupObj.dlg_header = ("Pilih: TERAPI");
		setDlglookupshow(true);
	}
	const hdlKlikFormitemdiagnosalookup = () => {
		const vTmpArr	= uDatadiagnosaArr.map(vItems => {
			return {id:vItems.id,caption:vItems.nama_diagnosa}});

		setDlglookupObj({
			dlg_input: "",
			dlg_jenis: "DIAGNOSAFORM",
			data_arr: vTmpArr,
			dlg_header: "Pilih: DIAGNOSA",
		});
		setDlglookupshow(true);
	}
	const hdlKlikFormitemtindakanlookup = (_IDXITEM) => {
		_IDXITEM = 0;//parseInt(_IDXITEM);

		setDlglookupapiObj({
			dlg_header: "Lookup: TINDAKAN ICD-9 CM",
			dlg_keyword: "",
			dlg_jenis: "FORMTINDAKAN",
			dlg_targetapi: pjson.homepage+"api/api_dataicd9/ld_lookup",
			dlg_idxtabel: _IDXITEM,
		});

		setDlglookupapishow(true);
	}
	const hdlKlikJanjiantambah = () => {
		if((parseInt(uDatamainObj.id_dokter)||0) <= 0) {
			document.getElementById("inpdoktercaption") &&
				document.getElementById("inpdoktercaption").focus()

			showToast("Nama Dokter Harus Dipilih Dahulu !"); return;
		}

		uDlgformdataObj.dlg_header 	= "Input Janjian Berikutnya";
		uDlgformdataObj.jenis 		= "JANJIAN";
		uDlgformdataObj.no_ruang 	= 1;
		uDlgformdataObj.dlg_size	= "lg";

		uDlgformdataObj.id_cabang		= uCabanginitObj.id_cabang;
		uDlgformdataObj.dokter_id		= uDatamainObj.id_dokter;
		uDlgformdataObj.dokter_caption	= uDatamainObj.nama_dokter;
		setDlgformshow(true);
	}
	const hdlKlikJanjianhapus = async(_IDXITEM) => {
		_IDXITEM = _IDXITEM===undefined ? -1 : parseInt(_IDXITEM);
		if(_IDXITEM < 0) return;

		if((parseInt(uJanjianArr[_IDXITEM].id_antrian)||0) > 0) return;

		if(await(Konfirm(uBahasaObj.confirm_hapus))) {
			uJanjianArr.splice(_IDXITEM,1);
			/*uDatamainObj.janjian_arr = uJanjianArr;
			setUpdatefield(!uUpdatefield)//-*/
			setDatamainObj({...uDatamainObj,
				janjian_arr: uJanjianArr,
			});
		}
	}
	const hdlKlikCekantriantoggle = () => {
		if(!uCekantrianshow) {
			if((uDlgformdataObj.tgl_antri||"")==="") {
				showToast("Harap Tentukan Tanggal Antrian Terlebih Dahulu !");
				return;
			}
			if(uDlgformdataObj.tgl_antri === UFunc.DbDate()) {
				showToast("Tanggal Cek Antrian Hanya Untuk Tanggal SETELAH Hari Ini !");
				return;	
			}
			const vTglantriDT = UFunc.toDate(uDlgformdataObj.tgl_antri);
			if(UFunc.DateIsMundur(vTglantriDT)) {
				showToast("Tanggal Cek Antrian Sudah Kadaluwarsa !");
				return;	
			}
		}
		setCekantrianshow(!uCekantrianshow);
	}
	const hdlKlikCekantrianview = () => {
		if((uCekantrianObj.tgl_antri||uDlgformdataObj.tgl_antri)==="") {
			uCekantrianObj.errormsg = ("Harap Tentukan Tanggal Antrian Terlebih Dahulu !");
			setEfekview(!uEfekview);return;
		}
		if(uCekantrianObj.tgl_antri === UFunc.DbDate()) {
			uCekantrianObj.errormsg = ("Tanggal Cek Antrian Hanya Untuk Tanggal SETELAH Hari Ini !");
			setEfekview(!uEfekview);return;
		}
		const vTglantriDT = UFunc.toDate(uCekantrianObj.tgl_antri);
		if(UFunc.DateIsMundur(vTglantriDT)) {
			uCekantrianObj.errormsg = ("Tanggal Cek Antrian Sudah Kadaluwarsa !");
			setEfekview(!uEfekview);return;
		}
		apiLoadantrian();
	}
	const hdlKlikNavtab = (e, id) => {
		e.preventDefault(); // Stop the default browser "jump"

		const element = document.getElementById(id);
		if (!element) return;

		const headerHeight 		= document.getElementById("idheadermain").offsetHeight;
		const elementPosition 	= element.getBoundingClientRect().top;

		// Calculate the final position: current scroll + element top - header height
		const offsetPosition = elementPosition + window.pageYOffset - headerHeight - 5;

		// This solves the "middle of the section" problem
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});

		// Update state to highlight the nav item immediately
		//setActivetab(id);

		// Update the URL hash silently (optional, prevents crash)
		//window.history.pushState(null, '', `#${id}`);
	}
	const hdlKDownResepformcaption = (_EV) => {
		if(_EV.keyCode !== 13) {
			setTambahresepObj({
				nama_item: uTambahresepObj.nama_item,
			})
			return;
		}
		
		const vResepcaption	= (uTambahresepObj.nama_item||"").trim();

		_EV.preventDefault()
		_EV.stopPropagation();

		if(vResepcaption === "") {
			setTambahresepObj({...uTambahresepObj,
				id: undefined
			})

			document.getElementById("inpreseptambahqty") &&
				document.getElementById("inpreseptambahqty").focus();
			return;
		}

		setDlglookupapiObj({
			...uDlglookupapiObj,
			dlg_trigger: true,
		});

		hdlKlikResepformlookup();
	}
	const hdlKlikResepformlookup = () => {
		setDlglookupapiObj({
			dlg_header: "Lookup: Data Obat",
			dlg_jenis: "FORMOBAT",
			dlg_keyword: uTambahresepObj.nama_item||"",
			dlg_targetapi: pjson.homepage+"api2/api_barang/ld_lookupobat",
		});

		setDlglookupapishow(true);
	}
	const hdlKlikResepformtambah = () => {
		if((parseInt(uTambahresepObj.id)||0) <= 0) return;

		//--VALIDASI--/
		if((uTambahresepObj.nama_item||"").trim() === "") {
			showToast("Nama Obat untuk Resep Tidak Valid !");
			return;
		}
		if(parseFloat(uTambahresepObj.qty ?? "0") <= 0) {
			showToast("QTY Obat untuk Resep Tidak Valid !");
			return;
		}
		//--END VALIDASI--/

		const vTmpObj = {...uTambahresepObj}

		setDatamainObj({...uDatamainObj,
			resep_arr: [vTmpObj,...(uDatamainObj.resep_arr||[])],
		})

		setTambahresepObj({});

		document.getElementById("inpreseptambahobat") &&
			document.getElementById("inpreseptambahobat").focus();
	}
	const hdlKlikResepformtambahmobile = () => {
		setDlgformdataObj({
			dlg_header: "Tambah Item Resep",
			jenis: "FORMRESEP",
			dlg_size: "lg",
		})
		setDlgformshow(true);
	}
	const hdlKlikReseptabeleditmobile = (_IDXITEM) => {
		const vArridx = parseInt(_IDXITEM ?? "-1");

		setDlgformdataObj({
			...((uDatamainObj.resep_arr||[])[vArridx]||{}),
			dlg_header: "Edit Resep Obat",
			jenis: "FORMRESEP",
			dlg_size: "lg",
			idxtabel: vArridx,
		});
		setDlgformshow(true);
	}
	const hdlKlikFormresepitemlookup = () => {
		setDlglookupapiObj({
			dlg_header: "Lookup: Data Obat",
			dlg_jenis: "DLGFORMOBAT",
			dlg_keyword: uTambahresepObj.nama_item||"",
			dlg_targetapi: pjson.homepage+"api2/api_barang/ld_lookupobat",
		});

		setDlglookupapishow(true);
	}
	const hdlKlikReseptabeledit = (_IDXITEM,_FIELD) => {
		_IDXITEM 	= parseInt(_IDXITEM);
		_FIELD		= (_FIELD||"").trim();

		let vTmpeditObj = {};
		let vValue;
		if(_FIELD === "qty") {
			//--VALIDASI--/
			vValue = parseFloat((uDatamainObj.resep_arr||[])[_IDXITEM].qty ?? 0);
			if(vValue <= 0) {
				showToast("Qty Obat Tidak Valid !");
				return;
			}
			//--END VALIDASI--/

			vTmpeditObj = { value: vValue }
		} else if(_FIELD === "ketentuan") {
			vValue = parseFloat((uDatamainObj.resep_arr||[])[_IDXITEM].frekuensi ?? 0);
			const vDosis = parseFloat((uDatamainObj.resep_arr||[])[_IDXITEM].dosis ?? 0);
			vTmpeditObj = { value: vValue,dosis:vDosis }
		} else if(_FIELD === "aturan") {
			vValue = ((uDatamainObj.resep_arr||[])[_IDXITEM].aturan || "").trim();
			vTmpeditObj = { value: vValue }
		}

		setEditresepObj({
			field:_FIELD,
			idxkey:_IDXITEM,
			...vTmpeditObj,
		});

		if(isMobile) return;

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			document.getElementById("inptabelresepedit") &&
				document.getElementById("inptabelresepedit").focus();
		},350)
	}
	const hdlKDownReseptabelfield = (_EV) => {
		if(_EV.which === 27) {
			_EV.preventDefault();
			setEditresepObj({});
			return;
		}
		if(_EV.which === 13) {
			_EV.preventDefault();
			_EV.stopPropagation();
			hdlKlikReseptabeldone();
			return;
		}
	}
	const hdlKlikReseptabeldone = () => {
		const vIdxedit = uEditresepObj.idxkey ?? -1;
		let vTmpeditObj;
		let vValue;
		if(uEditresepObj.field === "qty") {
			//--VALIDASI--/
			vValue = parseFloat(uEditresepObj.value ?? 0);
			if(vValue <= 0) {
				showToast("Qty Obat Tidak Valid !");
				return;
			}
			//--END VALIDASI--/

			vTmpeditObj = { qty: vValue }
		} else if(uEditresepObj.field === "ketentuan") {
			//--VALIDASI--/
			vValue = parseFloat(uEditresepObj.value ?? 0);
			if(vValue <= 0) {
				showToast("Frekuensi Penggunaan Obat Tidak Valid !");
				return;
			}
			const vDosis = parseFloat(uEditresepObj.dosis ?? 0);
			if(vDosis <= 0) {
				showToast("Jml Dosis Penggunaan Obat Tidak Valid !");
				return;
			}
			//--END VALIDASI--/

			vTmpeditObj = { frekuensi: vValue, dosis: vDosis }
		} else if(uEditresepObj.field === "aturan") {
			vValue = (uEditresepObj.value || "").trim();
			vTmpeditObj = { aturan: vValue }
		}
		
		///console.log("(Periksa - hdlKlikReseptabeldone) vTmpeditObj",vTmpeditObj);

		(uDatamainObj.resep_arr||[])[vIdxedit] = {
			...((uDatamainObj.resep_arr||[])[vIdxedit] || {}),
			...vTmpeditObj,
		}

		setEditresepObj({});
	}
	const hdlKlikReseptabelhapus = async(_IDXITEM) => {
		_IDXITEM = parseInt(_IDXITEM ?? -1); if(_IDXITEM < 0) return;

		if(await Konfirm("Apakah Yakin Akan Dihapus ?")) {
			(uDatamainObj.resep_arr||[]).splice(_IDXITEM,1);
			setEfekview(!uEfekview);
		}
	}
	const hdlKlikSimpanmain = async() => {
		//alert("uOdontograminputArr = "+JSON.stringify(uOdontograminputArr));return;
		if(!uIsFormupdate) return;
		if(uTabelitemObj.tabelidx !== undefined) {
			showToast("Kemungkinan Proses <b>Edit Terapi Masih BELUM Disimpan</b>..<br/>Mohon dicek Terlebih Dahulu !");
			return;
		}

		let vElfocus = document.getElementById("inptglperiksa");
		if((uDatamainObj.tgl_periksa||"").trim()==="") {
			if(!uISCellphonemode)
				window.history.replaceState(null, '', '#iddataperiksa');
			vElfocus && vElfocus.focus()
			showToast("Tanggal Antrian Tidak Valid !"); return
		}
		const vTglantriDT = UFunc.toDate(uDatamainObj.tgl_periksa);
		if(UFunc.DateIsBeyond(vTglantriDT)) {
			if(!uISCellphonemode)
				window.history.replaceState(null, '', '#iddataperiksa');
			vElfocus && vElfocus.focus()
			showToast("Tanggal Antrian Melewati Hari Ini !"); return
		}

		if(uISCellphonemode)
			vElfocus = document.getElementById("inpdoktercaption");
		else
			vElfocus = document.getElementById("btndokterpilih");
		if(parseInt(uDatamainObj.id_dokter||0) <= 0) {
			if(!uISCellphonemode)
				window.history.replaceState(null, '', '#iddataperiksa');
			vElfocus && vElfocus.focus()
			showToast("Dokter Harus Dipilih !"); return
		}
		vElfocus = document.getElementById("btnperawat");
		if((uPerawatArr.length) <= 0) {
			if(!uISCellphonemode)
				window.history.replaceState(null, '', '#iddataperiksa');
			vElfocus && vElfocus.focus()
			showToast("Belum Ada PERAWAT yang Disertakan !"); return
		}
		vElfocus = document.getElementById("btnsubjective");
		if((uDatamainObj.anamnase||"").trim()==="") {
			if(!uISCellphonemode) {
				window.history.replaceState(null, '', '#iddatasoa');
			}
			vElfocus && vElfocus.focus()
			showToast("SUBJECTIVE :: Keluhan Utama Harus Dipilih !"); return
		}
		vElfocus = document.getElementById("inpdiagnosamainlookup");
		if((parseInt(uDatamainObj.diagnosa_main_id)||0) <= 0) {
			if(!uISCellphonemode)
				window.history.replaceState(null, '', '#iddatasoa');
			vElfocus && vElfocus.focus()
			showToast("ASSESSMENT :: Diagnosa Utama Harus Dipilih !"); return
		}
		vElfocus = document.getElementById("btnFormitem");
		if((uItemsArr.length) <= 0) {
			if(!uISCellphonemode) {
				vElfocus = document.getElementById("inptambahitemcaption");
				window.history.replaceState(null, '', '#iddataplan');
			}
			vElfocus && vElfocus.focus()
			showToast("Belum Ada Item Terapi yang Diinputkan !"); return
		}

		//showToast(JSON.stringify(uDatamainObj)); return;

		if(await(Konfirm(
			//"<b>Simpan Billing PERIKSA</b>.."+
			//"<br/><br/>"+
			//"<div>"+uDatamainObj.dokter_id+"</div>"+
			"<div class='d-flex justify-content-between mx-3'>"+
				"<small >Tgl Periksa</small>"+
				"<b>"+UFunc.TglAngka(uDatamainObj.tgl_periksa)+"</b>"+
			"</div>"+

			"<div class='d-flex justify-content-between mx-3'>"+
				"<small>Dokter</small>"+
				"<b class='text-primary'>"+uDatamainObj.nama_dokter+"</b>"+
			"</div>"+
			(uPerawatArr.length <= 0 ? "" 
				: "<div class='d-flex justify-content-between mx-3'>"+
					"<small>Perawat</small>"+
					"<div class='ps-2 fst-italic text-end d-block'>"+
					(uPerawatArr.map((vItems,vKeys)=>{
						return vItems.perawat_caption;
					})).join(" &middot; ")+
					"</div>"+
				"</div>"+
				"")+

			"<hr class='border-none border-botom' />"+

			"<div class='d-flex justify-content-between mx-3'>"+
				"<small><b>(S)</b> :: Keluhan Utama</small>"+
				"<b class='text-end classfontsmaller text-capitalize' style='max-width:60%;'>"+uDatamainObj.anamnase+"</b>"+
			"</div>"+

			((uDatamainObj.objective_teks||"").trim() === "" ? "" 
				: "<div class='d-flex justify-content-between mx-3'>"+
					"<small><b>(O)</b> :: Deskripsi Objective</small>"+
					"<b class='text-end classfontsmaller text-capitalize' style='max-width:65%;'>"+uDatamainObj.objective_teks+"</b>"+
				"</div>"+
				"")+

			"<div class='d-flex justify-content-between mx-3'>"+
				"<small><b>(A)</b> :: Diagnosa Utama</small>"+
				"<b class='text-end classfontsmaller text-capitalize' style='max-width:65%;'>"+uDatamainObj.diagnosa_main_caption+"</b>"+
			"</div>"+

			"<hr class='border-none border-botom' />"+

			"<div class='d-flex justify-content-between mx-3'>"+
				"<small><b>(P)</b>lan & Terapi</small>"+
				"<div><b>"+UFunc.formatAngka(uItemsArr.length)+"</b> Items</div>"+
			"</div>"+

			((uDatamainObj.resep_arr||[]).length > 0 ? 
			"<div class='d-flex justify-content-between mx-3'>"+
				"<small>Resep Obat</small>"+
				"<div><b>"+UFunc.formatAngka((uDatamainObj.resep_arr||[]).length)+"</b> Items</div>"+
			"</div>"+
			"" : "")+

			/*//--TIDAK_DIPAKAI--/
			"<div class='d-flex justify-content-between mx-3'>"+
				"<small>Nilai Terapi</small>"+
				"<div class='text-rimary'>Rp "+UFunc.formatAngka(uDatamainObj.nilai_bruto)+"</div>"+
			"</div>"+
			((parseFloat(uDatamainObj.nilai_diskon)||0) <= 0 ? "" 
				: "<div class='d-flex justify-content-between mx-3 text-danger'>"+
				"<small>Diskon</small>"+
				"<div class=''>Rp "+UFunc.formatAngka(uDatamainObj.nilai_diskon)+"</div>"+
				"</div>"+
				"")+//-*/
			
			"<hr class='border-none border-botom' />"+
			"<div class='d-flex justify-content-between mx-3'>"+
				"<small>Nilai TOTAL</small>"+
				"<big class='text-success fw-bolder'>Rp "+UFunc.formatAngka(uDatamainObj.nilai_netto)+"</big>"+
			"</div>"+

			"<br/><br/>"+

			"<center>Apakah Yakin Akan Menyimpan ?</center>"+
			""))) apiSimpanmain()
	}
	//---END HANDEL--/

	//---INIT_PROCESS--/
	const initResetmain = () => {
		//uDispatch({type: "set", gBillingperiksaObj: undefined});
		uDispatch({type: "set", gOdontograminputArr: undefined});
		setTambahitemObj({});
		setTabelitemObj({});
		setDatamainObj({});setUpdatefield(!uUpdatefield);
	}
	const initResettambahform = () => {//-->RESET_SEMUA_KECUALI_CAPTION--/
		setTambahitemObj({
			terapi_caption: uTambahitemObj.terapi_caption,
		});
	}
	const lookupPilihdokter = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatadokterArr,_IDITEM);

		/*uDatamainObj.id_dokter 		= uDatadokterArr[vArridx].id;
		uDatamainObj.nama_dokter 	= uDatadokterArr[vArridx].dokter_caption;
		setUpdatefield(!uUpdatefield)//-*/
		setDatamainObj({...uDatamainObj,
			id_dokter: parseInt(uDatadokterArr[vArridx].id)||0,
			nama_dokter: uDatadokterArr[vArridx].dokter_caption||"",
		})
		setUpdatefield(!uUpdatefield);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inpanamnasecaption");
			vElfocus && vElfocus.focus()
		},350)
	}
	const lookupPilihdokterjanjian = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatadokterArr,_IDITEM);

		uDlgformdataObj.dokter_id 		= uDatadokterArr[vArridx].id;
		uDlgformdataObj.dokter_caption 	= uDatadokterArr[vArridx].dokter_caption;
		setUpdatefield(!uUpdatefield)

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inpjamawal");
			if(!isMobile) vElfocus && vElfocus.focus()
		},350)
	}
	const lookupPilihcatdokter = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatacatdokterArr,_IDITEM);

		/*uDatamainObj.note_dokter 	= uDatacatdokterArr[vArridx].note_caption||"";
		setUpdatefield(!uUpdatefield)//-*/
		setDatamainObj({...uDatamainObj,
			note_dokter: uDatacatdokterArr[vArridx].note_caption||"",
		})

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inpcatatantambahan");
			vElfocus && vElfocus.focus()
		},350)
	}
	const lookupPilihterapi = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDataterapiArr,_IDITEM);
		setTambahitemObj({
			...uTambahitemObj,
			id: parseInt(uDataterapiArr[vArridx].id)||0,
			terapi_caption: uDataterapiArr[vArridx].terapi_caption,
			terapi_tarif: parseFloat(uDataterapiArr[vArridx].terapi_tarif)||0,
			status_garansi: uDataterapiArr[vArridx].status_garansi,
			terapi_main: (uDataterapiArr[vArridx].terapi_main),
			terapi_qty: 1,
		})

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vElfocus = document.getElementById("inptambahitemqty");
			vElfocus && vElfocus.focus()
		},350)
	}
	const lookupPilihdiagnosamain = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatadiagnosaArr,_IDITEM);

		//--VALIDASI_SUDAH_ADA--/
		const vDiagnosasekunderArr 	= uDatamainObj.diagnosa_sekunder_arr || [];
		const vIdxsearch			= UFunc.getObjectIndeks(vDiagnosasekunderArr,_IDITEM,"diagnosa_sekunder_id");
		if(vIdxsearch >= 0) {
			showToast("<p><b>Diagnosa Utama Sudah Digunakan</b>..</p>"+
				"<i>Silahkan Hapus Diagnosa Sekunder Terlebih Dahulu!</i>"+
				"");return;
		}
		//--END VALIDASI_SUDAH_ADA--/

		/*uDatamainObj.diagnosa_main_id		= uDatadiagnosaArr[vArridx].id;
		uDatamainObj.diagnosa_main_caption	= uDatadiagnosaArr[vArridx].nama_diagnosa;
		setEfekview(!uEfekview);//-*/
		setDatamainObj({...uDatamainObj,
			diagnosa_main_id: parseInt(uDatadiagnosaArr[vArridx].id)||0,
			diagnosa_main_caption: uDatadiagnosaArr[vArridx].nama_diagnosa||"",
		})

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)

			let vElfocus = document.getElementById("inpdiagnosamainteks");
			vElfocus && vElfocus.focus();
		},350)
	}
	const lookupPilihdiagnosasekunder = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatadiagnosaArr,_IDITEM);
		const vTabelidx	= uDlglookupObj.dlg_idxtabel;

		setTabelitemObj({...uTabelitemObj,
			diagnosa_id: uDatadiagnosaArr[vArridx].id,
			diagnosa_caption: uDatadiagnosaArr[vArridx].nama_diagnosa,
		})
	}
	const lookupPilihFormdiagnosa = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatadiagnosaArr,_IDITEM);
		setDlgformdataObj({
			...uDlgformdataObj,
			diagnosa_id: parseInt(uDatadiagnosaArr[vArridx].id)||0,
			diagnosa_caption: uDatadiagnosaArr[vArridx].nama_diagnosa,
		})

		const vElfocus = document.getElementById("inpformitemdiagnosaketerangan");
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			vElfocus && vElfocus.focus()
		},350)
	}
	const lookupFormterapi = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDataterapiArr,_IDITEM);

		uDlgformdataObj.terapi_sub_id	= uDataterapiArr[vArridx].id;
		uDlgformdataObj.terapi_caption 	= uDataterapiArr[vArridx].terapi_caption;
		uDlgformdataObj.terapi_tarif 	= uDataterapiArr[vArridx].terapi_tarif;
		uDlgformdataObj.status_garansi 	= uDataterapiArr[vArridx].status_garansi;
		uDlgformdataObj.terapi_main		= (uDataterapiArr[vArridx].terapi_main);
		uDlgformdataObj.terapi_qty		= 1;
		setEfekview(!uEfekview)

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inpformitemqty");
			vElfocus && vElfocus.focus()
		},350)
	}
	const initKlikformjanjian = () => {
		let vElfocus = document.getElementById("inpformcabangid");
		if(parseInt(uDlgformdataObj.id_cabang||"0") <= 0) {
			vElfocus && vElfocus.focus()
			showToast("Cabang Tidak Valid !"); return
		}
		vElfocus = document.getElementById("inptglantri");
		if((uDlgformdataObj.tgl_antri||"") === "") {
			vElfocus && vElfocus.focus()
			showToast("Tgl Antrian Tidak Valid !"); return
		}
		if(uDlgformdataObj.tgl_antri === UFunc.DbDate()) {
			vElfocus && vElfocus.focus()
			showToast("Tanggal Antrian Hanya Dapat Tanggal SETELAH Hari Ini !");
			return
		}
		const vTglantriDT = UFunc.toDate(uDlgformdataObj.tgl_antri);
		if(UFunc.DateIsMundur(vTglantriDT)) {
			vElfocus && vElfocus.focus()
			showToast("Tgl Antrian Sudah Kadaluwarsa !"); return
		}
		//--CEK_SUDAH_ADA_DIDATA_LOKAL--/
		const vFilterTglExistArr = uJanjianArr.filter(vItems=>{
			return ((parseInt(vItems.id_antrian)||0) <= 0 
				&& vItems.tgl_antri === uDlgformdataObj.tgl_antri
				)
		});
		if(vFilterTglExistArr.length > 0) {
			vElfocus && vElfocus.focus()
			showToast("Tgl Antrian Tersebut Sudah Terdaftar !"); return
		}
		//--END CEK_SUDAH_ADA_DIDATA_LOKAL--/

		vElfocus = document.getElementById("inpjanjiandoktercaption");
		if(parseInt(uDlgformdataObj.dokter_id||"0") <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Dokter Rujukan Harus Dipilih.."+
				"<br/>Mohon Diperbaiki !"+
				""); return
		}

		vElfocus = document.getElementById("inpjamawal");
		if((uDlgformdataObj.jam_awal||"") === "") {
			vElfocus && vElfocus.focus();
			showToast("Jenis Antrian Merupakan Antrian JANJIAN.."+
				"<br/>Jam Janjian AWAL Harus Diisi !"+
				""); return;
		}

		vElfocus = document.getElementById("inpjamakhir");
		if((uDlgformdataObj.jam_akhir||"") === "") {
			vElfocus && vElfocus.focus();
			showToast("Jenis Antrian Merupakan Antrian JANJIAN.."+
				"<br/>Jam Janjian AKHIR Harus Diisi !"+
				""); return
		}

		const vTimeAwalDT	= UFunc.toDatetime(uDlgformdataObj.tgl_antri+" "+uDlgformdataObj.jam_awal+":00");
		const vTimeAkhirDT	= UFunc.toDatetime(uDlgformdataObj.tgl_antri+" "+uDlgformdataObj.jam_akhir+":00");

		if(vTimeAwalDT > vTimeAkhirDT) {
			vElfocus && vElfocus.focus();
			showToast("Jam Janjian AWAL Lebih Besar dari Jam Janjian AKHIR !"); return
		}
		vElfocus = document.getElementById("inpnoruang");
		if((parseInt(uDlgformdataObj.no_ruang)||0) <= 0
			|| (parseInt(uDlgformdataObj.no_ruang)||0) > (parseInt(uCabanginitObj.jml_ruangan)||2)) {
			vElfocus && vElfocus.focus();
			showToast("No Ruangan Tidak Valid ! "); return
		}

		apiJanjianchecking();
	}
	const initKlikformtanggal = () => {
		let vElfocus = document.getElementById("inptglperiksa");
		if((uDlgformdataObj.tgl_periksa||"") === "") {
			vElfocus && vElfocus.focus()
			showToast("Tgl Periksa Tidak Valid !"); return
		}

		/*uDatamainObj.tgl_periksa = uDlgformdataObj.tgl_periksa;
		setUpdatefield(!uUpdatefield);//-*/
		setDatamainObj({...uDatamainObj,
			tgl_periksa: uDlgformdataObj.tgl_periksa,
		})
		setDlgformshow(false);
	}
	const initKlikformitem = () => {//--UTK_MOBILE--/
		const vTerapiID = parseInt(uDlgformdataObj.terapi_sub_id)||0;
		if(vTerapiID <= 0) return;

		const vArridx = uDlgformdataObj.idxtabel===undefined 
			? -1 : parseInt(uDlgformdataObj.idxtabel);
		if(vArridx >= 0) {
			uItemsArr[vArridx] = {
				...(uItemsArr[vArridx]||{}),
				diagnosa_id: parseInt(uDlgformdataObj.diagnosa_id)||0,
				diagnosa_caption: (uDlgformdataObj.diagnosa_caption||"").trim(),
				tindakan_id: parseInt(uDlgformdataObj.tindakan_id)||0,
				tindakan_caption: (uDlgformdataObj.tindakan_caption||"").trim(),
				tindakan_teks: (uDlgformdataObj.tindakan_teks||"").trim(),
				keterangan: (uDlgformdataObj.ketgigi||"").trim(),
				nomorgigi_arr: (uDlgformdataObj.nomorgigi_arr||[]),
				status_ada_garansi: (uDlgformdataObj.status_garansi||"TIDAK"),
				qty_terapi: parseInt(uDlgformdataObj.terapi_qty)||1,
				diskon_terapi: parseFloat(uDlgformdataObj.terapi_diskon)||0,
			};

			hdlToggleDlgform();
			return;
		}

		const vTerapimain = uDlgformdataObj.terapi_main || "";
		const vTmpObj = {
			id_terapi_sub : vTerapiID,
			caption_terapi : uDlgformdataObj.terapi_caption || "",
			tarif_terapi: parseFloat(uDlgformdataObj.terapi_tarif) || 0,
			diskon_terapi: parseFloat(uDlgformdataObj.terapi_diskon) || 0,
			qty_terapi: parseInt(uDlgformdataObj.terapi_qty) || 0,
			diagnosa_id: parseInt(uDlgformdataObj.diagnosa_id) || 0,
			diagnosa_caption: uDlgformdataObj.diagnosa_caption,
			tindakan_id: uDlgformdataObj.tindakan_id || 0,
			tindakan_caption : (uDlgformdataObj.tindakan_caption||"").trim(),
			tindakan_teks : (uDlgformdataObj.tindakan_teks||"").trim(),
			keterangan : (uDlgformdataObj.ketgigi||"").trim(),
			nomorgigi_arr: (uDlgformdataObj.nomorgigi_arr||[]),
			status_ada_garansi : (uDlgformdataObj.status_garansi||"TIDAK"),
			tgl_batas_garansi : "",
		}

		//uDatamainObj.items_arr = [vTmpObj,...uItemsArr];
		setDatamainObj({...uDatamainObj,
			items_arr: [vTmpObj,...uItemsArr],
		})

		const vTmpresetObj = {
			jenis: uDlgformdataObj.jenis,
			terapi_caption : vTerapimain,
		}
		setDlgformdataObj(vTmpresetObj);
		showToast(uBahasaObj.pesan_sukses,"SUKSES");
		//setEfekview(!uEfekview);
	}
	const initKlikformperawat = () => {
		/*if((uDlgformdataObj.perawatid_arr||[]).length <= 0) {
			showToast("Perawat Belum Ada yg Dipilih !"); return
		}//-*/

		/*uDatamainObj.perawat_arr = uDataperawatArr.filter(vItems => 
			(uDlgformdataObj.perawatid_arr||[]).includes(vItems.id)
			) || [];
		setUpdatefield(!uUpdatefield);//-*/
		setDatamainObj({...uDatamainObj,
			perawat_arr: uDataperawatArr.filter(vItems => 
				(uDlgformdataObj.perawatid_arr||[]).includes(vItems.id)
				) || [],
		})
		setDlgformshow(false);
	}
	const initKlikformsubjective = () => {
		//console.log("(Periksa - initKlikformsubjective) uDatasubjectiveObj = "+JSON.stringify(uDatasubjectiveObj));
		/*uDatamainObj.anamnase 		= uDatasubjectiveObj.anamnase_caption;
		uDatamainObj.anamnase_id 	= uDatasubjectiveObj.anamnase_id;
		uDatamainObj.subjective_obj = uDatasubjectiveObj;//-*/

		setDatamainObj({...uDatamainObj,
			anamnase: uDatasubjectiveObj.anamnase_caption||"Undf Anamnase",
			anamnase_id: parseInt(uDatasubjectiveObj.anamnase_id)||0,
			subjective_obj: uDatasubjectiveObj,
		});
		uDispatch({type: "set", gDatasubjective: undefined});

		setDlgformsubjectiveshow(false);
	}
	const initKlikResepformlookupkfa = () => {
		//--CEK_TOKEN--/
		const vAccesstoken 		= uTokensatusehatObj.access_token;
		
 		if(!vAccesstoken) {
 			loadTokensatusehat(initKlikResepformlookupkfa); return;
 		}
		const vLimitedsec		= parseInt(uTokensatusehatObj.expires_in || "0");
		const vTimestampnow 	= new Date();
		const vTimetoken		= new Date(parseInt(uTokensatusehatObj.issued_at || "0"));
		const vSelisih			= UFunc.Datetimeselisih(vTimetoken,vTimestampnow).dtk;

		if(vSelisih > vLimitedsec) {
 			loadTokensatusehat(initKlikResepformlookupkfa); return;
		}
		//--END CEK_TOKEN--/

		setDlglookupapiObj({
			dlg_header: "Lookup: Data Obat Nasional (KFA)",
			dlg_keyword: uTambahresepObj.nama_item||"",
			dlg_jenis: "FORMKFA",
			dlg_targetapi: pjson.homepage+"api2/api_barang/ld_lookupkfa?send_accesstoken="+vAccesstoken,
		});

		setDlglookupapishow(true);
	}
	const initKlikResepmobilelookupkfa = () => {
		//--CEK_TOKEN--/
		const vAccesstoken 		= uTokensatusehatObj.access_token;
		
 		if(!vAccesstoken) {
 			loadTokensatusehat(initKlikResepmobilelookupkfa); return;
 		}
		const vLimitedsec		= parseInt(uTokensatusehatObj.expires_in || "0");
		const vTimestampnow 	= new Date();
		const vTimetoken		= new Date(parseInt(uTokensatusehatObj.issued_at || "0"));
		const vSelisih			= UFunc.Datetimeselisih(vTimetoken,vTimestampnow).dtk;

		if(vSelisih > vLimitedsec) {
 			loadTokensatusehat(initKlikResepmobilelookupkfa); return;
		}
		//--END CEK_TOKEN--/

		setDlglookupapiObj({
			dlg_header: "Lookup: Data Obat Nasional (KFA)",
			dlg_keyword: uTambahresepObj.nama_item||"",
			dlg_jenis: "DLGFORMKFA",
			dlg_targetapi: pjson.homepage+"api2/api_barang/ld_lookupkfa?send_accesstoken="+vAccesstoken,
		});

		setDlglookupapishow(true);
	}
	const initKlikformresep = () => {
		//--VALIDASI--/
		if((uDlgformdataObj.nama_item||"").trim() === "") {
			showToast("Nama Obat untuk Resep Tidak Valid !");
			return;
		}
		if(parseFloat(uDlgformdataObj.qty ?? 0) <= 0) {
			showToast("QTY Obat untuk Resep Tidak Valid !");
			return;
		}
		//--END VALIDASI--/

		const vTmpObj = {...uDlgformdataObj,
			dlg_header: undefined,
			jenis: undefined,
			dlg_size: undefined,
			idxtabel: undefined,
		}

		const vArridx = parseInt(uDlgformdataObj.idxtabel ?? "-1"); 
		if(vArridx >= 0) {
			(uDatamainObj.resep_arr||[])[vArridx] = {...vTmpObj};

			setDatamainObj({...uDatamainObj,
				resep_arr: (uDatamainObj.resep_arr||[]),
			});

			setDlgformshow(false);
			return;
		}

		setDatamainObj({...uDatamainObj,
			resep_arr: [vTmpObj,...(uDatamainObj.resep_arr||[])],
		});

		setDlgformdataObj({...uDlgformdataObj,
			id_barang : undefined,
			nama_item : undefined,
			kfa_code : undefined,
			kfa_name : undefined,
			frekuensi : undefined,
			dosis : undefined,
			aturan : undefined,
			qty : undefined,
			satuan_kecil : undefined,
		})
	}
	const initProsesscreening = () => {
		//--VALIDASI--/
		const vScreeningObj	= {
			tekanandarahatas : uDataobjectiveObj.tekanandarahatas,
			tekanandarahbawah : uDataobjectiveObj.tekanandarahbawah,
			denyutnadi : uDataobjectiveObj.denyutnadi,
			suhu : uDataobjectiveObj.suhu,
			berat : parseFloat(uDataobjectiveObj.berat) <= 0 ? undefined : parseFloat(uDataobjectiveObj.berat),
			nyeri_status : uDataobjectiveObj.nyeri_status,
			nyeri_skala : parseInt(uDataobjectiveObj.nyeri_skala) <= 0 ? undefined : uDataobjectiveObj.nyeri_skala,
			nyeri_kategori : uDataobjectiveObj.nyeri_kategori,
			mental_emosi : (uDataobjectiveObj.mental_emosi||"").trim()==="" ? undefined : (uDataobjectiveObj.mental_emosi||"").trim(),
			mental_konsepdiri : (uDataobjectiveObj.mental_konsepdiri||"").trim()==="" ? undefined : (uDataobjectiveObj.mental_konsepdiri||"").trim(),
			mental_komunikasi : (uDataobjectiveObj.mental_komunikasi||"").trim()==="" ? undefined : (uDataobjectiveObj.mental_komunikasi||"").trim(),
			psiko_mental : uDataobjectiveObj.psiko_mental,
			psiko_emosi : uDataobjectiveObj.psiko_emosi,
			sosial_agama : (uDataobjectiveObj.sosial_agama||"").trim()==="" ? undefined : (uDataobjectiveObj.sosial_agama||"").trim(),
			sosial_pendidikan : (uDataobjectiveObj.sosial_pendidikan||"").trim()==="" ? undefined : (uDataobjectiveObj.sosial_pendidikan||"").trim(),
			sosial_pekerjaan : (uDataobjectiveObj.sosial_pekerjaan||"").trim()==="" ? undefined : (uDataobjectiveObj.sosial_pekerjaan||"").trim(),
			riwayat_kesehatan : (uDataobjectiveObj.riwayat_kesehatan||"").trim()==="" ? undefined : (uDataobjectiveObj.riwayat_kesehatan||"").trim(),
			riwayat_obat : (uDataobjectiveObj.riwayat_obat||"").trim()==="" ? undefined : (uDataobjectiveObj.riwayat_obat||"").trim(),
			riwayat_gizi : (uDataobjectiveObj.riwayat_gizi||"").trim()==="" ? undefined : (uDataobjectiveObj.riwayat_gizi||"").trim(),
		}
		//--END VALIDASI--/

		setDatamainObj({...uDatamainObj,screening_obj:vScreeningObj});
		setDlgformobjectiveshow(false);
	}
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentHeadermain = () => {
		if(uHtml500msg || uHeaderloading) return (
			<b>{uBahasaObj.caption_billingperiksa||"Billing Periksa"}</b>
		)//->

		return (
		<>
		<b className="d-none d-lg-inline">{uBahasaObj.caption_billingperiksa||"Billing Periksa"}: </b>
		<span className="text-info fw-bolder d-none d-md-inline">{uDatapasienObj.pasien_caption||"UNDF"}</span>
		<span className="text-info fw-bolder d-md-none">{UFunc.Usercaptionfilter(uDatapasienObj.pasien_caption)}</span>
		<span className="mx-1 d-none d-md-inline">&middot;</span>
		<b className="d-none d-md-inline" style={{color:((uDatapasienObj.sex||"L")==="P"?"pink":"navy")}}>
			[<span>{uDatapasienObj.sex||"L"}</span>]
		</b>

		{(uDatapasienObj.asuransi_caption||"")!=="" && (
			<span className="classfontsmaller d-none d-md-inline">
			<span className="mx-1">&middot;</span>
				<CBadge color="light" className="" style={{border:"1px solid purple"}}>
				<small className="fst-italic" style={{color:"purple"}}>{uDatapasienObj.asuransi_caption}</small>
				</CBadge>
			</span>
		)}
		</>
		)//->
	}
	const contentHeadersub = () => {
		if(uHeaderloading) return (<div className="text-center text-primary classblinking">Loading..</div>)//->
		if(uHtml500msg) return "";

		const vTgllahirDT 	= (uDatapasienObj.tgl_lahir||"")===""?null:UFunc.toDate(uDatapasienObj.tgl_lahir);
		const vTglnowDT		= new Date();
		const vISBirthdaytoday = vTgllahirDT 
			? (vTgllahirDT.getDate() === vTglnowDT.getDate() &&
				vTgllahirDT.getMonth() === vTglnowDT.getMonth()) : false;

		return (
		<>
		<div className="d-none d-md-flex justify-content-between classfontsmaller">
			<small className="d-block">
				{(uDatapasienObj.pekerjaan_caption||"")!=="" && (
				<>
					<b className="text-primary">{uDatapasienObj.pekerjaan_caption}</b>
					<span className="mx-1">&middot;</span>
				</>
				)}

				{(uDatapasienObj.tgl_lahir||"")!=="" && (
				<>
					({uDatapasienObj.umur||"0th"} - {UFunc.TglAngka(uDatapasienObj.tgl_lahir)}
					{vISBirthdaytoday && (
					<>
						<span className="ms-1">&middot;</span>
						<CTooltip className="d-none d-lg-block" content="--Pasien Berulang Tahun Hari Ini--">
						<CImage src={pjson.homepage+"api/images/icon_birthday.png"} className="classblinking" height={30}/>
						</CTooltip>
					</>
					)}
					)
					<span className="mx-1">&middot;</span>
				</>
				)}

				{(uDatapasienObj.kondisi_khusus||"").length >= 3 && (
				<>
				<span className="classblinking text-success">{uDatapasienObj.kondisi_khusus}</span>
				<span className="mx-1">&middot;</span>
				</>
				)}

				{(uDatamainObj.progress_keterangan||"")!=="" && (
				<span className="fst-italic text-danger">
					{uDatamainObj.progress_keterangan}
				</span>
				)}
			</small>
				
			{(uDatapasienObj.alergi||"").length >= 3 && (
			<>
				<div className="fst-italic text-warning d-none d-md-block d-lg-none">
					<span className="classblinking">&middot;&middot; Alergi: {uDatapasienObj.alergi} &middot;&middot;</span>
				</div>

				<div className="fst-italic text-end text-warning d-none d-lg-block w-50">
					<marquee>&middot;&middot; Alergi: {uDatapasienObj.alergi} &middot;&middot;</marquee>
				</div>
			</>
			)}
		</div>

		<div className="d-md-none text-center">
			{(!uHtml500msg) ? (
			<div>
				(<b>{UFunc.formatAngka(uItemsArr.length)}</b>)
				<span className="mx-1">&middot;</span>

				<small className="align-top">Rp</small>

				<small className="align-middle text-success fw-bold display-6">
					{UFunc.formatAngka(uDatamainObj.nilai_netto)}
				</small>
			</div>
			) : (
				<div className="align-middle text-success fw-bold py-1"/>
			)}
		</div>

		<div className="d-none d-md-block classborderbottom my-2"/>

		{(!uISCellphonemode) && (
		<CNav className="justify-content-md-center align-items-center border-bottom-0" variant="tabs">
			<CNavItem>
				<CNavLink href="#iddataperiksa" active={uActivetab==="iddataperiksa"} className="classcursorpointer py-1 px-2 px-lg-3" onClick={(e)=>hdlKlikNavtab(e,"iddataperiksa")}>
				<div className={""+(uActivetab==="iddataperiksa" ? " fw-bolder text-primary text-uppercase" : "")}>
					<span className="classfontsmaller d-lg-none"><small>1. Info Billing</small></span>
					<small className="d-md-none d-lg-inline">1. Info Billing</small>
				</div>
				</CNavLink>
			</CNavItem>
			<CNavItem>
				<CNavLink href="#iddatasoa" active={uActivetab==="iddatasoa"} className="classcursorpointer py-1 px-2 px-lg-3" onClick={(e)=>hdlKlikNavtab(e,"iddatasoa")}>
				<div className={""+(uActivetab==="iddatasoa" ? " fw-bolder text-primary text-uppercase" : "")}>
					<span className="classfontsmaller d-lg-none"><small>2. Data S.O.A</small></span>
					<small className="d-md-none d-lg-inline">2. Data S.O.A</small>
				</div>
				</CNavLink>
			</CNavItem>
			<CNavItem>
				<CNavLink href="#iddataplan" active={uActivetab==="iddataplan"} className="classcursorpointer py-1 px-2 px-lg-3" onClick={(e)=>hdlKlikNavtab(e,"iddataplan")}>
				<div className={""+(uActivetab==="iddataplan" ? " fw-bolder text-primary text-uppercase" : "")}>
					<span className="classfontsmaller d-lg-none"><small>3. Plan & Terapi</small></span>
					<small className="d-md-none d-lg-inline">3. Plan & Terapi ({uItemsArr.length})</small>
				</div>
				</CNavLink>
			</CNavItem>
			<CNavItem>
				<CNavLink href="#iddataodontogram" active={uActivetab==="iddataodontogram"} className="classcursorpointer py-1 px-2 px-lg-3" onClick={(e)=>hdlKlikNavtab(e,"iddataodontogram")}>
				<div className={""+(uActivetab==="iddataodontogram" ? " fw-bolder text-primary text-uppercase" : "")}>
					<span className="classfontsmaller d-lg-none"><small>4. Odontogram</small></span>
					<small className="d-md-none d-lg-inline">4. Odontogram</small>
				</div>
				</CNavLink>
			</CNavItem>
			<CNavItem>
				<CNavLink href="#iddataresep" active={uActivetab==="iddataresep"} className="classcursorpointer py-1 px-2 px-lg-3" onClick={(e)=>hdlKlikNavtab(e,"iddataresep")}>
				<div className={""+(uActivetab==="iddataresep" ? " fw-bolder text-primary text-uppercase" : "")}>
					<span className="classfontsmaller d-lg-none"><small>5. Resep Obat ({(uDatamainObj.resep_arr||[]).length})</small></span>
					<small className="d-md-none d-lg-inline">5. Resep Obat ({(uDatamainObj.resep_arr||[]).length})</small>
				</div>
				</CNavLink>
			</CNavItem>
			<CNavItem>
				<CNavLink href="#iddataakhir" active={uActivetab==="iddataakhir"} className="classcursorpointer py-1 px-2 px-lg-3" onClick={(e)=>hdlKlikNavtab(e,"iddataakhir")}>
				<div className={""+(uActivetab==="iddataakhir" ? " fw-bolder text-primary text-uppercase" : "")}>
					<span className="classfontsmaller d-lg-none"><small>6. Catatan Pasien</small></span>
					<small className="d-md-none d-lg-inline">6. Catatan Pasien</small>
				</div>
				</CNavLink>
			</CNavItem>
		</CNav>
		)}
		</>
		)//->
	}
	const contentTglPeriksa = () => {
		if(uHtml500msg) return "";

		return (
		<CCard className="h-100" id="idcardtanggal">
			<CCardHeader className="py-0 pt-1 classfontsmaller">
				<>Tgl Periksa</>
			</CCardHeader>

			<CCardBody className="text-center d-flex justify-content-center align-items-center">
			<div className="w-100">
			{!uISAdmininit ? (
				<span className="text-primary">{UFunc.HariAngka(uDatamainObj.tgl_periksa)}</span>
			) : (
				<small className="d-block">
				<span className="text-primary">{UFunc.HariAngka(uDatamainObj.tgl_periksa)}</span>

				<div className="my-1 classborderbottom"/>

				<CTooltip className="d-none d-lg-block" content="--Klik untuk Edit">
				<CLink onClick={()=>hdlKlikPilihtanggal()} className="classikontabel classikonedit classcursorpointer"/>
				</CTooltip>
				</small>
			)}
			</div>
			</CCardBody>
		</CCard>
		)//>
	}
	const contentDokter = () => {
		if(uHtml500msg) return "";

		return (
		<CCard className="classbgcard h-100" id="idcardtanggal">
			<CCardHeader className="py-0 pt-1 classfontsmaller">
				<>Dokter</>
			</CCardHeader>

			<CCardBody className="text-center d-flex justify-content-center align-items-center">
			<div className="w-100">
			{(uTokenObj.userhak === "DOKTER") ? (
				<span className="text-primary">{UFunc.Usercaptionfilter(uDatamainObj.nama_dokter,3)}</span>
			) : (
			<>
				{((uDatamainObj.nama_dokter||"")==="") ? (
					<CTooltip className="d-none d-lg-block" content="--Pilih Dokter..">
						<CButton onClick={()=>hdlKlikDokterlookup()} size="sm" className="p-1 classikonbox" color="light" id="btndokterpilih">
						<CImage src={pjson.homepage+"api/images/menus_dokter.png"} className="" height={30}/>
						</CButton>
					</CTooltip>
				) : (
				<>
					<span className="text-primary">{UFunc.Usercaptionfilter(uDatamainObj.nama_dokter,3)}</span>

					{uDatadokterArr.length > 1 && (
					<>
					<div className="my-1 classborderbottom"/>

					<div>
						<CTooltip className="d-none d-lg-block" content="--Klik Untuk Edit">
						<CLink onClick={()=>hdlKlikDokterlookup()} 
							className="classcursorpointer classikontabel classikonedit"/>
						</CTooltip>

						<CTooltip className="d-none d-lg-block" content="--Reset Dokter">
						<CLink onClick={async()=>{
							if(await(Konfirm("Apakah Yakin Mereset Dokter ?"))) {
								setDatamainObj({...uDatamainObj,
									nama_dokter: undefined,id_dokter: 0,
								});
							}
							}}
							className="classcursorpointer">
								<CIcon icon="cilSync" className="classikonbox mx-0 text-danger" height={23}/>
						</CLink>
						</CTooltip>
					</div>
					</>
					)}
				</>
				)}
			</>
			)}
			</div>
			</CCardBody>
		</CCard>
		)//>
	}
	const contentPerawat = () => {
		if(uHtml500msg) return "";

		return (
		<CCard className="classbgcard h-100" id="idcardtanggal">
			<CCardHeader className="py-0 pt-1 classfontsmaller">
				<>Perawat</>
			</CCardHeader>

			<CCardBody className="text-center d-flex justify-content-center align-items-center">
			<div className="w-100">
			{(uPerawatArr.length <= 0) ? (
				<CTooltip className="d-none d-lg-block" content="--Pilih Perawat..">
					<CButton onClick={()=>hdlKlikPerawattambah()} size="sm" className="p-0 classikonbox" color="light" id="btnperawat">
					<CImage src={pjson.homepage+"api/images/menus_perawat.png"} className="" height={35}/>
					</CButton>
				</CTooltip>
			) : (
			<>
				<div className="text-center">
					{uPerawatArr.map((vItems,vKeys)=>{
						return (
						<>
						{vKeys > 0 && (
							<span className="mx-1">&middot;</span>
						)}
						<span key={vKeys} className="text-primary fst-italic">{vItems.perawat_caption||""}</span>
						</>
						)
					})}
				</div>

				<div className="my-1 classborderbottom"/>

				<div>
				<CTooltip className="d-none d-lg-block" content="--Klik Untuk Edit">
				<CLink onClick={()=>hdlKlikPerawattambah()} 
					className="classcursorpointer classikontabel classikonedit"/>
				</CTooltip>

				<CTooltip className="d-none d-lg-block" content="--Reset Perawat">
					<CLink className="classcursorpointer"
						onClick={()=>hdlKlikPerawatclear()}>
						<CIcon icon="cilSync" className="classikonbox mx-0 text-danger" height={23}/>
					</CLink>
				</CTooltip>
				</div>
			</>
			)}
			</div>
			</CCardBody>
		</CCard>
		)//>
	}
	const contentSubjective = () => {
		if(uHtml500msg) return "";

		return (
		<CCard className="classbgcard h-100">
			<CCardHeader className="py-0 pt-1 classfontsmaller">
				<><b>(S)</b>ubjective</>
			</CCardHeader>

			<CCardBody className="text-center d-flex justify-content-center align-items-center">
			<div className="w-100">
			{((uDatamainObj.anamnase||"")==="") ? (
			<CTooltip className="d-none d-lg-block" content="--Input Form Subjective..">
				<CButton onClick={()=>hdlKlikSubjective()} size="sm" className="p-0 classikonbox" color="light" id="btnsubjective">
				<CImage src={pjson.homepage+"api/images/menus_anamnesa.png"} className="" height={35}/>
				</CButton>
			</CTooltip>
			) : (
			<>
				<div>
					<span className="text-primary">{uDatamainObj.anamnase}</span>
				</div>

				<div className="my-1 classborderbottom"/>

				<div>
					<CTooltip className="d-none d-lg-block" content="--Klik Untuk Edit">
					<CLink onClick={()=>hdlKlikSubjective()} 
						className="classcursorpointer classikontabel classikonedit"/>
					</CTooltip>

					<CTooltip className="d-none d-lg-block" content="--Clear Form Subjective">
					<CLink onClick={async()=>{
						if(await(Konfirm("Apakah Yakin MERESET Data Subjective ?"))) {
							/*uDatamainObj.anamnase 		= undefined;
							uDatamainObj.anamnase_id 	= undefined;
							uDatamainObj.subjective_obj = undefined;
							setUpdatefield(!uUpdatefield);//-*/
							setDatamainObj({...uDatamainObj,
								anamnase: undefined,
								anamnase_id: undefined,
								subjective_obj: undefined,
							})
						}
						}} 
						className="classcursorpointer">
							<CIcon icon="cilSync" className="classikonbox mx-0 text-danger" height={23}/>
					</CLink>
					</CTooltip>
				</div>
			</>
			)}
			</div>
			</CCardBody>
		</CCard>
		)//>
	}
	const contentObjective = () => {
		if(uHtml500msg) return "";

		return (
		<CCard className="classbgcard h-100">
			<CCardHeader className="py-0 pt-1 classfontsmaller">
				<><b>(O)</b>bjective</>
			</CCardHeader>

			<CCardBody className="text-center d-flex justify-content-center align-items-center">
			<div className="w-100">
				<div>
					<CFormInput size="sm" maxLength={100}
						placeholder="--Deskripsi Objective Pasien.."
						value={uDatamainObj.objective_teks||""}
						onChange={(e)=>{uDatamainObj.objective_teks=e.target.value;setUpdatefield(!uUpdatefield)}}
						id="inpobjectiveteks"/>
				</div>

				<div className="my-3 classborderbottom"/>

				<div className="text-center">
				<CTooltip content="--Form Objective" className="d-none d-lg-block">
				<CLink className="classcursorpointer" onClick={()=>hdlKlikObjective()}>
					<CImage src={pjson.homepage+"api/images/icon_objective.png"} className="classikonbox" height={35}/>
				</CLink>
				</CTooltip>

				{(uDatamainObj.screening_obj) && (
					<CTooltip className="d-none d-lg-block" content="--Reset Screening Objective">
					<CLink onClick={async()=>{
						if(await(Konfirm("Apakah Yakin Mereset Screening Objective ?"))) {
							setDatamainObj({...uDatamainObj,
								screening_obj: undefined
							});
						}
						}}
						className="classcursorpointer">
							<CIcon icon="cilSync" className="classikonbox mx-0 text-danger" height={23}/>
					</CLink>
					</CTooltip>
				)}
				</div>
			</div>
			</CCardBody>
		</CCard>
		)//>
	}
	const contentAssessment = () => {
		if(uHtml500msg) return "";
			
		const vDiagnosasekunderArr	= uDatamainObj.diagnosa_sekunder_arr || [];

		return (
		<CCard className="classbgcard h-100">
			<CCardHeader className="py-0 pt-1 classfontsmaller">
				<><b>(A)</b>sessment</>
			</CCardHeader>

			<CCardBody className="text-center d-flex justify-content-center align-items-center">
			<div className="w-100">
				<div>
					<CInputGroup size="sm">
					<CFormInput size="sm" readOnly={true}
						placeholder="--Pilih Diagnosa UTAMA ICD10"
						value={uDatamainObj.diagnosa_main_caption||""}
						onClick={()=>hdlKlikDiagnosalookup("DIAGNOSAMAIN")}
						id="inpdiagnosamainlookup"/>
					<CButton size="sm" color="dark"
						onClick={()=>hdlKlikDiagnosalookup("DIAGNOSAMAIN")}
						id="btndiagnosamainlookup">
						<CIcon icon="cilSearch"/>
					</CButton>
					</CInputGroup>
				</div>

				<div className="my-3 classborderbottom"/>

				<div className="">
					<CFormInput size="sm" maxLength={100}
						value={uDatamainObj.diagnosa_main_teks || ""}
						onChange={(e)=>{setDatamainObj({...uDatamainObj,diagnosa_main_teks:e.target.value});setUpdatefield(!uUpdatefield)}}
						placeholder="--Keterangan Assesment.."
						id="inpdiagnosamainteks"/>
				</div>
			</div>
			</CCardBody>
		</CCard>
		)//>
	}
	const contentPeriksamobile = () => {
		if(uHtml500msg) return "";

		return (
		<CForm>
		<CRow className="">
		<CCol xs="4" className="">Tgl Periksa</CCol>
		<CCol className="">
		{(uTokenObj.userhak === "FREEROLE" || uTokenObj.userhak === "ADMIN") ? (
			<>
			<CFormInput	size="sm" type="date"
				value={uDatamainObj.tgl_periksa||""}
				onChange={(e)=>{uDatamainObj.tgl_periksa=e.target.value;setUpdatefield(!uUpdatefield)}}
				id="inptglperiksa"/>
			<div className="d-none">tgl_periksa= {uDatamainObj.tgl_periksa}</div>
			</>
		) : (
			<b className="text-primary">{UFunc.HariAngka(uDatamainObj.tgl_periksa)}</b>
		)}
		</CCol>
		</CRow>

		{uTokenObj.userhak !== "DOKTER" && (
		<CRow className="my-1">
		<CCol xs="4" className="">Dokter</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			<CFormInput	size="sm"
				readOnly={true}
				onClick={()=>{ if(uDatadokterArr.length <= 1) return; hdlKlikDokterlookup(); }}
				value={uDatamainObj.nama_dokter||""}
				onChange={(e)=>{uDatamainObj.nama_dokter=e.target.value;setUpdatefield(!uUpdatefield)}}
				placeholder={"--"+(uBahasaObj.caption_pilihdokter||"Pilih Dokter").toUpperCase()+".."}
				id="inpdoktercaption"/>
			{uDatadokterArr.length > 1 && (
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikDokterlookup()}
				id="btndokterlookup">
				<CIcon icon="cilSearch"/>
			</CButton>
			)}
			</CInputGroup>
		</CCol>
		</CRow>
		)}
		</CForm>
		)//>
	}
	const contentFormheadermobile = () => {
		if(uHtml500msg) return "";

		return (
		<>
			<CCard className="classbgcard mb-3" id="idcardanamnase">
			<CCardHeader className="py-1 classfontsmaller"><small>Data Periksa</small></CCardHeader>
			<CCardBody className="">{contentPeriksamobile()}</CCardBody>
			</CCard>
		</>
		)//>
	}
	const contentPlanheader = () => {
		if(uHtml500msg) return "";

		if(isMobile || uISCellphonemode) return (
			<CButton size="sm" color="secondary"
				className="text-white my-1"
				onClick={()=>hdlKlikTambahitemmobile()}
				id="btnFormitem">
				<CIcon icon="cibAddthis" className="me-1 align-middle"/>
				<small>Tambah Terapi</small>
			</CButton>
		)

		return (<><b>(P)</b>lanning / Terapi</>)//->
	}
	const contentPlanitemdesktop = () => {
		if(uHtml500msg) return "";

		return (
		<>
		<div className="bg-dark mb-3">
		<table className="text-white table table-borderless" id="idtabelplanheader">
			<tbody>
			<tr className="align-top">
				<td width={30} className="text-center">
				<CImage src={pjson.homepage+"api2/images/icon_new.png"} height={30}/>
				</td>
				
				<td className="text-start">
					<CRow>
					<CCol md="6">
						<CInputGroup size="sm">
						<CFormInput size="sm" maxLength={255}
							value={uTambahitemObj.tindakan_caption||""}
							onChange={(e)=>setTambahitemObj({...uTambahitemObj,tindakan_caption:e.target.value})}
							placeholder={"--"+(uBahasaObj.caption_keywordtindakan||"Masukkan Keyword Tindakan ICD-9").toUpperCase()+".."}
							onKeyDown={(e)=>hdlKDownTindakanlookup(e)}
							id="inptambahitemtindakanlookup"/>
						<CButton size="sm" color="secondary"
							onClick={()=>hdlKlikTindakanlookup()}
							id="btntambahitemtindakanlookup">
							<CIcon icon="cilSearch"/>
						</CButton>
						</CInputGroup>
						<div className="classpetunjuk text-warning"><small>Tindakan ICD-9 CM</small></div>
					</CCol>

					<CCol>
						<CInputGroup className="" size="sm">
						<CFormTextarea size="sm" rows={4}
							className="classfontsmaller py-1"
							value={UFunc.br2nl(uTambahitemObj.tindakan_teks||"")}
							onChange={(e)=>setTambahitemObj({...uTambahitemObj,tindakan_teks:UFunc.nl2br(e.target.value)})}
							placeholder={"--"+(uBahasaObj.caption_deskripsiplanning||"Deskripsi PLAN")+".."}
							id="inptambahitemtindakanteks"/>
						</CInputGroup>

						{!isMobile && (
						<div className="classpetunjuk text-warning"><small>*) {uBahasaObj.petunjuk_textarea}</small></div>
						)}
					</CCol>
					</CRow>
				</td>

				<td width="18%" className="text-end">
					<b className="text-success">
						Rp{UFunc.formatAngka(uTambahitemObj.terapi_tarif)}
					</b>
				</td>
			</tr>

			<tr className="align-top">
				<td className="text-center">&nbsp;</td>
				
				<td className="text-start">
					<CRow>
					<CCol md="6">
						<CInputGroup size="sm">
						<CFormInput size="sm"
							value={uTambahitemObj.terapi_caption||""}
							onKeyDown={(e)=>hdlKDownTerapicaption(e)}
							onChange={(e)=>setTambahitemObj({...uTambahitemObj,terapi_caption:e.target.value})}
							placeholder={"--"+(uBahasaObj.caption_keywordterapi||"Masukkan Keyword Terapi").toUpperCase()+".."}
							id="inptambahitemcaption"/>
						<CButton size="sm" color="secondary"
							onClick={()=>hdlKlikTerapilookup()}
							id="btntambahitemlookup">
							<CIcon icon="cilMagnifyingGlass"/>
						</CButton>
						</CInputGroup>
						<div className="classpetunjuk text-warning"><small>Terapi</small></div>
					</CCol>
					
					<CCol className="d-flex align-items-start">
						<div className="" style={{minWidth:90,width:"20%"}}>
						<CInputGroup size="sm">
						<CFormInput size="sm" maxLength={3}
							type="number"
							className="text-end"
							value={uTambahitemObj.terapi_qty||0}
							onChange={(e)=>setTambahitemObj({...uTambahitemObj,terapi_qty:e.target.value})}
							onFocus={(e)=>e.target.select()}
							id="inptambahitemqty"/>
						</CInputGroup>
						<div className="classpetunjuk text-warning"><small>UNT</small></div>
						</div>

						<small className="mx-2">&middot;</small>

						<CInputGroup size="sm">
						<CFormInput size="sm" maxLength={255}
							placeholder="--Pilih Nomor Gigi.."
							value={uTambahitemObj.ketgigi||""}
							onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btntambahitemadd")}
							onChange={(e)=>setTambahitemObj({...uTambahitemObj,ketgigi:e.target.value})}
							id="inptambahitemketgigi"/>
						{(uTambahitemObj.ketgigi||"").trim() !== "" && (
						<CButton size="sm" color="light"
							className="classfontsmaller"
							onClick={()=>{
								setTambahitemObj({...uTambahitemObj,
									ketgigi: "",nomorgigi_arr:[],
								})
							}}
							id="btntambahitemketgigiclear">
							<CIcon icon="cilX"/>
						</CButton>
						)}
						<CButton size="sm" color="secondary"
							onClick={()=>hdlKlikketgigiview()}
							id="btntambahitemketgigi">
							<CIcon icon="cilMagnifyingGlass"/>
						</CButton>
						</CInputGroup>
					</CCol>
					</CRow>
				</td>

				<td className="text-end">
					<CButton size="sm" color="secondary"
						className="px-2 px-lg-4 fw-bolder text-white"
						onClick={()=>hdlKlikTambahitem()}
						id="btntambahitemadd">
						<CIcon icon="cibAddthis" className="me-1"/>Tambah
					</CButton>
				</td>
			</tr>
			</tbody>
		</table>
		</div>

		<table className="table table-borderless" id="idtabelplanitem">
			<thead>
			<tr className="align-top p-0">
				<th width={30} className="p-0"/>
				<th className="p-0"/>
				<th width="18%" className="p-0"/>
			</tr>
			</thead>

			<tbody>
			{uItemsArr.map((vItems,vKeys)=>{
				const {
					id_terapi_sub,caption_terapi,tarif_terapi,qty_terapi,diskon_terapi,
					tindakan_id,tindakan_caption,tindakan_teks,
					diagnosa_id,diagnosa_caption, keterangan,
					status_ada_garansi,tgl_batas_garansi
				} = vItems;

				const vIdxedit 		= uTabelitemObj.tabelidx===undefined
					? -1 : parseInt(uTabelitemObj.tabelidx);

				const vBgColor 		= vKeys%2===0 ? "#F0F0F0" : "#FFFFFF";
				const vBordercolor  = vKeys%2===0 ? "#DCDCDC" : "gray"; 

				return (
				<React.Fragment key={vKeys}>
				<tr className="align-top" style={{backgroundColor:vBgColor}}>
					<td className="px-1 text-end">{(vKeys+1)}.</td>
					
					<td className="px-1 text-start">
						<div>
							{(vIdxedit!==vKeys) ? (
							<>
							{(diagnosa_caption||"").trim()==="" ? (
								<span className="classpetunjuk px-0">
								&middot; {uBahasaObj.caption_diagnosasekunder||"Diagnosa Sekunder"} EMPTY &middot;
								</span>
							) : (
								<span className="text-capitalize">
									<b>{diagnosa_caption}</b>

									{(parseInt(diagnosa_id)||0) !== (parseInt(uDatamainObj.diagnosa_main_id)||0) && (
									<span className="classpetunjuk px-0 mx-1">(Diagnosa Sekunder)</span>
									)}

									<span className="mx-1">&middot;</span>

									<CLink onClick={()=>hdlKlikDiagnosasekunderhapus(vKeys)} className="classcursorpointer">
									<CIcon icon="cilX" className="classikonbox" height={20}/>
									</CLink>
								</span>
							)}
							</>
							) : (
							<CRow>
							<CCol md="6">
								<CInputGroup size="sm">
								<CFormInput size="sm" readOnly={true}
									value={uTabelitemObj.diagnosa_caption||""}
									onClick={()=>hdlKlikDiagnosasekunderlookup(vKeys)}
									placeholder="--Pilih Diagnosa Sekunder ICD-10"
									id="inptabelitemdiagnosasekunder"/>
								<CButton size="sm" color="dark"
									onClick={()=>hdlKlikDiagnosasekunderlookup(vKeys)}
									id="btntabelitemdiagnosalookup">
									<CIcon icon="cilSearch"/>
								</CButton>
								</CInputGroup>
							</CCol>
							</CRow>
							)}
						</div>

						<div className="classborderbottom my-2"/>

						<CRow className="align-items-start">
						{(vIdxedit!==vKeys) ? (
						<>
							<CCol md="6">
								{(tindakan_caption||"").trim()==="" ? (
									<small className="classpetunjuk px-0">&middot; {uBahasaObj.caption_tindakanicd9||"Tindakan ICD-9 CM"} EMPTY &middot;</small>
								) : (
									<div className="text-capitalize">{tindakan_caption}</div>
								)}
							</CCol>

							<CCol>
								{(tindakan_teks||"").trim()==="" ? (
									<small className="classpetunjuk px-0">&middot; {uBahasaObj.caption_deskripsiplanning||"Deskripsi PLAN"} EMPTY &middot;</small>
								) : (
									<span className="" style={{color:"maroon"}}>
									<small>{UFunc.renderHTML(tindakan_teks)}</small>
									</span>
								)}
							</CCol>
						</>
						) : (
						<>
							<CCol md="6">
							<CInputGroup size="sm">
							<CFormInput size="sm"
								placeholder={"--"+(uBahasaObj.caption_keywordtindakan||"Masukkan Keyword Tindakan ICD-9")+".."}
								value={uTabelitemObj.tindakan_caption||""}
								onChange={(e)=>setTabelitemObj({...uTabelitemObj,tindakan_caption:e.target.value})}
								onKeyDown={(e)=>hdlKDownTindakanlookup(e,vKeys)}
								id="inptabelitemtindakanlookup"/>
							<CButton size="sm" color="dark"
								onClick={()=>hdlKlikTindakanlookup(vKeys)}
								id={"btntabelitemtindakanlookup"+vKeys}>
								<CIcon icon="cilSearch"/>
							</CButton>
							</CInputGroup>
							</CCol>

							<CCol>
							<CFormTextarea size="sm" rows={3}
								className="classfontsmaller py-1"
								value={UFunc.br2nl(uTabelitemObj.tindakan_teks||"")}
								onChange={(e)=>setTabelitemObj({...uTabelitemObj,tindakan_teks:UFunc.nl2br(e.target.value)})}
								placeholder={"--"+(uBahasaObj.caption_deskripsiplanning||"Deskripsi PLAN")+".."}
								id={"inptabelitemtindakanteks"+vKeys}/>
							</CCol>
						</>
						)}
						</CRow>

						<div className="classborderbottom mt-2"/>
					</td>
					
					<td className="text-end">
						{(vIdxedit !== vKeys) ? (
						<>
							<div className="text-success">
								{UFunc.formatAngka(parseInt(qty_terapi) * 
									((parseFloat(tarif_terapi)||0) - (parseFloat(diskon_terapi)||0))
								)}
							</div>

							<div className="text-start mt-2">
								<CTooltip className="d-none d-lg-block" content={"--EDIT Item Terapi No-"+(vKeys+1)}>
								<CLink className="classcursorpointer classikontabel classikonedit"
									onClick={()=>hdlKlikTabeledit(vKeys)}/>
								</CTooltip>
								<span className="mx-1">&middot;</span>
								<CTooltip className="d-none d-lg-block" content={"--HAPUS Item Terapi No-"+(vKeys+1)}>
								<CLink className="classcursorpointer classikontabel classikonhapus"
									onClick={()=>hdlKlikTabelhapus(vKeys)}/>
								</CTooltip>
							</div>
						</>
						) : (
							<b className="text-warning d-none">{UFunc.formatAngka(parseInt(uTabelitemObj.qty_terapi || 1) * parseFloat(tarif_terapi))}</b>
						)}
					</td>
				</tr>

				<tr className="align-top" style={{backgroundColor:vBgColor,borderBottom:"1px dashed "+vBordercolor}}>
					<td className="px-1 text-end">&nbsp;</td>
					
					<td className="px-1 text-start">
					<CRow className="">
						{(vIdxedit!==vKeys) ? (
						<>
							<CCol md="6" className="text-info">{caption_terapi||"UNDF"}</CCol>

							<CCol className="">
							<span>
								<b className="text-primary">{qty_terapi||1}</b>unt
								<span className="mx-1">x</span>

								{(parseFloat(diskon_terapi)||0) <= 0 ? (
									<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>
								) : (
								<>
									<span>(</span>
									<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>
									<span>-</span>
									<span className="text-danger">{UFunc.formatAngka(diskon_terapi)}</span>
									<span>)</span>
								</>
								)}
							</span>

							<span className="mx-2">&middot;</span>

							{(keterangan||"").trim()==="" ? (
								<small className="classpetunjuk px-0">{uBahasaObj.caption_ketgigi||"Ket.Gigi"} EMPTY &middot;</small>
							) : (
								<span className="text-capitalize">{uBahasaObj.caption_ketgigi||"Ket.Gigi"}: <b>{keterangan}</b></span>
							)}
							</CCol>
						</>
						) : (
						<>
							<CCol md="12" lg="5">
								<small className="fw-bolder">{caption_terapi||"UNDF"}</small>
							</CCol>

							<CCol className="d-flex align-items-start">
								<CInputGroup style={{minWidth:90,width:"15%"}}
									size="sm">
								<CFormInput size="sm" type="number"
									className="text-end"
									value={uTabelitemObj.qty_terapi||1}
									onChange={(e)=>setTabelitemObj({...uTabelitemObj,qty_terapi:e.target.value})}
									onFocus={(e)=>e.target.select()}
									id="inptabelitemqty"/>
								<CInputGroupText className="px-1">UNT</CInputGroupText>
								</CInputGroup>

								<span className="ms-1">x</span>
								<span className="ms-1">(</span>
								<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>
								<b className="mx-1">-</b>

								<div style={{minWidth:110,width:"20%"}}>
									<NumberFormat 
										value={uTabelitemObj.diskon_terapi||"0"}
										displayType="text" 
										thousandSeparator="." 
										decimalSeparator=","
										allowNegative={false}
										onValueChange={(values) => uTabelitemObj.diskon_terapi=values.value}
										renderText={values => (
											<CFormInput size="sm" type="text"
												className="text-end text-danger"
												value={values}
												onChange={(e)=>setTabelitemObj({...uTabelitemObj,diskon_terapi:e.target.value})}
												onFocus={(e)=>e.target.select()}
												id="inptabelitemdiskon"/>
										)} 
									prefix=""/>
									<div className="classpetunjuk px-0">Disc.Max: {parseInt(uSystemsettingObj.persen_diskonmax)||100}%</div>
								</div>

								<span>)</span>

								<span className="mx-1 mx-lg-2">&middot;</span>

								<CInputGroup size="sm">
								<CFormInput size="sm" maxLength={255}
									placeholder={"--"+(uBahasaObj.caption_ketgigi||"Ket.Gigi")+".."}
									value={uTabelitemObj.keterangan||""}
									onChange={(e)=>setTabelitemObj({...uTabelitemObj,keterangan:e.target.value})}
									onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnTabelsimpan"+vKeys)}
									id={"inptabelketgigi"}/>

								{(uTabelitemObj.keterangan||"").trim() !== "" && (
								<CButton size="sm" color="light"
									className="classfontsmaller border"
									onClick={()=>{
										setTabelitemObj({...uTabelitemObj,
											keterangan: "",
											nomorgigi_arr:[],
										})
									}}
									id="btntabelketgigiclear">
									<CIcon icon="cilX"/>
								</CButton>
								)}
								<CButton size="sm" color="dark"
									onClick={()=>hdlKlikketgigiview(vKeys)}
									id={"btntabelitemketgigi"+vKeys}>
									<CIcon icon="cilMagnifyingGlass"/>
								</CButton>
								</CInputGroup>
							</CCol>
						</>
						)}
					</CRow>
					</td>
					
					<td className="text-center">
						{(vIdxedit === vKeys) && (
							<CButton size="sm" color="dark"
								className="fw-bold text-white"
								onClick={()=>hdlKlikTabelsimpan(vKeys)}
								id={"btnTabelsimpan"+vKeys}>
								<CIcon icon="cilCheckAlt"/> Simpan
							</CButton>
						)}
					</td>
				</tr>
				</React.Fragment>
				)//>
			})}
			</tbody>

			<tfoot>
			<tr className="fw-bolder bg-primary text-white">
				<td colSpan={2} className="text-end">J U M L A H</td>
				<td className="text-end">{UFunc.formatAngka(uDatamainObj.nilai_bruto)}</td>
			</tr>
			</tfoot>
		</table>
		</>
		)//>

		//---LAMA_TIDAK_DIPAKAI--/
		return (
		<>
		<CRow className="text-light mx-0 bg-dark mb-2 py-2">
		<CCol md="10" className="d-flex">
		<div style={{width:"3%",minWidth:35}} className="text-center px-1">
			<CImage src={pjson.homepage+"api/images/icon_new.png"} height={30}/>
		</div>

		<div style={{width:"97%"}} className="px-1">
			<div className="d-flex align-items-start">
				<div style={{minWidth:350,width:"50%"}}>
				<CInputGroup size="sm">
				<CFormInput size="sm"
					value={uTambahitemObj.terapi_caption||""}
					onKeyDown={(e)=>hdlKDownTerapicaption(e)}
					onChange={(e)=>setTambahitemObj({...uTambahitemObj,terapi_caption:e.target.value})}
					placeholder={"--"+(uBahasaObj.caption_keywordterapi||"Masukkan Keyword Terapi").toUpperCase()+".."}
					id="inptambahitemcaption"/>
				<CButton size="sm" color="secondary"
					onClick={()=>hdlKlikTerapilookup()}
					id="btntambahitemlookup">
					<CIcon icon="cilMagnifyingGlass"/>
				</CButton>
				</CInputGroup>
				<div className="classpetunjuk text-warning"><small>Terapi</small></div>
				</div>

				<div className="mx-2" style={{minWidth:70,width:"10%"}}>
				<CInputGroup size="sm">
				<CFormInput size="sm" maxLength={3}
					type="number"
					className="text-end"
					value={uTambahitemObj.terapi_qty||0}
					onChange={(e)=>setTambahitemObj({...uTambahitemObj,terapi_qty:e.target.value})}
					onFocus={(e)=>e.target.select()}
					id="inptambahitemqty"/>
				</CInputGroup>
				<div className="classpetunjuk text-warning"><small>UNT</small></div>
				</div>

				<CInputGroup style={{minWidth:100,width:"30%"}} size="sm">
				<CFormInput size="sm" maxLength={255}
					placeholder="--Pilih Nomor Gigi.."
					value={uTambahitemObj.ketgigi||""}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btntambahitemadd")}
					onChange={(e)=>setTambahitemObj({...uTambahitemObj,ketgigi:e.target.value})}
					id="inptambahitemketgigi"/>
				<CButton size="sm" color="secondary"
					onClick={()=>hdlKlikketgigiview()}
					id="btntambahitemketgigi">
					<CIcon icon="cilMagnifyingGlass"/>
				</CButton>
				</CInputGroup>

				<div className="d-md-none" style={{minWidth:100}}/>
			</div>

			<div className="classborderbottom my-2"/>

			<div className="d-flex align-items-start">
				<div style={{minWidth:350}} className="w-50">
				<CInputGroup size="sm">
				<CFormInput size="sm" maxLength={255}
					value={uTambahitemObj.tindakan_caption||""}
					onChange={(e)=>setTambahitemObj({...uTambahitemObj,tindakan_caption:e.target.value})}
					placeholder={"--"+(uBahasaObj.caption_keywordtindakan||"Masukkan Keyword Tindakan ICD-9").toUpperCase()+".."}
					onKeyDown={(e)=>hdlKDownTindakanlookup(e)}
					id="inptambahitemtindakanlookup"/>
				<CButton size="sm" color="secondary"
					onClick={()=>hdlKlikTindakanlookup()}
					id="btntambahitemtindakanlookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
				<div className="classpetunjuk text-warning"><small>Tindakan ICD-9 CM</small></div>
				</div>

				<span className="mx-1">&middot;</span>

				<div className="w-50">
				<CInputGroup className="" size="sm">
				<CFormTextarea size="sm" rows={3}
					className="classfontsmaller py-1"
					value={UFunc.br2nl(uTambahitemObj.tindakan_teks||"")}
					onChange={(e)=>setTambahitemObj({...uTambahitemObj,tindakan_teks:UFunc.nl2br(e.target.value)})}
					placeholder={"--"+(uBahasaObj.caption_deskripsiplanning||"Deskripsi PLAN")+".."}
					id="inptambahitemtindakanteks"/>
				</CInputGroup>
				<div className="classpetunjuk text-warning"><small>*) {uBahasaObj.petunjuk_textarea}</small></div>
				</div>

				<div className="d-md-none" style={{minWidth:100}}/>
			</div>
		</div>
		</CCol>

		<CCol md="2" className="text-end">
			<div className="text-success fw-bolder pb-3">Rp{UFunc.formatAngka(uTambahitemObj.terapi_tarif)}</div>
			
			<div className="mx-1">&nbsp;</div>

			<CButton size="sm" color="secondary"
				className="px-2 px-lg-4 fw-bolder text-white"
				onClick={()=>hdlKlikTambahitem()}
				id="btntambahitemadd">
				<CIcon icon="cibAddthis" className="me-1"/>Tambah
			</CButton>
		</CCol>
		</CRow>

		{uItemsArr.map((vItems,vKeys)=>{
			const {
				id_terapi_sub,caption_terapi,tarif_terapi,qty_terapi,
				tindakan_id,tindakan_caption,tindakan_teks,
				diagnosa_id,diagnosa_caption,
				keterangan,
				status_ada_garansi,tgl_batas_garansi
			} = vItems;

			const vIdxedit 		= uTabelitemObj.tabelidx===undefined
				? -1 : parseInt(uTabelitemObj.tabelidx);

			const vBgColor 		= vKeys%2===0 ? "#F0F0F0" : "#FFFFFF";
			const vBordercolor  = vKeys%2===0 ? "silver" : "gray"; 

			return (
			<div style={{backgroundColor:vBgColor,borderBottom:"1px dotted "+vBordercolor}}
				key={vKeys}>
			<CRow className="mx-0 py-2">
			<CCol md="9" lg="10" className="d-flex px-0">
				<div style={{width:"3%",minWidth:35}} 
					className="text-end px-1"><small>{(vKeys+1)}.</small></div>

				<div style={{minWidth:"50%",width:"calc(100% - 25px)",}}
					className="px-1">
					<div className="">
						{(vIdxedit!==vKeys) ? (
						<>
						{(diagnosa_caption||"").trim()==="" ? (
							<span className="classpetunjuk px-0">
							{uBahasaObj.caption_diagnosasekunder||"Diagnosa Sekunder"}: {"<EMPTY>"}
							</span>
						) : (
							<span className="text-capitalize">
								<b>{diagnosa_caption}</b>

								{(parseInt(diagnosa_id)||0) !== (parseInt(uDatamainObj.diagnosa_main_id)||0) && (
								<span className="classpetunjuk px-0 mx-1">(Diagnosa Sekunder)</span>
								)}

								<span className="mx-1">&middot;</span>

								<CLink onClick={()=>hdlKlikDiagnosasekunderhapus(vKeys)} className="classcursorpointer">
								<CIcon icon="cilX" className="classikonbox" height={20}/>
								</CLink>
							</span>
						)}
						</>
						) : (
						<div style={{width:"49%"}}>
						<CInputGroup size="sm">
						<CFormInput size="sm" readOnly={true}
							value={uTabelitemObj.diagnosa_caption||""}
							onClick={()=>hdlKlikDiagnosasekunderlookup(vKeys)}
							placeholder="--Pilih Diagnosa Sekunder ICD-10"
							id="inptabelitemdiagnosasekunder"/>
						<CButton size="sm" color="dark"
							onClick={()=>hdlKlikDiagnosasekunderlookup(vKeys)}
							id="btntabelitemdiagnosalookup">
							<CIcon icon="cilSearch"/>
						</CButton>
						</CInputGroup>
						</div>
						)}
					</div>
					
					<div className="classborderbottom my-2"/>

					<div className="">
						{(vIdxedit!==vKeys) ? (
						<>
							<span className="align-middle">{caption_terapi||"UNDF"}</span>
							<span className="mx-2">&middot;</span>

							<small className="align-middle">
								(<b className="text-primary">{qty_terapi||1}</b>unt
								<span className="mx-1">x</span>
								<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>)
							</small>

							<span className="mx-2">&middot;</span>

							{(keterangan||"").trim()==="" ? (
								<span className="classpetunjuk px-0 mx-0">
								<small>{uBahasaObj.caption_ketgigi||"Ket.Gigi"}: {"<EMPTY>"}</small>
								</span>
							) : (
								<small className="text-capitalize">{uBahasaObj.caption_ketgigi||"Ket.Gigi"}: <b>{keterangan}</b></small>
							)}
						</>
						) : (
						<>
							<div className="d-flex align-items-start">
							<small>{caption_terapi||"UNDF"}</small>
							<small className="me-1">:</small>
							<CInputGroup 
								style={{minWidth:100,width:"15%"}}
								size="sm">
							<CFormInput size="sm" type="number"
								className="ms-2 text-end"
								value={uTabelitemObj.qty_terapi||1}
								onChange={(e)=>setTabelitemObj({...uTabelitemObj,qty_terapi:e.target.value})}
								onFocus={(e)=>e.target.select()}
								id="inptabelitemqty"/>
							<CInputGroupText>unt</CInputGroupText>
							</CInputGroup>

							<span className="mx-2">&middot;</span>
							<CInputGroup 
								style={{minWidth:150,width:"30%"}}
								size="sm">
							<CFormInput size="sm" maxLength={255}
								placeholder={"--"+(uBahasaObj.caption_ketgigi||"Ket.Gigi")+".."}
								value={uTabelitemObj.keterangan||""}
								onChange={(e)=>setTabelitemObj({...uTabelitemObj,keterangan:e.target.value})}
								id={"inptabelketgigi"}/>
							<CButton size="sm" color="dark"
								onClick={()=>hdlKlikketgigiview(vKeys)}
								id={"btntabelitemketgigi"+vKeys}>
								<CIcon icon="cilMagnifyingGlass"/>
							</CButton>
							</CInputGroup>
							</div>
						</>
						)}
					</div>

					<div className="classborderbottom my-2"/>

					<div className="d-none d-md-flex align-items-start">
					{(vIdxedit!==vKeys) ? (
					<>
						<div style={{width:"50%"}}>
							{(tindakan_caption||"").trim()==="" ? (
								<small className="classpetunjuk px-0">{uBahasaObj.caption_tindakanicd9||"Tindakan ICD-9 CM"}: {"<EMPTY>"}</small>
							) : (
								<div className="text-capitalize">{tindakan_caption}</div>
							)}
						</div>

						<div className="text-center mx-2">&middot;</div>

						<div style={{maxWidth:"45%"}}>
							{(tindakan_teks||"").trim()==="" ? (
								<small className="classpetunjuk px-0">{uBahasaObj.caption_tindakanteks||"Deskripsi Tindakan"}: {"<EMPTY>"}</small>
							) : (
								<span className="" style={{color:"maroon"}}>
								<small>{UFunc.renderHTML(tindakan_teks)}</small>
								</span>
							)}
						</div>
					</>
					) : (
					<>
						<div style={{width:"49%"}}>
						<CInputGroup size="sm">
						<CFormInput size="sm"
							placeholder={"--"+(uBahasaObj.caption_keywordtindakan||"Masukkan Keyword Tindakan ICD-9")+".."}
							value={uTabelitemObj.tindakan_caption||""}
							onChange={(e)=>setTabelitemObj({...uTabelitemObj,tindakan_caption:e.target.value})}
							onKeyDown={(e)=>hdlKDownTindakanlookup(e,vKeys)}
							id="inptabelitemtindakanlookup"/>
						<CButton size="sm" color="dark"
							onClick={()=>hdlKlikTindakanlookup(vKeys)}
							id={"btntabelitemtindakanlookup"+vKeys}>
							<CIcon icon="cilSearch"/>
						</CButton>
						</CInputGroup>
						</div>

						<div className="text-center px-1">&middot;</div>

						<div style={{width:"50%"}} className="">
						<CFormTextarea size="sm" rows={3}
							className="classfontsmaller py-1"
							value={UFunc.br2nl(uTabelitemObj.tindakan_teks||"")}
							onChange={(e)=>setTabelitemObj({...uTabelitemObj,tindakan_teks:UFunc.nl2br(e.target.value)})}
							placeholder={"--"+(uBahasaObj.caption_tindakanteks||"Deskripsi Tindakan")+".."}
							onKeyDown={(e)=>{
								if(e.keyCode!==13) return;
								if(e.shiftKey) return;

								e.preventDefault();e.stopPropagation();

								document.getElementById("btnTabelsimpan"+vKeys) &&
									document.getElementById("btnTabelsimpan"+vKeys).focus();
							}}
							id={"inptabelitemtindakanteks"+vKeys}/>
						</div>
					</>
					)}
					</div>
				</div>
			</CCol>

			<CCol md="3" lg="2" className="text-center text-md-end px-1 px-md-2">
				<div className="text-end text-success">
				{(vIdxedit !== vKeys) ? (
					<>{UFunc.formatAngka(parseInt(qty_terapi) * parseFloat(tarif_terapi))}</>
				) : (
					<span className="text-danger">{UFunc.formatAngka(parseInt(uTabelitemObj.qty_terapi || 1) * parseFloat(tarif_terapi))}</span>
				)}
				</div>

				<div className="text-center mx-1">&nbsp;</div>

				{(vIdxedit !== vKeys) ? (
					<div className="text-end">
						<CTooltip className="d-none d-lg-block" content={"--EDIT Item Terapi No-"+(vKeys+1)}>
						<CLink className="classcursorpointer classikontabel classikonedit"
							onClick={()=>hdlKlikTabeledit(vKeys)}/>
						</CTooltip>
						<span className="mx-1">&middot;</span>
						<CTooltip className="d-none d-lg-block" content={"--HAPUS Item Terapi No-"+(vKeys+1)}>
						<CLink className="classcursorpointer classikontabel classikonhapus"
							onClick={()=>hdlKlikTabelhapus(vKeys)}/>
						</CTooltip>
					</div>
					) : (
					<div className="text-end">
						<CButton size="sm" color="dark"
							className="fw-bold text-white"
							onClick={()=>hdlKlikTabelsimpan(vKeys)}
							id={"btnTabelsimpan"+vKeys}>
							<CIcon icon="cilCheckAlt"/> Simpan
						</CButton>
					</div>
				)}
			</CCol>
			</CRow>
			</div>
			)
		})}

		{(uItemsArr.length > 0) && (
		<>
		<CRow className="mx-0 py-2 pb-3 mt-1 bg-primary border-top border-top-warning text-white">
			<CCol md="9" lg="10" className="text-start text-md-end fw-bolder pe-2">JUMLAH (Rp)</CCol>
			<CCol md="3" lg="2" className="ps-0 text-end fw-bolder">{UFunc.formatAngka(uDatamainObj.nilai_bruto)}</CCol>
		</CRow>

		<CRow className="mx-0 py-2 bg-light border border-top border-top-dark">
			<CCol md="9" lg="10" className="text-start text-md-end text-danger pe-2">
				Diskon &middot; <small className="fst-italic">Max {parseInt(uSystemsettingObj.persen_diskonmax)||100}%</small> (Rp)
			</CCol>
			<CCol md="3" lg="2" className="text-end fw-bolder">
			<NumberFormat 
				value={uDatamainObj.nilai_diskon||"0"}
				displayType={'text'} 
				thousandSeparator={"."} 
				decimalSeparator={","}
				onValueChange={(values) => uDatamainObj.nilai_diskon=values.value}
				renderText={values => (
					<CFormInput 
						value={values}
						size="sm"
						className="text-end"
						onChange={(e)=>{uDatamainObj.nilai_diskon=e.target.value;setUpdatefield(!uUpdatefield)}}
						onFocus={(e)=>e.target.select()}
					id="inpdiskon"/>
				)} 
			prefix=""/>
			</CCol>
		</CRow>
		</>
		)}
		</>
		)//>
		//---END LAMA_TIDAK_DIPAKAI--/
	}
	const contentPlanitemmobile = () => {
		if(uHtml500msg) return "";

		return (
		<table className="table" id="idtabelitemmobile">
		<thead>
			<tr>
			<th width={25} className="p-0"/>
			<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{uItemsArr.map((vItems,vKeys)=>{
			const {
				id_terapi_sub,caption_terapi,tarif_terapi,qty_terapi,diskon_terapi,
				tindakan_id,tindakan_caption,tindakan_teks,
				diagnosa_id,diagnosa_caption, keterangan,
				status_ada_garansi,tgl_batas_garansi
			} = vItems;

			return (
			<tr id={"idtr"+vKeys} className="align-top text-end" key={vKeys}>
			<td className="px-1 pe-0">{vKeys+1}.</td>
			<td className="px-1">
				<CRow className="mx-0">
				<CCol xs="12" className="px-1 text-start d-flex justify-content-between align-items-start">
					<div>
					{(diagnosa_caption||"")==="" ? (
						<div className="classpetunjuk px-0">&middot; Assesment Unselected &middot;</div>
					) : (
						<b className="text-capitalize">{diagnosa_caption}</b>
					)}
					</div>

					<CDropdown className="ps-1">
					<CDropdownToggle color="transparent" className="p-0" caret={false}>
						<CIcon icon="cilChevronBottom" className="classikonbox align-middle mx-0" height={25}/>
					</CDropdownToggle>

					<CDropdownMenu>
						<CDropdownItem onClick={()=>hdlKlikTabelEditmobile(vKeys)}>
						<CIcon className="me-2 align-middle classikonedit" height={25}/>Edit Data
						</CDropdownItem>

						<CDropdownDivider/>

						<CDropdownItem onClick={()=>hdlKlikTabelhapus(vKeys)}>
						<CIcon className="me-2 align-middle classikonhapus" height={25}/>Hapus Terapi
						</CDropdownItem>
					</CDropdownMenu>
					</CDropdown>
				</CCol>

				<CCol xs="12" className="px-1 my-3 classborderbottom"/>

				<CCol xs="4" className="px-1 text-start">
					<small>{uBahasaObj.caption_tindakanicd9||"Tindakan ICD9"}</small>
				</CCol>
				<CCol xs="8" className="px-1 text-end">
					{(tindakan_caption||"").trim()==="" ? (
						<div className="classpetunjuk px-0">&middot; {(uBahasaObj.caption_tindakanicd9 || "Tindakan ICD9")} Unselected &middot;</div>
					) : (
						<span className="text-capitalize">{tindakan_caption||"-"}</span>
					)}
				</CCol>

				<CCol xs="3" className="px-1 text-start" style={{color:"Maroon"}}>
					<small>{uBahasaObj.word_plan||"Plan"}</small>
				</CCol>
				<CCol xs="9" className="px-1 text-end" style={{color:"Maroon"}}>
					{(tindakan_teks||"").trim()==="" ? (
						<div className="classpetunjuk px-0">&middot; {(uBahasaObj.caption_deskripsiplanning || "Deskripsi Plan")} EMPTY &middot;</div>
					) : (
						<small>{UFunc.renderHTML(tindakan_teks||"-")}</small>
					)}
				</CCol>

				<CCol xs="12" className="px-1 my-3 classborderbottom"/>

				<CCol xs="12" className="px-1 text-start text-info">
					<>{(caption_terapi||"-")}</>
				</CCol>

				<CCol xs="12" className="px-1 my-3 classborderbottom"/>

				<CCol xs="4" className="px-1 text-start">
					<small>Detil Item</small>
				</CCol>
				<CCol xs="8" className="px-1 text-end">
					<b className="text-primary">{(qty_terapi)}</b>unt
					<span> x </span>

					{(parseFloat(diskon_terapi)||0) <= 0 ? (
						<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>
					) : (
					<>
						<span>(</span>
						<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>
						<span>-</span>
						<span className="text-danger">{UFunc.formatAngka(diskon_terapi)}</span>
						<span>)</span>
					</>
					)}
				</CCol>

				<CCol xs="4" className="px-1 text-start">
					<small>{uBahasaObj.caption_ketgigi||"Ket.Gigi"}</small>
				</CCol>
				<CCol xs="8" className="px-1 text-end">
					{(keterangan||"").trim()==="" ? (
						<div className="classpetunjuk px-0">&middot; Ket.Gigi EMPTY &middot;</div>
					) : (
						<span className="text-capitalize">{(keterangan||"-")}</span>
					)}
				</CCol>

				<CCol xs="12" className="px-1 my-3 classborderbottom"/>

				<CCol xs="4" className="px-1 text-start text-success">
					Nilai (Rp)
				</CCol>
				<CCol xs="8" className="px-1 text-end fw-bolder text-success">
					{UFunc.formatAngka(
						((parseFloat(tarif_terapi)||0) - (parseFloat(diskon_terapi)||0)) 
						* (parseFloat(qty_terapi)||0)
					)}
				</CCol>
				</CRow>
			</td>
			</tr>
			)//>
		})}
		</tbody>

		{(!uISCellphonemode) && (
		<tfoot>
			<tr className="bg-primary text-white fw-bolder">
				<td className="px-1"/>
				<td className="px-1">
				<CRow className="mx-0">
				<CCol xs="6" className="text-start px-1">JUMLAH (Rp)</CCol>
				<CCol xs="6" className="px-1 text-end">{UFunc.formatAngka(uDatamainObj.nilai_bruto)}</CCol>
				</CRow>
				</td>
			</tr>

			{(1==3) && (
			<tr className="bg-light classborderbottom">
				<td className="px-1"/>
				<td className="px-1">
				<CRow className="mx-0">
				<CCol className="text-start px-1 text-danger classfontsmaller">
					Diskon &middot; <small>Max:{parseInt(uSystemsettingObj.persen_diskonmax)||0}%</small> (Rp)
				</CCol>
				<CCol xs="6" md="4" className="px-1 text-end">
				<NumberFormat 
					value={uDatamainObj.nilai_diskon||"0"}
					displayType={'text'} 
					thousandSeparator={"."} 
					decimalSeparator={","}
					onValueChange={(values) => uDatamainObj.nilai_diskon=values.value}
					renderText={values => (
						<CFormInput 
							value={values}
							size="sm"
							className="text-end"
							onChange={(e)=>{uDatamainObj.nilai_diskon=e.target.value;setUpdatefield(!uUpdatefield)}}
							onFocus={(e)=>e.target.select()}
						id="inpdiskon"/>
					)} 
				prefix=""/>
				</CCol>
				</CRow>
				</td>
			</tr>
			)}
		</tfoot>
		)}
		</table>
		)//>
	}
	const contentResepform = () => {
		if(uHtml500msg) return "";
		if(isMobile) return "";

		let vSatuan = uTambahresepObj.satuan_kecil || "PCS";
		const vArrsatuan = vSatuan.split(" ");
		if(vArrsatuan.length > 3) {
			vSatuan = ((vArrsatuan[0]??"")+" "+
				(vArrsatuan[1]??"")+" "+
				(vArrsatuan[2]??"")+
				""
			).trim();
		}

		return (
		<div className="bg-dark mb-3 d-flex align-items-center p-3 text-white">
			<div style={{width:"3%",minWidth:35}} className="text-center px-1">
				<CImage src={pjson.homepage+"api\/images\/icon_new.png"} height={30}/>
			</div>

			<CInputGroup size="sm" style={{minWidth:300,width:"35%"}}>
				<CFormInput size="sm"
					placeholder="--Masukkan Keyword Obat KFA.."
					value={uTambahresepObj.nama_item||""}
					onChange={(e)=>setTambahresepObj({...uTambahresepObj,nama_item:e.target.value})}
					onKeyDown={(e)=>hdlKDownResepformcaption(e)}
					id="inpreseptambahobat"/>
				<CButton size="sm" color="secondary"
					onClick={()=>hdlKlikResepformlookup()}
					id="btnformresepobat">
					<CIcon icon="cilSearch"/>
				</CButton>
			</CInputGroup>
			
			<span className="mx-2"/>

			<CInputGroup size="sm" style={{minWidth:70,width:(vArrsatuan.length > 2 ? "15%" : "10%")}}>
				<CFormInput size="sm" type="number"
					value={uTambahresepObj.qty||"0"}
					onChange={(e)=>setTambahresepObj({...uTambahresepObj,qty:e.target.value})}
					onFocus={(e)=>e.target.select()}
					className="text-end"
					id="inpreseptambahqty"/>
				<CInputGroupText className="px-1"><small>{vSatuan}</small></CInputGroupText>
			</CInputGroup>

			<span className="mx-2">&middot;</span>

			<CButton size="sm" color="secondary"
				className="px-2 px-lg-4 fw-bolder text-white"
				onClick={()=>hdlKlikResepformtambah()}
				id="btnformreseptambah">
				<CIcon icon="cibAddthis" className="me-1"/>Tambah
			</CButton>
		</div>
		)//>
	}
	const contentReseptabel = () => {
		if(uHtml500msg) return "";

		return (
		<table className="table table-borderless table-striped" id="idtabelresepitem">
			<thead>
				<tr className="align-top text-center classfontsmaller d-none d-md-table-row p-0">
				<td className="px-0" width={30}><small>No</small></td>
				<td className="px-0">
				<CRow className="m-0">
					<CCol md="4" className="px-0 text-start"><small>Nama Obat KFA</small></CCol>
					<CCol md="2" className="px-0"><small>QTY</small></CCol>
					<CCol md="2" className="px-0"><small>Ketentuan</small></CCol>
					<CCol md="3" className="px-0 text-start" width="25%"><small>Aturan Tambahan</small></CCol>
					<CCol md="1" className="px-0"><small>&middot;</small></CCol>
				</CRow>
				</td>
				</tr>

				<tr className="align-top text-center classfontsmaller d-md-none p-0">
				<td className="p-0" width={30}/>
				<td className="p-0"/>
				</tr>
			</thead>

			<tbody>
			{(uDatamainObj.resep_arr || []).map((vItems,vKeys)=>{
				const {
					id_barang, nama_item, kfa_code, kfa_name,
					frekuensi,dosis, aturan, qty, satuan_kecil,
				} = vItems


				let vSatuan = satuan_kecil || "PCS";
				const vArrsatuan = vSatuan.split(" ");
				if(vArrsatuan.length > 3) {
					vSatuan = ((vArrsatuan[0]??"")+" "+
						(vArrsatuan[1]??"")+" "+
						(vArrsatuan[2]??"")+
						""
					).trim();
				}

				return (
				<tr className="align-top text-end" key={vKeys}>
					<td className="px-1">{vKeys+1}.</td>

					<td className="px-1 px-md-0">
					<CRow className="m-0">
					<CCol md="4" className="px-1 text-start d-flex justify-content-between align-items-start">
						<div className="text-info pe-1 pe-md-0">{nama_item}</div>

						<CDropdown className="d-md-none">
						<CDropdownToggle color="transparent" className="p-0" caret={false}>
							<CIcon icon="cilChevronBottom" className="classikonbox align-middle mx-0" height={25}/>
						</CDropdownToggle>

						<CDropdownMenu>
							<CDropdownItem onClick={()=>hdlKlikReseptabeleditmobile(vKeys)}>
							<CIcon className="me-2 align-middle classikonedit" height={25}/>Edit Obat
							</CDropdownItem>

							<CDropdownDivider/>

							<CDropdownItem onClick={()=>hdlKlikReseptabelhapus(vKeys)}>
							<CIcon className="me-2 align-middle classikonhapus" height={25}/>Hapus Obat
							</CDropdownItem>
						</CDropdownMenu>
						</CDropdown>
					</CCol>
					
					<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>
					
					<CCol xs="6" className="px-1 text-start d-md-none">
						<small>Jumlah</small>
					</CCol>
					<CCol xs="6" className="px-1 d-md-none">
						<b>{qty}</b>
						&nbsp;
						<span className="fst-italic">{vSatuan}</span>
					</CCol>

					<CCol md="2" className="px-1 text-md-center d-none d-md-block">
						{(uEditresepObj.field === "qty" && uEditresepObj.idxkey === vKeys && !isMobile) ? (
						<div className="px-lg-4">
						<CInputGroup size="sm">
							<CFormInput size="sm" type="number"
								style={{minWidth:40}}
								min={1}
								value={uEditresepObj.value}
								onChange={(e)=>setEditresepObj({...uEditresepObj,value:e.target.value})}
								onKeyDown={(e)=>hdlKDownReseptabelfield(e)}
								onFocus={(e)=>e.target.select()}
								className="text-end"
								id="inptabelresepedit"/>
							<CButton size="sm" color="dark"
								onClick={()=>hdlKlikReseptabeldone()}
								id="btntabelresepdone">
								<CIcon icon="cilCheckAlt"/>
							</CButton>
						</CInputGroup>
						</div>
						) : (
						<CTooltip content="--Klik Untuk Edit" className="d-none d-lg-block">
						<CLink onClick={()=>hdlKlikReseptabeledit(vKeys,"qty")} className="classcursorpointer">
							<b>{qty}</b>
							&nbsp;
							<span className="classfontsmaller">
								<small className="fst-italic">{vSatuan}</small>
							</span>
						</CLink>
						</CTooltip>
						)}
					</CCol>

					<CCol xs="6" className="px-1 text-start d-md-none">
						<small>Ketentuan</small>
					</CCol>
					<CCol xs="6" className="px-1 d-md-none">
						<b>{frekuensi}</b>
						<span>x</span>
						(<b>{dosis}</b>&nbsp;<span className="fst-italic">{vSatuan}</span>)
					</CCol>

					<CCol md="2" className="px-0 text-md-center d-none d-md-block">
						{(uEditresepObj.field === "ketentuan" && uEditresepObj.idxkey === vKeys && !isMobile) ? (
						<div className="px-lg-2">
						<CInputGroup size="sm">
							<CFormInput size="sm" type="number"
								style={{minWidth:40}}
								min={1}
								value={uEditresepObj.value}
								onChange={(e)=>setEditresepObj({...uEditresepObj,value:e.target.value})}
								onKeyDown={(e)=>{if(e.which===27){
									e.preventDefault(); e.stopPropagation();
									setEditresepObj({});
								}}}
								onFocus={(e)=>e.target.select()}
								className="text-end"
								id="inptabelresepedit"/>
							
							<CInputGroupText className="px-1 px-lg-2">x</CInputGroupText>

							<CFormInput size="sm" type="number"
								style={{minWidth:40}}
								min={1}
								value={uEditresepObj.dosis}
								onChange={(e)=>setEditresepObj({...uEditresepObj,dosis:e.target.value})}
								onKeyDown={(e)=>hdlKDownReseptabelfield(e)}
								onFocus={(e)=>e.target.select()}
								className="text-end"
								id="inptabelresepdosis"/>

							<CButton size="sm" color="dark"
								className="px-1 px-lg-2"
								onClick={()=>hdlKlikReseptabeldone()}
								id="btntabelresepdone">
								<CIcon icon="cilCheckAlt"/>
							</CButton>
						</CInputGroup>
						</div>
						) : (
						<CTooltip content="--Klik Untuk Edit" className="d-none d-lg-block">
							<CLink onClick={()=>hdlKlikReseptabeledit(vKeys,"ketentuan")} className="classcursorpointer">
							<small>
								<b>{frekuensi}</b>
								<span>x</span>
								(<b>{dosis}</b>&nbsp;<small className="fst-italic">{vSatuan}</small>)
							</small>
							</CLink>
						</CTooltip>
						)}
					</CCol>

					<CCol xs="3" className="px-1 text-start d-md-none">
						<small>Aturan</small>
					</CCol>
					<CCol xs="9" className="px-1 d-md-none">
						<i>{aturan || "-"}</i>
					</CCol>

					<CCol md="3" className="px-1 text-md-start fst-italic d-none d-md-block">
						{(uEditresepObj.field === "aturan" && uEditresepObj.idxkey === vKeys && !isMobile) ? (
						<div className="px-lg-">
						<CInputGroup size="sm">
							<CFormInput size="sm" maxLength={100}
								placeholder="--Contoh: Setelah Makan"
								value={uEditresepObj.value}
								onChange={(e)=>setEditresepObj({...uEditresepObj,value:e.target.value})}
								onKeyDown={(e)=>hdlKDownReseptabelfield(e)}
								id="inptabelresepedit"/>
							<CButton size="sm" color="dark"
								onClick={()=>hdlKlikReseptabeldone()}
								id="btntabelresepdone">
								<CIcon icon="cilCheckAlt"/>
							</CButton>
						</CInputGroup>
						</div>
						) : (
						<CTooltip content="--Klik Untuk Edit" className="d-none d-lg-block">
							<CLink onClick={()=>hdlKlikReseptabeledit(vKeys,"aturan")} className="classcursorpointer">
							{(aturan||"").trim() === "" ? (
								<CIcon icon="cilPencil" className="classikonbox" height={23}/>
							) : (
								<i>{aturan || "-"}</i>
							)}
							</CLink>
						</CTooltip>
						)}
					</CCol>
					
					<CCol md="1" className="px-1 text-md-center d-none d-md-block">
						{isMobile && (
						<CLink onClick={()=>hdlKlikReseptabeleditmobile(vKeys)}
							className="classcursorpointer classikontabel classikonedit"/>
						)}

						<CLink onClick={()=>hdlKlikReseptabelhapus(vKeys)}
							className="classcursorpointer classikontabel classikonhapus"/>
					</CCol>

					{1===3 && (
					<CCol xs="12" className="mt-3 d-none d-md-block classfontsmaller">
						{JSON.stringify(vItems)}
					</CCol>
					)}
					</CRow>
					</td>
				</tr>
				)//>
			})}
			</tbody>
		</table>
		)//>
	}
	const contentNote = () => {
		if(uHtml500msg) return "";

		return (
		<CCard className="classbgcard h-100">
			<CCardHeader className="py-1">
				<small>Catatan utk Pasien</small>
			</CCardHeader>

			<CCardBody className="">
			<div className="d-flex justify-content-between my-2">
				<div>
					<small className="d-lg-none">Catatan Dokter</small>
					<span className="d-none d-lg-block">Catatan Dokter</span>
				</div>

				<div style={{width:"60%"}} className="text-end">
					<CInputGroup size="sm">
					<CFormInput	size="sm" type="search"
						placeholder={"--"+(uBahasaObj.caption_pilihcatdokter||"Pilih Catatan Dokter")+".."}
						readOnly={true}
						onClick={()=>hdlKlikCatdokterlookup()}
						value={uDatamainObj.note_dokter||""}
						onChange={(e)=>{uDatamainObj.note_dokter=e.target.value;setUpdatefield(!uUpdatefield)}}
						id="inpcatdokter"/>
					{(uDatamainObj.note_dokter||"")!=="" && (
					<CButton size="sm" color="light"
						className="text-danger"
						onClick={()=>{uDatamainObj.note_dokter="";setUpdatefield(!uUpdatefield)}}
						id="btncatdokterclear">
						<CIcon icon="cilXCircle"/>
					</CButton>
					)}
					<CButton size="sm" color="dark"
						onClick={()=>hdlKlikCatdokterlookup()}
						id="btncatdokterlookup">
						<CIcon icon="cilMagnifyingGlass"/>
					</CButton>
					</CInputGroup>
				</div>
			</div>

			<div className="d-flex justify-content-between my-2">
				<div>
					<small className="d-lg-none">Cat.Tambahan</small>
					<span className="d-none d-lg-block">Cat.Tambahan</span>
				</div>

				<div style={{width:"60%"}} className="text-end">
					<CFormInput	size="sm" maxLength={255}
						value={uDatamainObj.note_nota||""}
						onChange={(e)=>{uDatamainObj.note_nota=e.target.value;setUpdatefield(!uUpdatefield)}}
						className="text-capitalize"
						id="inpcatatantambahan"/>
				</div>
			</div>
			</CCardBody>
		</CCard>
		)//>
	}
	const contentReservasidokter = () => {
		if(uHtml500msg) return "";

		return (
		<CCard className="classbgcard h-100">
			<CCardHeader className="py-1">
				<small>Reservasi Berikutnya</small>
			</CCardHeader>

			<CCardBody className="">
			<div className="text-center mb-1">
				<span>Janjian Berikutnya</span>
				<span className="mx-1">&middot;</span>
				<CTooltip className="d-none d-lg-block" content="--Input Janjian Berikutnya">
				<CLink className="classikon classikontambah classcursorpointer"
					onClick={()=>hdlKlikJanjiantambah()}/>
				</CTooltip>
			</div>
			
			<div className="my-1 classborderbottom"/>

			<div className="my-2">
				{uJanjianArr.length <= 0 ? (
					<div className="text-center">
					<small className="classpetunjuk">&middot; Belum ada Janjian Berikutnya &middot;</small>
					</div>
				) : (
				<ol className="ps-3">
					{uJanjianArr.map((vItems,vKeys)=>{
						const {
							id_cabang,id_antrian,no_ruang,tgl_antri,keterangan,jam_awal,
							id_dokter,
						} = vItems;

						const vDokteridx = UFunc.getObjectIndeks(uDatadokterArr,id_dokter);
						const vDoktercaption= vDokteridx >= 0 ? uDatadokterArr[vDokteridx].dokter_caption : "Undf";
						
						const vCabangidx = UFunc.getObjectIndeks(uDatacabangArr,id_cabang);
						const vCabangcaption= vCabangidx >= 0 ? uDatacabangArr[vCabangidx].cabang_nama : "Undf";

						return (
						<li key={vKeys}>
						<div className="d-flex justify-content-between">
						<div>
							<b>{UFunc.HariAngka(tgl_antri)}</b>
							{parseInt(no_ruang) > 0 && (
							<>
							<span className="mx-1">&middot;</span>
							(Rg-{no_ruang||"1"})
							</>
							)}
						</div>
						
						<div>
							{(jam_awal||"")!=="" && (
								<b>{(jam_awal||"")}</b>
							)}
							{parseInt(no_ruang) <= 0 && (
								<b>UMUM</b>
							)}

							{(parseInt(id_antrian)||0)<=0 && (
							<>
							<small className="mx-1">&middot;</small>
							<CTooltip className="d-none d-lg-block" content="--Hapus Janjian">
							<CLink
								className="classcursorpointer classikontabel classikonhapus"
								onClick={()=>hdlKlikJanjianhapus(vKeys)}/>
							</CTooltip>
							</>
							)}
						</div>
						</div>
						
						<div className="classfontsmaller">
							{(parseInt(uDatamainObj.id_dokter||"0") !== parseInt(id_dokter)) && (
							<>
							<small className="text-primary">{vDoktercaption}</small>
							<small className="mx-1">&middot;</small>
							</>
							)}
							
							<small className="">{vCabangcaption}</small>
						</div>

						{(keterangan||"").trim()!=="" && (
						<div className="fst-italic classfontsmaller text-capitalize"><small>{keterangan||""}</small></div>
						)}
						</li>
						)
					})}
				</ol>
				)}
			</div>
			</CCardBody>
		</CCard>
		)//>
	}
	const contentPage500 = () => {
		if(!uHtml500msg) return ""

		return (
			<CCard className="my-3 classbgcard">
			<CCardHeader><b>Page 500</b></CCardHeader>
			<CCardBody className="py-5">{UFunc.renderHTML(uHtml500msg)}</CCardBody>
			</CCard>
		)//>
	}
	const contentDlgview = () => {
		if(uHtml500msg) return "";
		if(!uIsDlgviewshow) return "";

		if(uDlgviewjenis === "KETGIGI") return contentDlgviewketgigi()

		return "";
	}
	const contentDlgviewketgigi = () => {
		if(uDlgviewjenis !== "KETGIGI") return "";

		return (
		<>
		<table width="100%" cellPadding={3} cellSpacing={0} className="fw-bolder">
			<tbody>
			<tr>
			<td align="left" colSpan={4}><CLink className="classcursorpointer ps-3 d-block bg-light text-decoration-none" style={{color:"Orange"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Paramolar KW I")}>Paramolar</CLink></td>
			<td align="center" colSpan={4}><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Blue"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Mesiodent")}>Mesiodent</CLink></td>
			<td className="p-0" rowSpan={9} width={1} bgcolor="Green"><CImage src={pjson.homepage+"api/images/img_spacer.png"} width={1}/></td>
			<td align="center" colSpan={4}><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Blue"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Mesiodent")}>Mesiodent</CLink></td>
			<td align="right" colSpan={4}><CLink className="classcursorpointer pe-3 d-block bg-light text-decoration-none" style={{color:"Orange"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Paramolar KW II")}>Paramolar</CLink></td>
			</tr>
			<tr>
			<td align="center" width="7%">&nbsp;</td>
			<td align="center" width="7%">&nbsp;</td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.55")}>55</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.54")}>54</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.53")}>53</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.52")}>52</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.51")}>51</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.61")}>61</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.62")}>62</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.63")}>63</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.64")}>64</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.65")}>65</CLink></td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="7%">&nbsp;</td>
			<td align="center" width="7%">&nbsp;</td>
			</tr>
			<tr>
			<td colSpan={8} align="center">&nbsp;</td>
			<td colSpan={8} align="center">&nbsp;</td>
			</tr>
			<tr>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.18")}>18</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.17")}>17</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.16")}>16</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.15")}>15</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.14")}>14</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.13")}>13</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.12")}>12</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.11")}>11</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.21")}>21</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.22")}>22</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.23")}>23</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.24")}>24</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.25")}>25</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.26")}>26</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.27")}>27</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.28")}>28</CLink></td>
			</tr>
			<tr height={1}>
			<td colSpan={8} align="center" className="p-0" height={1} style={{fontSize:1,backgroundColor:"green"}}>
				<CImage src={pjson.homepage+"api/images/img_spacer.png"} height={1}/>
			</td>
			<td colSpan={8} align="center" className="p-0" height={1} style={{fontSize:1,backgroundColor:"green"}}>
				<CImage src={pjson.homepage+"api/images/img_spacer.png"} height={1}/>
			</td>
			</tr>
			<tr>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.48")}>48</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.47")}>47</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.46")}>46</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.45")}>45</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.44")}>44</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.43")}>43</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.42")}>42</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.41")}>41</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.31")}>31</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.32")}>32</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.33")}>33</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.34")}>34</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.35")}>35</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.36")}>36</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.37")}>37</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.38")}>38</CLink></td>
			</tr>
			<tr>
			<td colSpan={8} align="center">&nbsp;</td>
			<td colSpan={8} align="center">&nbsp;</td>
			</tr>
			<tr>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.85")}>85</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.84")}>84</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.83")}>83</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.82")}>82</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.81")}>81</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.71")}>71</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.72")}>72</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.73")}>73</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.74")}>74</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.75")}>75</CLink></td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%">&nbsp;</td>
			</tr>
			<tr>
			<td align="left" colSpan={4}><CLink className="classcursorpointer ps-3 d-block bg-light text-decoration-none" style={{color:"Orange"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Paramolar KW IV")}>Paramolar</CLink></td>
			<td align="center" colSpan={4}><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Blue"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Mesiodent")}>Mesiodent</CLink></td>
			<td align="center" colSpan={4}><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Blue"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Mesiodent")}>Mesiodent</CLink></td>
			<td align="right" colSpan={4}><CLink className="classcursorpointer pe-3 d-block bg-light text-decoration-none" style={{color:"Orange"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Paramolar KW III")}>Paramolar</CLink></td>
			</tr>
			</tbody>
		</table>
		</>
		)//>
	}
	const contentDlgform = () => {
		if(!uIsDlgformshow) return "";

		if(uDlgformdataObj.jenis === "PILIHTANGGAL") return contentFormtanggal();
		if(uDlgformdataObj.jenis === "JANJIAN") return contentFormjanjian();
		if(uDlgformdataObj.jenis === "PILIHPERAWAT") return contentFormperawat();
		if(uDlgformdataObj.jenis === "FORMTERAPI") return contentFormitemmobile();
		if(uDlgformdataObj.jenis === "FORMRESEP") return contentFormresepmobile();
		//if(uDlgformdataObj.jenis === "FORMSUBJECTIVE") return contentFormsubjective();//--TIDAK_DIPAKAI--/

		return "";
	}
	const contentFormtanggal = () => {
		if(uDlgformdataObj.jenis !== "PILIHTANGGAL") return (<></>)//->

		return (
		<CForm className="mx-lg-5 px-lg-5">
		<CFormInput size="sm" type="date"
			value={uDlgformdataObj.tgl_periksa}
			onChange={(e)=>{uDlgformdataObj.tgl_periksa = e.target.value;setEfekview(!uEfekview)}}
			onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
			id="inpformtglperiksa"/>
		</CForm>
		)//->
	}
	const contentFormperawat = () => {
		if(uDlgformdataObj.jenis !== "PILIHPERAWAT") return (<></>)//->

		const vPerawatkwd	= (uDlgformdataObj.kwd_perawat||"").trim();
		const vPerawatviewArr= vPerawatkwd==="" ? uDataperawatArr
			: uDataperawatArr.filter(vItems => 
				((vItems.perawat_caption||"").toUpperCase()).includes(vPerawatkwd.toUpperCase()));//-*/

		return (
		<CForm className=""
			style={{marginRight:"-15px",marginLeft:"-15px",}}>
		<div className="mb-3 bg-light border p-3 px-lg-5 border-top border-bottom">
			<CFormInput size="sm"
				value={uDlgformdataObj.kwd_perawat||""}
				onChange={(e)=>{uDlgformdataObj.kwd_perawat = e.target.value;setEfekview(!uEfekview)}}
				placeholder="--Masukkan Keyword Perawat.."
				onKeyDown={(e)=>{
					if(e.keyCode === 40) {
						e.preventDefault()
						e.stopPropagation()
						document.getElementById("inpperawat0") &&
							document.getElementById("inpperawat0").focus();
						return;
					}
				}}
				id="inpperawatsearch"/>
		</div>

		<div style={{maxHeight:(window.innerHeight - 295),overflowY:"auto",overflowX:"hidden"}}
			className="px-3">
		{vPerawatviewArr.map((vItems,vKeys)=>{
			const {
				id,perawat_caption
			} = vItems; 

			return (
			<>
			<CInputGroup size="sm" className={"p-4 py-2 border"+
				(vKeys > 0 ? " border-top-0": "")+(uDlgformdataObj.init_keys===vKeys ? " bg-light text-black": "")+
				""
				}
				onMouseEnter={(e)=>{uDlgformdataObj.init_keys = vKeys;setEfekview2(!uEfekview2)}}
				onMouseLeave={(e)=>{uDlgformdataObj.init_keys = undefined;setEfekview2(!uEfekview2)}}
				key={vKeys}>
				<input type="checkbox" 
					value={id}
					checked={(uDlgformdataObj.perawatid_arr||[]).indexOf(id)>=0}
					onChange={(e)=>{
						const vValueID 	= e.target.value;
						const vValueidx = (uDlgformdataObj.perawatid_arr||[]).indexOf(vValueID);
						if(vValueidx < 0) {
							(uDlgformdataObj.perawatid_arr||[]).push(vValueID);
						} else {
							(uDlgformdataObj.perawatid_arr||[]).splice(vValueidx,1);
						}
						setEfekview2(!uEfekview2)
					}}
					onKeyDown={(e)=>{
						if(vKeys < vPerawatviewArr.length-1) return;

						UFunc.hdlKeyDownInput(e,"btnDialogSimpan");
					}}
					id={"inpperawat"+vKeys}/>
				<label htmlFor={"inpperawat"+vKeys} 
					className="ms-2 classcursorpointer">{perawat_caption}</label>
			</CInputGroup>
			</>
			) 
		})}
		</div>
		</CForm>
		)//>
	}
	const contentFormjanjian = () => {
		if(uDlgformdataObj.jenis !== "JANJIAN") return (<></>)//>

		const vCabangcaption	= uCabanginitObj.nama||"UNDF";

		return (
		<CForm className="mx-lg-5">
			<CRow className="mb-4 mx-0 mx-lg-5">
				<CCol className="py-3 border rounded">
				<div className="classpetunjuk">
					*) Masukkan Data-data Pendaftaran Pemeriksaan pada form di bawah ini, kemudian tekan SIMPAN.
					<br/>Jika Pasien Sudah Terdaftar pada Tanggal Tersebut, dan membutuhkan PERUBAHAN, Harap Hubungi FO.
				</div>
				</CCol>
			</CRow>

			{uDatacabangArr.length > 1 && (
			<CRow className="my-3">
			<CCol xs="4" className="text-md-end">{uBahasaObj.caption_unitcabang||"Unit Cabang"}</CCol>
			<CCol xs="8" lg="5" className="text-end text-md-start text-lg-start text-primary">
				<CFormSelect size="sm"
					value={uDlgformdataObj.id_cabang}
					onChange={(e)=>{uDlgformdataObj.id_cabang = e.target.value;setEfekview(!uEfekview)}}
					className=""
					id="inpformcabangid">
				{uDatacabangArr.map((vItems,vKeys)=>{
					return (
					<option key={vKeys} value={vItems.id}>{vItems.cabang_nama}</option>
					)
				})}
				</CFormSelect>
			</CCol>
			</CRow>
			)}

			<CRow className="my-2">
			<CCol xs="4" className="text-md-end fw-bold">{uBahasaObj.caption_tglantri||"Tgl Antri"}</CCol>
			<CCol xs="8" lg="5" className="text-end">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="date"
					value={uDlgformdataObj.tgl_antri||""}
					onChange={(e)=>{uDlgformdataObj.tgl_antri=(e.target.value);setEfekview(!uEfekview)}}
					id="inptglantri"/>
				<span className="me-2"/>

				<CInputGroupText className="bg-transparent py-0">
				<CTooltip className="d-none d-lg-block" content="--Cek TANGGAL ANTRIAN dulu..">
				<CLink className="classcursorpointer"
					onClick={()=>hdlKlikCekantriantoggle()}>
				<CImage src={pjson.homepage+"api/images/menus_antrianpasien.png"} height={23}/>
				</CLink>
				</CTooltip>
				</CInputGroupText>
				</CInputGroup>
			</CCol>
			</CRow>

			<div className="my-3 classborderbottom"/>

			<CRow className="my-2">
			<CCol xs="4" className="text-md-end text-success">
				<small className="d-md-none">{uBahasaObj.word_dokter||"Dokter"}</small>
				<span className="d-none d-md-block">{uBahasaObj.caption_dokterjanjian||"Dokter Janjian"}</span>
			</CCol>
			<CCol xs="8" lg="5" className="text-start fw-bolder text-primary">
				<CInputGroup size="sm">
				<CFormInput size="sm" readOnly={true}
					placeholder="--Pilih Dokter.."
					value={uDlgformdataObj.dokter_caption}
					onClick={()=>hdlKlikDokterjanjianlookup()}
					id="inpjanjiandoktercaption"/>
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikDokterjanjianlookup()}
					id="btnjanjiandokterlookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol xs="4" className="text-md-end text-success">{uBahasaObj.caption_jamjanjian||"Jam Janjian"}</CCol>
			<CCol xs="8" lg="4" className="text-start">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="time"
					min="07:00" max="22:00" 
					value={uDlgformdataObj.jam_awal||""}
					onChange={(e)=>{uDlgformdataObj.jam_awal=(e.target.value);setEfekview(!uEfekview)}}
					id="inpjamawal"/>
				<CInputGroupText className="py-0">s.d.</CInputGroupText>
				<CFormInput size="sm" type="time"
					min="07:00" max="22:00" 
					value={uDlgformdataObj.jam_akhir||""}
					onChange={(e)=>{uDlgformdataObj.jam_akhir=(e.target.value);setEfekview(!uEfekview)}}
					id="inpjamakhir"/>
				</CInputGroup>
				<div className="d-block d-lg-none classpetunjuk">
				*) Format 24hrs (09:00 atau 15.30)
				</div>
			</CCol>
			<CCol lg="4" className="d-none d-lg-block text-start classpetunjuk ps-0">
				*) Format 24hrs (09:00 atau 15.30)
			</CCol>
			</CRow>

			<CRow className="my-2">
			<CCol xs="4" className="text-md-end text-success">
				<small className="d-md-none">{uBahasaObj.word_ruangan||"Ruangan"}</small>
				<span className="d-none d-md-block">{uBahasaObj.caption_pilihruang||"Pilih Ruangan"}</span>
			</CCol>
			<CCol xs="8" lg="4" className="text-start">
				<CFormSelect size="sm"
					value={uDlgformdataObj.no_ruang||"1"}
					onChange={(e)=>{uDlgformdataObj.no_ruang=(e.target.value);setEfekview(!uEfekview)}}
					id="inpnoruang">
					{(() => {
						 let vOption = [];
						 for (let i = 1; i <= (parseInt(uCabanginitObj.jml_ruangan)||2); i++) {
						 	vOption.push(<option value={i} key={i}>Ruang No-{i}</option>);
						 }
						 return vOption;
					})()}
				</CFormSelect>
			</CCol>
			</CRow>

			<div className="my-3 classborderbottom"/>

			<CRow className="my-2">
			<CCol xs="4" className="text-md-end">{uBahasaObj.caption_ketantrian||"Ket.Antrian"}</CCol>
			<CCol xs="8" className="text-start">
				<CFormInput size="sm" maxLength={255}
					value={uDlgformdataObj.keterangan||""}
					onChange={(e)=>{uDlgformdataObj.keterangan=(e.target.value);setEfekview(!uEfekview)}}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpketantri"/>
			</CCol>
			</CRow>
		</CForm>
		)//>
	}
	const contentFormitemmobile = () => {
		if(uDlgformdataObj.jenis !== "FORMTERAPI") return (<></>)//>

		const vArridx = uDlgformdataObj.idxtabel===undefined 
			? -1 : parseInt(uDlgformdataObj.idxtabel);

		return (
		<CForm>
		<CRow className="my-1">
			<CCol xs="3" md="4">
				<small className="d-md-none">Diagnosa</small>
				<span className="d-none d-md-block">Diagnosa</span>
			</CCol>
			
			<CCol>
				<CInputGroup size="sm">
				<CFormInput size="sm"
					readOnly={true}
					value={uDlgformdataObj.diagnosa_caption||""}
					placeholder="--Pilih DIAGNOSA Sekunder.."
					onClick={()=>hdlKlikFormitemdiagnosalookup()}
					id="inpformitemdiagnosalookup"/>
				{(parseInt(uDlgformdataObj.diagnosa_id)||0) > 0 && (
					<CButton size="sm" color="light"
						className="border-secondary"
						onClick={()=>{
							setDlgformdataObj({
								...uDlgformdataObj,
								diagnosa_id: undefined,
								diagnosa_caption: undefined,
							})
						}}
						id="btnformitemdiagnosaclear">
						<CIcon icon="cilX" className="text-danger"/>
					</CButton>
				)}
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikFormitemdiagnosalookup()}
					id="btnformitemdiagnosalookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
			</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-1">
			<CCol xs="3" md="4">
				<small className="d-md-none">ICD-9</small>
				<span className="d-none d-md-block">Tindakan ICD9</span>
			</CCol>
			
			<CCol>
			<CInputGroup size="sm">
			<CFormInput size="sm" readOnly={true}
				value={uDlgformdataObj.tindakan_caption||""}
				placeholder="--Pilih Tindakan ICD9.."
				onClick={()=>hdlKlikFormitemtindakanlookup()}
				id="inpformitemtindakanlookup"/>
			{(parseInt(uDlgformdataObj.tindakan_id)||0) > 0 && (
				<CButton size="sm" color="light"
					className="border-secondary"
					onClick={()=>{
						setDlgformdataObj({
							...uDlgformdataObj,
							tindakan_id: undefined,
							tindakan_caption: undefined,
						})
					}}
					id="btnformitemdiagnosaclear">
					<CIcon icon="cilX" className="text-danger"/>
				</CButton>
			)}
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikFormitemtindakanlookup()}
				id="btnformitemtindakanlookup">
				<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-1">
			<CCol xs="3" md="4" style={{color:"maroon"}}>
				<small className="d-md-none">PLAN</small>
				<span className="d-none d-md-block">PLAN</span>
			</CCol>
			
			<CCol>
			<CFormTextarea size="sm" rows={4}
				className="classfontsmaller py-1"
				value={UFunc.br2nl(uDlgformdataObj.tindakan_teks)}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,tindakan_teks:UFunc.nl2br(e.target.value)})}
				placeholder={"--"+(uBahasaObj.caption_deskripsiplanning||"Deskripsi Plan")+".."}
				id="inpformitemtindakanteks"/>
			</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		{(vArridx < 0) ? (
		<CRow className="my-1">
			<CCol xs="3" md="4">
				<small className="d-md-none">Terapi</small>
				<span className="d-none d-md-block">Nama Terapi</span>
			</CCol>
			
			<CCol className="text-end">
				<CInputGroup size="sm">
				<CFormInput size="sm" readOnly={true}
					value={uDlgformdataObj.terapi_caption||""}
					placeholder={"--"+(uBahasaObj.caption_pilihterapi||"Pilih Terapi").toUpperCase()+".."}
					onClick={()=>hdlKlikFormitemlookup()}
					id="inpformitemcaption"/>
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikFormitemlookup()}
					id="btnformitemlookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
			</CCol>
		</CRow>
		) : (
		<>
			<div className="text-info">{uDlgformdataObj.terapi_caption}</div>
			<div className="my-3 classborderbottom"/>
		</>
		)}

		<CRow className="my-1">
			<CCol xs="3" md="4">
				<small className="d-md-none">Qty/Diskon</small>
				<span className="d-none d-md-block">Qty / Diskon</span>
			</CCol>

			<CCol xs="4" md="3" className="pe-1">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="number"
					value={uDlgformdataObj.terapi_qty||"0"}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,terapi_qty:e.target.value})}
					onFocus={(e)=>e.target.select()}
					className="text-end"
					id="inpformitemqty"/>
				<CInputGroupText>unt</CInputGroupText>
				</CInputGroup>
			</CCol>

			<CCol>
				<NumberFormat 
					value={uDlgformdataObj.terapi_diskon||"0"}
					displayType="text" 
					thousandSeparator="." 
					decimalSeparator=","
					allowNegative={false}
					onValueChange={(values) => uDlgformdataObj.terapi_diskon=values.value}
					renderText={values => (
						<CFormInput size="sm" type="text"
							className="text-end text-danger"
							value={values}
							onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,terapi_diskon:e.target.value})}
							onFocus={(e)=>e.target.select()}
							id="inpformitemdiskon"/>
					)} 
					prefix=""/>
				<div className="classpetunjuk px-0">Disc.Max: {parseInt(uSystemsettingObj.persen_diskonmax)||100}%</div>
			</CCol>
		</CRow>
			
		<CRow className="my-1">
			<CCol xs="3" md="4">
				<small className="d-md-none">Ket.Gigi</small>
				<span className="d-none d-md-block">Ket.Gigi</span>
			</CCol>

			<CCol>
			<CInputGroup size="sm">
			<CFormInput size="sm" maxLength={255}
				placeholder="Keterangan Gigi"
				value={uDlgformdataObj.ketgigi||""}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,ketgigi:e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inpformitemketgigi"/>
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikketgigiview()}
				id="btnformitemketgigi">
				<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
			</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
			<CCol xs="5" className="text-success">
				<small className="text-success d-md-none">Tarif (Rp)</small>
				<span className="text-success d-none d-md-block">Tarif Terapi (Rp)</span>
			</CCol>
			<CCol className="text-end text-success fw-bolder">
				{UFunc.formatAngka(
					(parseInt(uDlgformdataObj.terapi_qty)||0) * 
						((parseFloat(uDlgformdataObj.terapi_tarif)||0) - (parseFloat(uDlgformdataObj.terapi_diskon)||0))
				)}
			</CCol>
		</CRow>
		</CForm>
		)//>
	}
	const contentFormresepmobile = () => {
		if(uDlgformdataObj.jenis !== "FORMRESEP") return (<></>)//>

		const vArridx = uDlgformdataObj.idxtabel===undefined 
			? -1 : parseInt(uDlgformdataObj.idxtabel);
		
		let vSatuan = uDlgformdataObj.satuan_kecil || "PCS";

		return (
		<>
		<CForm id="idformresepdlg">
		<CRow className="my-1">
			<CCol xs="3" md="4">
				<small className="d-md-none">Obat</small>
				<span className="d-none d-md-block">Obat</span>
			</CCol>
			
			<CCol>
				<CInputGroup size="sm">
				<CFormInput size="sm"
					readOnly={true}
					value={uDlgformdataObj.nama_item||""}
					placeholder="--Pilih Obat.."
					onClick={()=>{ if(isMobile) hdlKlikFormresepitemlookup() }}
					id="inpformresepnama"/>
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikFormresepitemlookup()}
					id="btnformresepnamalookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-1">
			<CCol xs="3" md="4">
				<small className="d-md-none">QTY</small>
				<span className="d-none d-md-block">QTY</span>
			</CCol>

			<CCol xs="6" md="4">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="number" maxLength={4}
					value={uDlgformdataObj.qty||""}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,qty:e.target.value})}
					onFocus={(e)=>e.target.select()}
					className="text-end"
					id="inpformresepqty"/>
				<CInputGroupText>{vSatuan}</CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-1">
			<CCol xs="3" md="4">
				<small className="d-md-none">Ketentuan</small>
				<span className="d-none d-md-block">Ketentuan</span>
			</CCol>

			<CCol xs="9" md="6">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="number" maxLength={2}
					value={uDlgformdataObj.frekuensi||""}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,frekuensi:e.target.value})}
					onFocus={(e)=>e.target.select()}
					placeholder="-frekuensi-"
					className="text-end"
					id="inpformresepfrekuensi"/>
				<CInputGroupText className="px-1">x</CInputGroupText>
				<CFormInput size="sm" type="number" maxLength={2}
					value={uDlgformdataObj.dosis||""}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,dosis:e.target.value})}
					onFocus={(e)=>e.target.select()}
					placeholder="-dosis-"
					className="text-end"
					id="inpformresepdosis"/>
				<CInputGroupText><small>{vSatuan}</small></CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-1">
			<CCol xs="3" md="4">
				<small className="d-md-none">Aturan</small>
				<span className="d-none d-md-block">Aturan</span>
			</CCol>

			<CCol>
				<CFormInput size="sm" maxLength={100}
					value={uDlgformdataObj.aturan||""}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,aturan:e.target.value})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					className=""
					placeholder="--Contoh: Sesudah Makan"
					id="inpformresepaturan"/>
			</CCol>
		</CRow>
		</CForm>
		<div style={{height:window.innerHeight - 350}}/>
		</>
		)//>
	}
	const contentFloatantrian = () => {
		if(uHtml500msg) return "";
		if(!uCekantrianshow) return "";

		return (
		<>
		<div style={{
				position:"fixed",
				top:"1%",right:"1%",
				minWidth:300,
				width:"35%",
				zIndex:1091,
				backgroundColor:"#AEAEAE99",
				border:"1px dotted gray",
				borderRadius:10,
			}}
			className="d-none d-lg-block"
			id="idshowantrian">
			{contentShowantrian()}
		</div>

		<div style={{
				position:"fixed",
				top:"1%",right:"1%",
				minWidth:300,
				width:"50%",
				zIndex:1091,
				backgroundColor:"#AEAEAE99",
				border:"1px dotted gray",
				borderRadius:10,
			}}
			className="d-none d-md-block d-lg-none"
			id="idshowantrian">
			{contentShowantrian()}
		</div>

		<div style={{
				position:"fixed",
				top:"1%",right:"1%",
				minWidth:300,
				width:"98%",
				zIndex:1091,
				backgroundColor:"#AEAEAE",
				border:"1px dotted gray",
				borderRadius:10,
			}}
			className="d-md-none"
			id="idshowantrian">
			{contentShowantrian()}
		</div>
		</>
		)//>
	}
	const contentShowantrian = () => {
		if(!uCekantrianshow) return "";

		//--> [{"dokter_id":"99","dokter_caption":"AGNES ENDRA, SpPros, DRG","pasien_id":"43371","pasien_caption":"Andy","pasien_telp":null,"jam_awal":"11:15:00","jam_hadir":null,"no_urut":"0","keterangan":"Ini Ketarangan Antrian","id":"26"}]
		const vAntrianjanjianArr= uCekDataantrianArr.filter(vItems=>parseInt(vItems.no_urut)<=0);
		const vAntrianumumArr 	= uCekDataantrianArr.filter(vItems=>parseInt(vItems.no_urut)>0);

		return (
		<div className="position-relative" style={{
			padding:15,
			minHeight:window.innerHeight-50,
			height:window.innerHeight-20,
			}}>
			<div style={{position:"absolute",top:-1,left:-1,zIndex:10}}>
			<CButton size="sm" color="transparent" className="p-1 fw-bolder classcursorpointer"
				onClick={()=>setCekantrianshow(false)}
				id="btncekantriclose">
			<CIcon icon="cilXCircle" className="text-danger" height={30}/>
			</CButton>
			</div>
		<CCard className="classbgcard w-100 h-100">
		<CCardHeader className="text-center">
			<small className="fw-bolder">CEK Antrian Pasien</small>
			<div className="classborderbottom my-2"/>
			<CForm className="mx-3">
			<CInputGroup size="sm">
				{uDatacabangArr.length > 1 && (
				<CFormSelect size="sm"
					value={uCekantrianObj.id_cabang||uDlgformdataObj.id_cabang}
					onChange={(e)=>{uCekantrianObj.id_cabang=e.target.value;setEfekview(!uEfekview)}}
					id="inpcekcabangid">
				{uDatacabangArr.map((vItems,vKeys)=>{
					return (
					<option value={vItems.id} key={vKeys}>{vItems.cabang_nama}</option>
					)
				})}
				</CFormSelect>
				)}
				<CFormInput size="sm" type="date"
					value={uCekantrianObj.tgl_antri || uDlgformdataObj.tgl_antri}
					onChange={(e)=>{uCekantrianObj.tgl_antri=e.target.value;setEfekview(!uEfekview)}}
					id="inpcektglantri"/>
				<CButton size="sm" color="secondary"
					onClick={()=>hdlKlikCekantrianview()}
					id="btncekantri">
					<CIcon icon="cilMagnifyingGlass"/>
				</CButton>
			</CInputGroup>
			</CForm>
		</CCardHeader>

		<CCardBody style={{overflowY:"auto"}}>
			{(uCekantrianObj.isLoading||false)==true ? (
				<center><CSpinner className="mx-auto" color="blue"/></center>
			) : (
			<>
			{(uCekantrianObj.errormsg||"")!=="" ? (
				<div className="classfontsmaller text-center">{UFunc.renderHTML(uCekantrianObj.errormsg)}</div>
			) : (
				<small>
				{vAntrianjanjianArr.length > 0 && (
				<>
				<div className="px-2 mb-1 fw-bolder text-white" 
					style={{backgroundColor:"#666699"}}>Antrian Janjian</div>
				{vAntrianjanjianArr.map((vItems,vKeys)=>{
					const {
						dokter_id,dokter_caption,pasien_id,pasien_caption,jam_awal,no_urut,keterangan
					} = vItems;

					const vListyle	= {
						borderBottom: "1px dotted black"
					}
					if(parseInt(pasien_id)===parseInt(uPasienID))
						vListyle.backgroundColor = "#FF510044";

					return (
					<div style={vListyle} key={vKeys}>
					<CRow className="mx-0 pb-1">
						<CCol md="1" className="px-0 text-end">{vKeys+1}.</CCol>
						<CCol md="9">
							<div><b>{vItems.pasien_caption}</b></div>
							<small className="text-primary classfontsmaller fst-italic">{vItems.dokter_caption}</small>
						</CCol>
						<CCol md="2" className="px-0 text-center">
							<b>{(vItems.jam_awal||"").substring(0,5)}</b>
						</CCol>
					</CRow>
					</div>
					)
				})}
				</>
				)}

				{vAntrianumumArr.length > 0 && (
				<>
				<div className="px-2 mb-1 fw-bolder text-white" 
					style={{backgroundColor:"#993366"}}>Antrian Umum</div>
				{vAntrianumumArr.map((vItems,vKeys)=>{
					const {
						dokter_id,dokter_caption,pasien_id,pasien_caption,jam_awal,no_urut,keterangan
					} = vItems;

					const vListyle	= {
						borderBottom: "1px dotted black"
					}
					if(parseInt(pasien_id)===parseInt(uPasienID))
						vListyle.backgroundColor = "#FF510044";

					return (
					<div style={vListyle} key={vKeys}>
					<CRow className="mx-0 pb-1">
						<CCol md="1" className="px-0 text-end">{vKeys+1}.</CCol>
						<CCol md="9">
							<div><b>{vItems.pasien_caption}</b></div>
						</CCol>
						<CCol md="2" className="px-0 text-center">
							No-<b>{(vItems.no_urut)}</b>
						</CCol>
					</CRow>
					</div>
					)
				})}
				</>
				)}
				</small>
			)}
			</>
			)}
		</CCardBody>
		</CCard>
		</div>
		)
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoadawal = async() => {
		setHtml500msg();

		setDatapasienObj({})
		setHeaderloading(true);
		setLoading(true);
		try {
			setSessionaktif(false);
			const vHeaderObj= {
				headers: { Accept: "application/json", "Content-Type": "application/json" },
				method: "POST",
				mode: "cors",
				cache: "default",
			}

			setTimeelapse(0);
			const vTimeBegin = new Date();
			const [output_progress,
			output_pasien,
			output_perawat,
			output_dokternote,
			output_terapi,
			output_diagnosa,
			output_dokter,
			output_janjian,
			] = await Promise.all([
				(async () => {
					const vURLs	= pjson.homepage+"api2/api_periksa/ld_init";
					const vDATAS= JSON.stringify({
						send_pasienid : uPasienID,
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response was not ok.');
					return response.json();
				})(),

				(async () => {
					const vURLs	= pjson.homepage+"api2/api_pasien/ld_pasiendata";
					const vDATAS= JSON.stringify({
						send_pasienid : uPasienID,
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response was not ok.');
					return response.json();
				})(),
					
				(async () => {
					const vURLs			= pjson.homepage+"api2/api_perawat/ld_lookup";
					const vDATAS		= JSON.stringify({
						send_tokenauth: uTokenObj.userinit
					});

					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response was not ok.');
					return response.json();
				})(),
					
				(async () => {
					const vURLs			= pjson.homepage+"api2/api_dokternote/ld_lookup";
					const vDATAS		= JSON.stringify({
						send_tokenauth: uTokenObj.userinit
					});

					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response was not ok.');
					return response.json();
				})(),
					
				(async () => {
					const vURLs			= pjson.homepage+"api2/api_terapi/ld_lookup";
					const vDATAS		= JSON.stringify({
						send_tokenauth: uTokenObj.userinit
					});

					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response was not ok.');
					return response.json();
				})(),
					
				(async () => {
					const vURLs			= pjson.homepage+"api2/api_diagnosa/ld_lookup";
					const vDATAS		= JSON.stringify({
						send_tokenauth: uTokenObj.userinit
					});

					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response was not ok.');
					return response.json();
				})(),
					
				(async () => {
					const vURLs			= pjson.homepage+"api2/api_dokter/ld_lookup";
					const vDATAS		= JSON.stringify({
						send_tokenauth: uTokenObj.userinit
					});

					//if(uTokenObj.userhak === "DOKTER") return {};

					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response was not ok.');
					return response.json();
				})(),
					
				(async () => {
					const vURLs			= pjson.homepage+"api2/api_dokter/ld_janjian";
					const vDATAS		= JSON.stringify({
						send_pasienid: uPasienID,
						send_tokenauth: uTokenObj.userinit
					});

					if(uTokenObj.userhak !== "DOKTER") return {};

					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response was not ok.');
					return response.json();
				})()
			]);

			setSessionaktif(true);

			//--OUTPUT_PROGRESS--/
			if(output_progress.tampil) {
				setDatapasienObj(JSON.parse(output_progress.datapasien||"{}"))
				setDatamainObj({
					...uDatamainObj,
					progress_id: parseInt(output_progress.progress_id) || 0,
					progress_dokterid: parseInt(output_progress.progress_dokterid) || 0,
					progress_keterangan: output_progress.progress_keterangan || "",
					screening_obj: output_progress.progress_screeningstr ? JSON.parse(output_progress.progress_screeningstr) : undefined,
				})
			} else if(output_progress.info) {
				setHtml500msg(output_progress.info); return;
			} else if(output_progress.errors) {
				console.log("(Periksa - apiLoadawal) output_progress.errors : "+output_progress.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_progress.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div className='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_progress.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END OUTPUT_PROGRESS--/

			//--OUTPUT_PASIEN--/
			if(output_pasien.tampil) {
				setDatapasienObj(JSON.parse(output_pasien.datapasien||"{}"))
			} else if(output_pasien.info) {
				setHtml500msg(output_pasien.info); return;
			} else if(output_pasien.errors) {
				console.log("(Periksa - apiLoadawal) output_pasien.errors : "+output_pasien.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_pasien.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div className='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_pasien.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END OUTPUT_PASIEN--/

			//--OUTPUT_PERAWAT--/
			if(output_perawat.tampil) {
				setDataperawatArr(JSON.parse(output_perawat.dataperawat||"[]"))
			} else if(output_perawat.info) {
				setHtml500msg(output_perawat.info); return;
			} else if(output_perawat.errors) {
				console.log("(Periksa - apiLoadawal) output_perawat.errors : "+output_perawat.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_perawat.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div className='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_perawat.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END OUTPUT_PERAWAT--/

			//--DOKTERNOTE--/
			if(output_dokternote.tampil) {
				setDatacatdokterArr(JSON.parse(output_dokternote.datanotedokter||"[]"))
			} else if(output_dokternote.info) {
				setHtml500msg(output_dokternote.info); return;
			} else if(output_dokternote.errors) {
				console.log("(Periksa - apiLoadawal) output_dokternote.errors : "+output_dokternote.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_dokternote.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div className='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_dokternote.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END DOKTERNOTE--/

			//--TERAPI--/
			if(output_terapi.tampil) {
				setDataterapiArr(JSON.parse(output_terapi.dataterapi||"[]"))
			} else if(output_terapi.info) {
				setHtml500msg(output_terapi.info); return;
			} else if(output_terapi.errors) {
				console.log("(Periksa - apiLoadawal) output_terapi.errors : "+output_terapi.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_terapi.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div className='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_terapi.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END TERAPI--/

			//--DIAGNOSA--/
			if(output_diagnosa.tampil) {
				setDatadiagnosaArr(JSON.parse(output_diagnosa.datadiagnosa||"[]"))
			} else if(output_diagnosa.info) {
				setHtml500msg(output_diagnosa.info); return;
			} else if(output_diagnosa.errors) {
				console.log("(Periksa - apiLoadawal) output_diagnosa.errors : "+output_diagnosa.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_diagnosa.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div className='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_diagnosa.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END DIAGNOSA--/

			//--DOKTER--/
			if(output_dokter.tampil) {
				setDatadokterArr(JSON.parse(output_dokter.datadokter||"[]"))
			} else if(output_dokter.info) {
				setHtml500msg(output_dokter.info); return;
			} else if(output_dokter.errors) {
				console.log("(Periksa - apiLoadawal) output_dokter.errors : "+output_dokter.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_dokter.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div className='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_dokter.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END DOKTER--/

			//--DOKTERJANJIAN--/
			if(output_janjian.tampil) {
				setDatajanjianArr(JSON.parse(output_janjian.datajanjian||"[]"))
			} else if(output_janjian.info) {
				setHtml500msg(output_janjian.info); return;
			} else if(output_janjian.errors) {
				console.log("(Periksa - apiLoadawal) output_janjian.errors : "+output_janjian.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_janjian.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div className='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_janjian.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END DOKTERJANJIAN--/

			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setTimeelapse(vTimeDiff);
		} catch (error) {
			console.log("(Periksa - apiLoadawal) catch-error : "+error.message);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		} finally {
			setHeaderloading(false);
			setLoading(false);
		}
	}
	const _apiLoadawal_ = () => {//--TIDAK_DIPAKAI--/
		setHtml500msg();

		setDatapasienObj({})
		setHeaderloading(true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_pasienid : uPasienID,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_periksa/ld_init";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setHeaderloading(false);
			setLoading(false);
			if(output_string.tampil) {
				setDatapasienObj(JSON.parse(output_string.datapasien||"{}"))
				setDatadokterArr(JSON.parse(output_string.datadokter||"[]"))
				setDataperawatArr(JSON.parse(output_string.dataperawat||"[]"))
				setDatacatdokterArr(JSON.parse(output_string.datanotedokter||"[]"))
				setDataterapiArr(JSON.parse(output_string.dataterapi||"[]"))
				setDatajanjianArr(JSON.parse(output_string.datajanjian||"[]"))
				setDataitemcicilanArr(JSON.parse(output_string.dataitemcicilan||"[]"))
				setDatadiagnosaArr(JSON.parse(output_string.datadiagnosa||"[]"))

				uDatamainObj.progress_id 		 = parseInt(output_string.progress_id || "0");
				uDatamainObj.progress_dokterid 	 = parseInt(output_string.progress_dokterid || "0");
				uDatamainObj.progress_keterangan = output_string.progress_keterangan || "";
				
				//console.log("(Periksa - apiLoadawal) "+(output_string.datadokter||"[]"))
				setEfekview(!uEfekview);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Periksa - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div className='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			setHeaderloading(false);
			setLoading(false);
			console.log("(Periksa - apiLoadawal) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiJanjianchecking = () => {
		const vElsimpan	= document.getElementById("btnDialogSimpan")
		vElsimpan && (vElsimpan.disabled = true);
		setLoading(true);

		const vDATAS	= JSON.stringify({
			send_pasienid: uPasienID,
			send_dataformantri : JSON.stringify(uDlgformdataObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_periksa/pr_cekinputantri";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				const vTmpObj = {
					id_cabang: uDlgformdataObj.id_cabang||uCabanginitObj.id_cabang,
					tgl_antri: uDlgformdataObj.tgl_antri||"",
					id_dokter: uDlgformdataObj.dokter_id||"0",
					jam_awal: uDlgformdataObj.jam_awal||"",
					jam_akhir: uDlgformdataObj.jam_akhir||"",
					no_ruang: uDlgformdataObj.no_ruang||"1",
					keterangan: uDlgformdataObj.keterangan||"",
				}

				uDatamainObj.janjian_arr = [...uJanjianArr,vTmpObj];
				setUpdatefield(!uUpdatefield);
				hdlToggleDlgform()
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Periksa - apiJanjianchecking) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			console.log("(Periksa - apiJanjianchecking) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR")
		});
	}
	const apiLoadantrian = () => {
		uCekantrianObj.errormsg 	= "";
		uCekantrianObj.isLoading 	= true;
		setEfekview(!uEfekview);

		const vDATAS	= JSON.stringify({
			send_cabangid : uCekantrianObj.id_cabang||uDlgformdataObj.id_cabang,
			send_tglantri : uCekantrianObj.tgl_antri||uDlgformdataObj.tgl_antri,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_antrian/ld_data";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			uCekantrianObj.isLoading = false;
			if(output_string.tampil) {
				//console.log("(Periksa - apiLoadantrian) output_string.dataobject : "+output_string.dataobject);
				const vTmpArr =  JSON.parse(output_string.dataobject || "[]");
				uCekantrianObj.antrian_arr = vTmpArr;
				if(vTmpArr.length <= 0)
					uCekantrianObj.errormsg = "<div className='classpetunjuk'>&middot; Data Antrian Tidak Ada &middot;</div>";
				setEfekview2(!uEfekview2);
			} else if(output_string.info) {
				uCekantrianObj.errormsg = (output_string.info);
				setEfekview2(!uEfekview2);
			} else if(output_string.errors) {
				console.log("(Periksa - apiLoadantrian) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				uCekantrianObj.errormsg = ("<font color='red'>"+vMsg+"</font>");
				setEfekview2(!uEfekview2);
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			uCekantrianObj.isLoading = false;
			uCekantrianObj.errormsg = ("<font color='red'>"+(pjson.mydefault.msg500str.join(" "))+"</font>");
			setEfekview2(!uEfekview2)
			console.log("(Rekammedis - apiLoadantrian) catch-error : "+error);
		});
	}
	const apiSimpanmain = () => {
		const vElsimpan	= document.getElementById("btnSimpanmain")
		vElsimpan && (vElsimpan.disabled = true);
		setLoading(true);


		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			showToast(uBahasaObj.pesan_periksasukses||"Berhasil","SUKSES");
			//uNavigate(uUrlbefore,{replace:true});
		},2500);return;//-*/

		const vDATAS	= JSON.stringify({
			send_pasienid: uPasienID,
			send_datamain : JSON.stringify(uDatamainObj),
			send_dataodontogram : JSON.stringify(uOdontograminputArr),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_periksa/pr_simpanmain";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				uDispatch({type: "set", gBillingperiksaObj: undefined});
				uDispatch({type: "set", gOdontograminputArr: undefined});
				showToast((uBahasaObj.pesan_periksasukses||"Berhasil"),"SUKSES");
				uNavigate(uUrlbefore,{replace:true}); return;
			} else if(output_string.periksa_invalid) {
				uDispatch({type: "set", gBillingperiksaObj: undefined});
				uDispatch({type: "set", gOdontograminputArr: undefined});
				showToast(output_string.periksa_invalid);
				uNavigate(uUrlbefore,{replace:true}); return;
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Periksa - apiSimpanmain) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			console.log("(Periksa - apiSimpanmain) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR")
		});
	}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{
		document.addEventListener("keydown",hdlKDownDocument);

		return ()=>{
			document.removeEventListener("keydown",hdlKDownDocument);
		}
	})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gDatasubjective: undefined});
		uDispatch({type: "set", gDataobjective: undefined});

		apiLoadawal();

		return () => {
			setDlgviewshow(false); setDlgformshow(false);setDlgformsubjectiveshow(false);
			setDlgformsubjectiveshow(false);
			setDatadiagnosaArr([]);setTabelitemObj({});setTambahitemObj({});
			setTambahresepObj({}); setEditresepObj({});
    		setDatapasienObj({});
    		setDatadokterArr([]);
    		setDataperawatArr([]);
    		setDatacatdokterArr([]);
    		setDatajanjianArr([]);
    	}
	},[]);
	React.useEffect(()=>{ 
		uDispatch({type: "set", gBillingperiksaObj: uDatamainObj}); 
	},[uUpdatefield])
	React.useEffect(()=>{
		if(uDatamainObj.tgl_periksa===undefined) {
			setDatamainObj({...uDatamainObj,
				tgl_periksa: UFunc.DbDate(),
			});
			setUpdatefield(!uUpdatefield);
		}
	},[uDatamainObj,uDatamainObj.tgl_periksa]);
	React.useEffect(()=>{
		//--JIKA_YG_LOGIN_DOKTER--/
		if(uTokenObj.userhak === "DOKTER") {
			if(uDatamainObj.id_dokter === undefined) {
				setDatamainObj({...uDatamainObj,
					id_dokter: parseInt(uTokenObj.user_dokterid)||0,
					nama_dokter: uTokenObj.usercaption||"",
				});
				setUpdatefield(!uUpdatefield);
			}
			return;
		}
		//--END JIKA_YG_LOGIN_DOKTER--/

		//--JIKA_DOKTERARR_CUMAN_1--/
		if(uDatadokterArr.length === 1) {
			if(uDatamainObj.id_dokter === undefined) {
				setDatamainObj({...uDatamainObj,
					id_dokter: parseInt(uDatadokterArr[0].id)||0,
					nama_dokter: (uDatadokterArr[0]||{}).dokter_caption||"",
				});
				setUpdatefield(!uUpdatefield);
			}
			return;
		}
		//--END JIKA_DOKTERARR_CUMAN_1--/
	},[uDatamainObj,uDatamainObj.id_dokter])
	React.useEffect(()=>{
		const vDokterid = parseInt(uDatamainObj.progress_dokterid)||0;
		if(vDokterid <= 0 || uDatadokterArr.length <= 0) return;
		if(uDatamainObj.id_dokter !== undefined) return;

		const vDokteridx = UFunc.getObjectIndeks(uDatadokterArr,vDokterid);
		setDatamainObj({...uDatamainObj,
			id_dokter: vDokterid,
			nama_dokter: (uDatadokterArr[vDokteridx]||{}).dokter_caption || "",
		});
		setUpdatefield(!uUpdatefield);
	},[uDatamainObj.progress_dokterid]);
	React.useEffect(()=>{
		if(uJanjianArr.length <= 0 && uDatajanjianArr.length > 0) {
			setDatamainObj({...uDatamainObj,
				janjian_arr: uDatajanjianArr,
			});
			setUpdatefield(!uUpdatefield);

			return;
		}
	},[uDatamainObj,uJanjianArr,uDatajanjianArr]);

	React.useEffect(()=>{
		if(uItemsArr.length <= 0) {
			setDatamainObj({
				...uDatamainObj,
				nilai_bruto: undefined,
			})

			setUpdatefield(!uUpdatefield); 
			return;
		}

		setDatamainObj({...uDatamainObj,
			nilai_bruto: uItemsArr.reduce((vAkumulator, vItems) => {
				return vAkumulator + 
					(((parseFloat(vItems.tarif_terapi)||0) - (parseFloat(vItems.diskon_terapi)||0)) 
						* (parseInt(vItems.qty_terapi)||0)
					);
			}, 0),
		});

		setUpdatefield(!uUpdatefield); 
	},[uItemsArr.length,uTabelitemObj,uIsDlgformshow])
	React.useEffect(()=>{
		const vMaxpersen 	= parseFloat(uSystemsettingObj.persen_diskonmax) || 0;
		const vMaxdiskon	= (vMaxpersen <= 0 ? 1 : (vMaxpersen/100)) 
			* (parseInt(uDatamainObj.nilai_bruto)||0)
		const vDiskon 		= (parseInt(uDatamainObj.nilai_diskon)||0)
		if(vDiskon > vMaxdiskon) {
			uDatamainObj.nilai_diskon = vMaxdiskon;
			setUpdatefield(!uUpdatefield);			
		}
	},[uDatamainObj.nilai_diskon])
	React.useEffect(()=>{
		const vNetto = (parseInt(uDatamainObj.nilai_bruto)||0)
			- (parseInt(uDatamainObj.nilai_diskon)||0)

		uDatamainObj.nilai_netto = vNetto;
		setUpdatefield(!uUpdatefield);
	},[uDatamainObj.nilai_bruto,uDatamainObj.nilai_diskon])
	React.useEffect(()=>{
		if(!uTabelitemObj.idxtabel) return;
		if(!uTabelitemObj.diskon_terapi) return;

		const vMaxpersen 	= parseFloat(uSystemsettingObj.persen_diskonmax) || 0;
		const vMaxdiskon	= (vMaxpersen <= 0 ? 1 : (vMaxpersen/100)) 
			* (parseFloat(uTabelitemObj.tarif_terapi)||0);

		const vDiskon 		= parseFloat(uTabelitemObj.diskon_terapi)||0;

		if(vDiskon > vMaxdiskon) {
			setTabelitemObj({...uTabelitemObj,
				diskon_terapi: vMaxdiskon,
			});
		}
	},[uTabelitemObj.diskon_terapi])
	React.useEffect(()=>{
		if(uDatamainObj.tgl_periksa !== UFunc.DbDate()
			|| (uDatamainObj.anamnase||"").trim() !== ""
			|| (uDatamainObj.note_dokter||"").trim() !== ""
			|| (uDatamainObj.note_nota||"").trim() !== ""
			|| (parseInt(uDatamainObj.id_dokter)||0) !== (parseInt(uTokenObj.user_dokterid)||0)
			|| (parseInt(uDatamainObj.nilai_diskon)||0) > 0
			|| (uDatamainObj.diagnosa_main_caption||"").trim() !== ""
			|| (parseInt(uDatamainObj.diagnosa_main_id)||0) > 0
			|| uPerawatArr.length > uDatajanjianArr.length
			|| (uDatamainObj.diagnosa_sekunder_arr||[]).length > 0
			|| uItemsArr.length > 0
			|| uJanjianArr.length > 0
			|| uOdontograminputArr.length > 0
			) setIsFormupdate(true);
		else setIsFormupdate(false);
	},[uDatamainObj.tgl_periksa,
	uDatamainObj.id_dokter,
	uDatamainObj.anamnase,
	uDatamainObj.diagnosa_main_caption,
	uDatamainObj.diagnosa_main_id,
	(uDatamainObj.diagnosa_sekunder_arr||[]).length,
	uPerawatArr.length,
	uItemsArr.length,
	uDatamainObj.note_dokter,
	uDatamainObj.note_nota,
	uDatamainObj.nilai_diskon,
	uJanjianArr.length,
	uOdontograminputArr.length
	])
	React.useEffect(()=>{
		/*let vElfocus;
		if(uActivetab==="iddataplan") {
			vElfocus = document.getElementById("inptambahitemtindakanlookup");
		}
		else if(uActivetab==="iddataakhir") {
			vElfocus = document.getElementById("inpcatdokter");
		}

		vElfocus && vElfocus.focus();//-*/

		const handleScroll = () => {
    		if (window.isManualScrolling) {
    			if (uActivetab !== 'iddataperiksa') setActivetab('iddataperiksa');
    			return;
    		}

			const headerHeight 		= document.getElementById("idheadermain").offsetHeight;

			const offset 			= document.getElementById("idheadermain").offsetHeight;// Adjust this to match your sticky header height + a little extra buffer
			const scrollPosition 	= window.scrollY + headerHeight;

			const scrolledTo = window.scrollY + window.innerHeight;
			const isAtBottom = scrolledTo >= document.documentElement.scrollHeight;

			const sections = document.querySelectorAll('section[id]');

			sections.forEach((section) => {
				const sectionTop 		= section.offsetTop - (section.offsetTop * 0.15);
				const sectionHeight 	= section.offsetHeight;
				const id 				= section.getAttribute('id');

				if(isAtBottom) {
					setActivetab(sections[sections.length-1].id);
					window.history.replaceState(null, '', `#${sections[sections.length-1].id}`);
					return;
				}

				if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
					// IMPORTANT: Only update if the section actually changed
					// This prevents the infinite loop/crash you had earlier
					if (uActivetab !== id && !isAtBottom) {
						setActivetab(id);
						// Update URL bar without a full React Router navigation crash
						window.history.replaceState(null, '', `#${id}`);
					} 
		    	}
		    });
		};
		window.addEventListener('scroll', handleScroll, { passive: true });
		
		return () => window.removeEventListener('scroll', handleScroll);
	},[uActivetab]);
	React.useEffect(()=>{
		if(!uISDlgformsubjectivesimpan) return;
		uDispatch({type: "set", gISSubjectivesimpan: undefined});

		//console.log("(Periksa [uISDlgformsubjectivesimpan]) uDatasubjectiveObj => "+JSON.stringify(uDatasubjectiveObj))
		initKlikformsubjective();
	},[uISDlgformsubjectivesimpan]);
	React.useEffect(()=>{
		if(!uISDlglookupshow) {
			setDlglookupObj({}); return;
		}
	},[uISDlglookupshow])
	React.useEffect(()=>{
		if(!uISDlglookupapishow) {
			setDlglookupapiObj({});
			return;
		}
	},[uISDlglookupapishow])
	React.useEffect(()=>{
		if(!uIsDlgviewshow) {
			setDlgviewheader("");
			setDlgviewjenis("");
			return;
		}
	},[uIsDlgviewshow])
	React.useEffect(()=>{
		if(!uIsDlgformshow) {
			setDlgformdataObj({})
			setCekantrianshow(false)
			return;
		}

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			let vElfocus = document.getElementById("inptglantri");
			if(uDlgformdataObj.jenis === "FORMTERAPI")
				vElfocus = document.getElementById("inpformterapicaption");
			else if(uDlgformdataObj.jenis === "PILIHTANGGAL")
				vElfocus = document.getElementById("inpformtglperiksa");
			else if(uDlgformdataObj.jenis === "PILIHPERAWAT")
				vElfocus = document.getElementById("inpperawatsearch");

			if(!isMobile) vElfocus && vElfocus.focus();		
		},350)
	},[uIsDlgformshow])
	React.useEffect(()=>{
		if(!uISDlgformobjectivesimpan) return;
		uDispatch({type: "set", gISObjectivesimpan: undefined});

		initProsesscreening();
	},[uISDlgformobjectivesimpan]);
	React.useEffect(()=>{ 
		if(!uCekantrianshow) {
			setCekantrianObj({});
			setEfekview(!uEfekview); 
			return
		}
		apiLoadantrian();

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			document.getElementById("btncekantriclose") &&
				document.getElementById("btncekantriclose").focus();
		},350)
	},[uCekantrianshow])
	React.useEffect(()=>{ 
		setCekantrianObj({
			antrian_arr: [],
		})
	},[uCekantrianObj.tgl_antri,uCekantrianObj.id_cabang])
	React.useEffect(()=>{
		if(!uISReloadodontogram) return;

		setReloadodontogram(false);
	},[uISReloadodontogram])
	//---END EFFECT--/

	//console.log("(Periksa) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		{contentFloatantrian()}
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-3 p-0 m-0" id="idheadermain">
		<CContainer fluid className="classheadertop m-0" style={{minHeight:64}}>
			<CHeaderToggler className="px-0"
				onClick={() => hdlKlikBack()}>
			<CIcon icon="cilArrowCircleLeft" className="align-middle me-2" height={30}/>
			</CHeaderToggler>
			
			<CHeaderBrand className="me-auto">
				{contentHeadermain()}
			</CHeaderBrand>
			
			<CHeaderNav className="align-items-center">
				<CTooltip className="d-none d-lg-block" content="--Reset Form Billing">
					<CLink className="classikon classikonreset classcursorpointer me-2"
						onClick={()=>hdlKlikReset()}/>
				</CTooltip>
				<MyHeaderProfile isWithLogout={false} {...props}/>
			</CHeaderNav>
		</CContainer>

		<CContainer fluid className="bg-white p-2 px-3 pb-md-0 d-block" style={{minHeight:52}}>
			{contentHeadersub()}
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-2 px-lg-5 mb-1">
		<CContainer fluid className="px-0">
		{(uHeaderloading) ? (
			<div className="text-center text-primary classblinking m-3">
				<big>&middot;&middot;&middot;</big>
			</div>
		) : (
		<>
		{(uHtml500msg) ? (<>{contentPage500()}</>) : (
			<CForm>
			<div className="d-none">{JSON.stringify(uCabanginitObj)}</div>
			{(!uISCellphonemode) ? (
			<div ref={contentRef}>
				<section id="iddataperiksa" style={uStylesection}>
				<h1 className="text-primary p-2 px-3 rounded-3" 
					style={{fontSize:20,backgroundColor:"#2984D144"}}>
					1. Informasi Billing
				</h1>

				<CRow className="align-items-stretch">
					<CCol md={(!uISAdmininit ? "5" : "3")} className="mb-3" 
						style={{minHeight:(!uISCellphonemode && !uISTabletmode) ? 100 : "auto"}}>{contentTglPeriksa()}</CCol>
					
					{uISAdmininit && (
						<CCol md="4" className="mb-3">{contentDokter()}</CCol>
					)}

					<CCol md={(!uISAdmininit ? "7" : "5")} className="mb-3">{contentPerawat()}</CCol>
				</CRow>
				</section>
				
				<section id="iddatasoa" className="mt-3" style={uStylesection}>
				<h1 className="text-primary p-2 px-3 rounded-3" 
					style={{fontSize:20,backgroundColor:"#2984D144"}}>
					2. Data S.O.A
				</h1>

				<CRow className="align-items-stretch">
					<CCol md="4" className="mb-3">{contentSubjective()}</CCol>
					<CCol md="4" className="mb-3">{contentObjective()}</CCol>
					<CCol md="4" className="mb-3">{contentAssessment()}</CCol>
				</CRow>
				</section>
				
				<section id="iddataplan" className="mt-3" style={uStylesection}>
				<h1 className="text-primary p-2 px-3 rounded-3 mt-3" 
					style={{fontSize:20,backgroundColor:"#2984D144"}}>
					3. PLAN dan Terapi
				</h1>

				<CCard className="classbgcard mb-4">
					<CCardHeader className="py-2 py-lg-0 pt-lg-1 classfontsmaller">
						{contentPlanheader()} 
					</CCardHeader>

					<CCardBody className="px-0">
					{isMobile ? contentPlanitemmobile() : contentPlanitemdesktop()}
					</CCardBody>
				</CCard>
				</section>
				
				<section id="iddataodontogram" className="mt-3" style={uStylesection}>
				<h1 className="text-primary p-2 px-3 rounded-3 mt-3" 
					style={{fontSize:20,backgroundColor:"#2984D144"}}>
					4. Odontogram
				</h1>

				<MyCardodontogram pasienID={uPasienID}
					triggerReload={uISReloadodontogram}
					{...props}/>
				</section>

				<section id="iddataresep" className="mt-3" style={uStylesection}>
				<h1 className="text-primary p-2 px-3 rounded-3 mt-4" 
					style={{fontSize:20,backgroundColor:"#2984D144"}}>
					5. Peresepan Obat
				</h1>

				<CCard className="classbgcard mb-4">
					<CCardHeader className="py-2 py-lg-0 pt-lg-1 classfontsmaller">
					{isMobile ? (
						<CButton size="sm" color="secondary"
							className="text-white mb-lg-1"
							onClick={()=>hdlKlikResepformtambahmobile()}
							id="btnformreseptambahmobile">
						<CIcon icon="cibAddthis" className="me-1 align-middle"/>
						<small>Tambah Resep Obat</small>
						</CButton>
					) : (
						<>Medication Request</>
					)}
					</CCardHeader>
				
					<CCardBody className="px-0">
					{contentResepform()}
					{contentReseptabel()}
					</CCardBody>
				</CCard>
				</section>

				<section id="iddataakhir" className="mt-3" style={uStylesection}>
				<h1 className="text-primary p-2 px-3 rounded-3 mt-4" 
					style={{fontSize:20,backgroundColor:"#2984D144"}}>
					6. Catatan dan Reservasi
				</h1>

				<CRow className="align-items-stretch">
				<CCol md="6" className="mb-3">{contentNote()}</CCol>

				<CCol className="mb-3">
					{uTokenObj.userhak === "DOKTER" && (<>{contentReservasidokter()}</>)}
				</CCol>
				</CRow>
				</section>

			</div>
			) : (
			<>
				<div className="d-md-none">{contentFormheadermobile()}</div>

				<CRow className="align-items-stretch">
					<CCol xs="12" className="mb-3">{contentPerawat()}</CCol>
					<CCol xs="12" className="mb-3">{contentSubjective()}</CCol>
					<CCol xs="12" className="mb-3">{contentObjective()}</CCol>
					<CCol xs="12" className="mb-3">{contentAssessment()}</CCol>
				</CRow>

				<CCard className="classbgcard mb-3">
					<CCardHeader className="py-2 py-lg-0 pt-lg-1 classfontsmaller">
						{contentPlanheader()} 
					</CCardHeader>

					<CCardBody className="px-0">
						{contentPlanitemmobile()}
					</CCardBody>
				</CCard>

				<CCard className="classbgcard mb-3">
					<CCardHeader className="py-2 py-lg-0 pt-lg-1 classfontsmaller">
						<CButton size="sm" color="secondary"
							className="text-white"
							onClick={()=>hdlKlikResepformtambahmobile()}
							id="btnformreseptambahmobile">
						<CIcon icon="cibAddthis" className="me-1 align-middle"/>
						<small>Tambah Resep Obat</small>
						</CButton>						
					</CCardHeader>
				
					<CCardBody className="px-0">
					{contentReseptabel()}
					</CCardBody>
				</CCard>

				<CRow className="align-items-stretch">
					<CCol xs="12" className="mb-3">{contentNote()}</CCol>

					{uTokenObj.userhak === "DOKTER" && (
					<CCol className="mb-3">{contentReservasidokter()}</CCol>
					)}
				</CRow>
			</>
			)}
			</CForm>
		)}
		</>
		)}
		</CContainer>
		</div>

		<CFooter position="sticky" className="px-3 text-black-50 justify-content-center" 
			style={{backgroundColor:"#AEAEAE",borderTop:"1px dashed #f0f0f0"}}
			id="idfootermain">
		<MyButton
			onClick={()=>hdlKlikSimpanmain()}
			disabled={uHeaderloading||uHtml500msg||uIsDlgviewshow||uIsDlgformshow||uISDlglookupshow}
			id="btnSimpanmain">{uBahasaObj.word_simpan||"Simpan"} [F9]</MyButton>
		</CFooter>
		</div>

		<div className="classtooltipcheck text-danger fw-bold" id="iddiagramchecked">
		<CIcon icon="cilCheckCircle" height={20}/>
		</div>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>hdlToggleDlgLookup()}
			dialogHeader={uDlglookupObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupObj.dlg_input}
			dataItemArr={uDlglookupObj.data_arr || []} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>

		<MyDialoglookupapi
			show={uISDlglookupapishow}
			toggle={()=>setDlglookupapishow(false)}
			dialogHeader={uDlglookupapiObj.dlg_header||""}
			inputValue={uDlglookupapiObj.dlg_keyword}
			onKlikPilihItem={hdlKlikPilihLookupapi}
			targetApi={uDlglookupapiObj.dlg_targetapi||""} 
			kdownTrigger={uDlglookupapiObj.dlg_trigger}
			id="iddialoglookupapi"
			{...props}/>

		<MyDialogformsubjective
			showDlg={uISDlgformsubjectiveshow}
			toggleShow={()=>setDlgformsubjectiveshow(false)}
			{...props}/>

		<MyDialogview
			options={{centered:true,size:"xl"}}
			show={uIsDlgviewshow} 
			dialogHeader={uDlgviewheader}
			toggle={hdlToggleDlgview}
			renderContent={contentDlgview()}/>

		<MyDialogform
			options={{centered:uDlgformdataObj.dlg_center,size:uDlgformdataObj.dlg_size}}
			onSimpan={()=>hdlKlikDlgformsimpan()}
			show={uIsDlgformshow} 
			dialogHeader={uDlgformdataObj.dlg_header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>

		<MyDialogformobjective
			showDlg={uISDlgformobjectiveshow}
			toggleShow={()=>setDlgformobjectiveshow(false)}
			{...props}/>

		<MyDialognomorgigi
			showDlg={uISDlgnomorgigishow} 
			toggleShow={()=>setDlgnomorgigishow(false)}
			dataSelectedArr={uDlgnomorgigiObj.nomorgigi_arr || []} 
			onKlikpilih={hdlKlikpilihgigi}
			isUpdated={uDlgnomorgigiObj.is_updated}
			{...props}/>

		<MySessionextender active={true} {...props}/>
		</>
	)//>
}	

export default Periksa